var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebDevelop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 766.45 611.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#a0c8ea;}.cls-10,.cls-12,.cls-2{mix-blend-mode:multiply;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:url(#linear-gradient-4);}.cls-7{fill:url(#linear-gradient-5);}.cls-8{fill:url(#linear-gradient-6);}.cls-9{fill:url(#linear-gradient-7);}.cls-10,.cls-12{fill:#b7d1ea;}.cls-10{opacity:0.51;}.cls-11,.cls-155{fill:#58ffff;}.cls-13{fill:url(#linear-gradient-8);}.cls-14{fill:url(#linear-gradient-9);}.cls-15{fill:url(#linear-gradient-10);}.cls-16{fill:url(#linear-gradient-11);}.cls-17{fill:url(#linear-gradient-12);}.cls-18{fill:url(#linear-gradient-13);}.cls-19{fill:url(#linear-gradient-14);}.cls-20{fill:url(#linear-gradient-15);}.cls-21{fill:url(#linear-gradient-16);}.cls-22{fill:url(#linear-gradient-17);}.cls-23{fill:url(#linear-gradient-18);}.cls-24{fill:url(#linear-gradient-19);}.cls-25{fill:url(#linear-gradient-20);}.cls-26{fill:url(#linear-gradient-21);}.cls-27{fill:url(#linear-gradient-22);}.cls-28,.cls-29,.cls-30,.cls-31{fill:#dc2dd0;}.cls-29{opacity:0.59;}.cls-30{opacity:0.36;}.cls-31{opacity:0.26;}.cls-162,.cls-222,.cls-32,.cls-46{fill:#180f46;}.cls-32{opacity:0.62;mix-blend-mode:soft-light;}.cls-33{fill:url(#linear-gradient-23);}.cls-34{fill:url(#linear-gradient-24);}.cls-35{fill:url(#linear-gradient-25);}.cls-36{fill:url(#linear-gradient-26);}.cls-37{fill:url(#linear-gradient-27);}.cls-38{fill:url(#linear-gradient-28);}.cls-39{fill:url(#linear-gradient-29);}.cls-40{fill:url(#linear-gradient-30);}.cls-41{fill:url(#linear-gradient-31);}.cls-42{fill:url(#linear-gradient-32);}.cls-43{fill:url(#linear-gradient-33);}.cls-44{fill:url(#linear-gradient-34);}.cls-45{fill:url(#linear-gradient-35);}.cls-46{opacity:0.16;}.cls-160,.cls-161,.cls-222,.cls-46{mix-blend-mode:overlay;}.cls-47{fill:url(#linear-gradient-36);}.cls-48{fill:url(#linear-gradient-37);}.cls-49{fill:url(#linear-gradient-38);}.cls-50{fill:url(#linear-gradient-39);}.cls-51{fill:url(#linear-gradient-40);}.cls-52{fill:url(#linear-gradient-41);}.cls-53{fill:url(#linear-gradient-42);}.cls-54{fill:url(#linear-gradient-43);}.cls-55{fill:url(#linear-gradient-44);}.cls-56{fill:url(#linear-gradient-45);}.cls-57{fill:url(#linear-gradient-46);}.cls-58{fill:url(#linear-gradient-47);}.cls-59{fill:url(#linear-gradient-48);}.cls-60{fill:url(#linear-gradient-49);}.cls-61{fill:url(#linear-gradient-50);}.cls-62{fill:url(#linear-gradient-51);}.cls-63{fill:url(#linear-gradient-52);}.cls-64{fill:url(#linear-gradient-53);}.cls-65{fill:url(#linear-gradient-54);}.cls-66{fill:url(#linear-gradient-55);}.cls-67{fill:url(#linear-gradient-56);}.cls-68{fill:url(#linear-gradient-58);}.cls-69{opacity:0.79;}.cls-70{fill:url(#linear-gradient-59);}.cls-71{fill:url(#linear-gradient-60);}.cls-72{fill:url(#linear-gradient-61);}.cls-73{fill:url(#linear-gradient-62);}.cls-74{fill:url(#linear-gradient-63);}.cls-75{fill:url(#linear-gradient-64);}.cls-76{fill:url(#linear-gradient-65);}.cls-77{fill:url(#linear-gradient-66);}.cls-78{fill:url(#linear-gradient-67);}.cls-79{fill:url(#linear-gradient-68);}.cls-80{fill:url(#linear-gradient-69);}.cls-81{fill:url(#linear-gradient-70);}.cls-82{fill:url(#linear-gradient-71);}.cls-83{fill:url(#linear-gradient-72);}.cls-84{fill:url(#linear-gradient-73);}.cls-85{fill:url(#linear-gradient-74);}.cls-86{fill:url(#linear-gradient-75);}.cls-87{fill:url(#linear-gradient-76);}.cls-88{fill:url(#linear-gradient-77);}.cls-89{fill:url(#linear-gradient-78);}.cls-90{fill:url(#linear-gradient-79);}.cls-91{fill:url(#linear-gradient-80);}.cls-92{fill:url(#linear-gradient-81);}.cls-93{fill:url(#linear-gradient-82);}.cls-94{fill:url(#linear-gradient-83);}.cls-204,.cls-263,.cls-95{opacity:0.25;}.cls-95{fill:url(#linear-gradient-84);}.cls-96{fill:url(#linear-gradient-85);}.cls-97{fill:url(#linear-gradient-86);}.cls-98{fill:url(#linear-gradient-87);}.cls-99{fill:url(#linear-gradient-88);}.cls-100{fill:url(#linear-gradient-89);}.cls-101{fill:url(#linear-gradient-90);}.cls-102{fill:url(#linear-gradient-91);}.cls-103{fill:url(#linear-gradient-92);}.cls-104{fill:url(#linear-gradient-93);}.cls-105{fill:url(#linear-gradient-94);}.cls-106{fill:url(#linear-gradient-95);}.cls-107{fill:url(#linear-gradient-96);}.cls-108{fill:url(#linear-gradient-97);}.cls-109{fill:url(#linear-gradient-98);}.cls-110{fill:url(#linear-gradient-99);}.cls-111{fill:url(#linear-gradient-100);}.cls-112{fill:url(#linear-gradient-101);}.cls-113{fill:url(#linear-gradient-102);}.cls-114{fill:url(#linear-gradient-103);}.cls-115{fill:url(#linear-gradient-104);}.cls-116{fill:url(#linear-gradient-105);}.cls-117{fill:url(#linear-gradient-106);}.cls-118{fill:url(#linear-gradient-107);}.cls-119{fill:#d14f49;}.cls-120{fill:url(#linear-gradient-108);}.cls-121{fill:url(#linear-gradient-109);}.cls-122{fill:url(#linear-gradient-110);}.cls-123{fill:url(#linear-gradient-111);}.cls-124{fill:url(#linear-gradient-112);}.cls-125{fill:url(#linear-gradient-113);}.cls-126{fill:url(#linear-gradient-114);}.cls-127{fill:url(#linear-gradient-115);}.cls-128{fill:url(#linear-gradient-116);}.cls-129{fill:url(#linear-gradient-117);}.cls-130{fill:url(#linear-gradient-118);}.cls-131{fill:url(#linear-gradient-119);}.cls-132{fill:url(#linear-gradient-120);}.cls-133{fill:url(#linear-gradient-121);}.cls-134{fill:url(#linear-gradient-122);}.cls-135{fill:url(#linear-gradient-123);}.cls-136{fill:url(#linear-gradient-124);}.cls-137{fill:url(#linear-gradient-125);}.cls-138{fill:url(#linear-gradient-126);}.cls-139{fill:url(#linear-gradient-127);}.cls-140{fill:url(#linear-gradient-128);}.cls-141{fill:url(#linear-gradient-129);}.cls-142{fill:url(#linear-gradient-130);}.cls-143{fill:url(#linear-gradient-131);}.cls-144{fill:url(#linear-gradient-132);}.cls-145{fill:url(#linear-gradient-133);}.cls-146{fill:url(#linear-gradient-134);}.cls-147{fill:url(#linear-gradient-135);}.cls-148{fill:url(#linear-gradient-136);}.cls-149{fill:url(#linear-gradient-137);}.cls-150{fill:#0e1e75;}.cls-151{fill:url(#linear-gradient-138);}.cls-152{fill:url(#linear-gradient-139);}.cls-153{fill:url(#linear-gradient-140);}.cls-154{fill:url(#linear-gradient-141);}.cls-155{opacity:0.33;}.cls-156{fill:url(#linear-gradient-142);}.cls-157{fill:url(#linear-gradient-143);}.cls-158{fill:url(#linear-gradient-144);}.cls-159{fill:url(#linear-gradient-145);}.cls-160{opacity:0.53;}.cls-161,.cls-222{opacity:0.4;}.cls-163{fill:url(#linear-gradient-146);}.cls-164{fill:url(#linear-gradient-147);}.cls-165{fill:url(#linear-gradient-148);}.cls-166{fill:url(#linear-gradient-149);}.cls-167{fill:url(#linear-gradient-150);}.cls-168{fill:url(#linear-gradient-151);}.cls-169{fill:url(#linear-gradient-152);}.cls-170{fill:url(#linear-gradient-153);}.cls-171{fill:url(#linear-gradient-154);}.cls-172{fill:url(#linear-gradient-155);}.cls-173{fill:url(#linear-gradient-156);}.cls-174{fill:url(#linear-gradient-157);}.cls-175{fill:url(#linear-gradient-158);}.cls-176{fill:url(#linear-gradient-159);}.cls-177{fill:url(#linear-gradient-160);}.cls-178{fill:url(#linear-gradient-161);}.cls-179{fill:url(#linear-gradient-162);}.cls-180{fill:url(#linear-gradient-163);}.cls-181{fill:url(#linear-gradient-164);}.cls-182{fill:url(#linear-gradient-165);}.cls-183{fill:url(#linear-gradient-166);}.cls-184{fill:url(#linear-gradient-167);}.cls-185{fill:url(#linear-gradient-168);}.cls-186{fill:url(#linear-gradient-169);}.cls-187{fill:url(#linear-gradient-170);}.cls-188{fill:url(#linear-gradient-171);}.cls-189{fill:url(#linear-gradient-172);}.cls-190{fill:url(#linear-gradient-173);}.cls-191{fill:url(#linear-gradient-174);}.cls-192{fill:url(#linear-gradient-175);}.cls-193{fill:url(#linear-gradient-176);}.cls-194{fill:url(#linear-gradient-177);}.cls-195{fill:url(#linear-gradient-178);}.cls-196{fill:url(#linear-gradient-179);}.cls-197{fill:url(#linear-gradient-180);}.cls-198{fill:url(#linear-gradient-181);}.cls-199{fill:url(#linear-gradient-182);}.cls-200{fill:url(#linear-gradient-183);}.cls-201{fill:url(#linear-gradient-184);}.cls-202{fill:url(#linear-gradient-185);}.cls-203{fill:url(#linear-gradient-186);}.cls-204{fill:url(#linear-gradient-187);}.cls-205{fill:url(#linear-gradient-188);}.cls-206{fill:url(#linear-gradient-189);}.cls-207{fill:url(#linear-gradient-190);}.cls-208{fill:url(#linear-gradient-191);}.cls-209{fill:url(#linear-gradient-192);}.cls-210{fill:url(#linear-gradient-193);}.cls-211{fill:url(#linear-gradient-194);}.cls-212{fill:url(#linear-gradient-195);}.cls-213{fill:url(#linear-gradient-196);}.cls-214{fill:url(#linear-gradient-197);}.cls-215{fill:url(#linear-gradient-198);}.cls-216{fill:url(#linear-gradient-199);}.cls-217{fill:url(#linear-gradient-200);}.cls-218{fill:url(#linear-gradient-201);}.cls-219{fill:url(#linear-gradient-202);}.cls-220{fill:url(#linear-gradient-203);}.cls-221{fill:url(#linear-gradient-204);}.cls-223{fill:url(#linear-gradient-205);}.cls-224{fill:url(#linear-gradient-206);}.cls-225{fill:url(#linear-gradient-207);}.cls-226{fill:url(#linear-gradient-208);}.cls-227{fill:url(#linear-gradient-209);}.cls-228{fill:url(#linear-gradient-210);}.cls-229{fill:url(#linear-gradient-211);}.cls-230{fill:url(#linear-gradient-212);}.cls-231{fill:url(#linear-gradient-213);}.cls-232{fill:url(#linear-gradient-214);}.cls-233{fill:url(#linear-gradient-215);}.cls-234{fill:url(#linear-gradient-216);}.cls-235{fill:url(#linear-gradient-217);}.cls-236{fill:url(#linear-gradient-218);}.cls-237{fill:url(#linear-gradient-219);}.cls-238{fill:url(#linear-gradient-220);}.cls-239{fill:url(#linear-gradient-221);}.cls-240{fill:url(#linear-gradient-222);}.cls-241{fill:url(#linear-gradient-223);}.cls-242{fill:url(#linear-gradient-224);}.cls-243{fill:url(#linear-gradient-225);}.cls-244{fill:url(#linear-gradient-226);}.cls-245{fill:url(#linear-gradient-227);}.cls-246{fill:url(#linear-gradient-228);}.cls-247{fill:url(#linear-gradient-229);}.cls-248{fill:url(#linear-gradient-230);}.cls-249{fill:url(#linear-gradient-231);}.cls-250{fill:url(#linear-gradient-232);}.cls-251{fill:url(#linear-gradient-233);}.cls-252{fill:url(#linear-gradient-234);}.cls-253{fill:url(#linear-gradient-235);}.cls-254{fill:url(#linear-gradient-236);}.cls-255{fill:url(#linear-gradient-237);}.cls-256{fill:url(#linear-gradient-238);}.cls-257{fill:url(#linear-gradient-239);}.cls-258{fill:url(#linear-gradient-240);}.cls-259{fill:url(#linear-gradient-241);}.cls-260{fill:url(#linear-gradient-242);}.cls-261{fill:url(#linear-gradient-243);}.cls-262{fill:url(#linear-gradient-244);}.cls-263{fill:url(#linear-gradient-245);}.cls-264{fill:url(#linear-gradient-246);}.cls-265{fill:url(#linear-gradient-247);}.cls-266{fill:url(#linear-gradient-248);}.cls-267{fill:url(#linear-gradient-249);}.cls-268{fill:url(#linear-gradient-250);}.cls-269{fill:url(#linear-gradient-251);}.cls-270{fill:url(#linear-gradient-252);}.cls-271{fill:url(#linear-gradient-253);}.cls-272{fill:url(#linear-gradient-254);}.cls-273{fill:url(#linear-gradient-255);}.cls-274{fill:url(#linear-gradient-256);}.cls-275{fill:url(#linear-gradient-257);}.cls-276{fill:url(#linear-gradient-258);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 518.75,
    y1: 109.1,
    x2: 599.78,
    y2: 109.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a1ba5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b4af3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 550.63,
    y1: 124.35,
    x2: 668.98,
    y2: -18.8,
    gradientTransform: "translate(373.85 -430.37) rotate(59.69)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#31b2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a54d3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 524.55,
    y1: 110.83,
    x2: 599.41,
    y2: 110.83,
    gradientTransform: "translate(374.03 -430.26) rotate(59.69)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e42ed3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b0d99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 550.64,
    y1: 124.36,
    x2: 668.99,
    y2: -18.79,
    gradientTransform: "translate(374.06 -429.87) rotate(59.69)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 541.44,
    y1: 110.84,
    x2: 582.48,
    y2: 110.84,
    gradientTransform: "translate(374.03 -430.24) rotate(59.69)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 550.67,
    y1: 124.39,
    x2: 669.03,
    y2: -18.76,
    gradientTransform: "translate(374.05 -430.02) rotate(59.69)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 557.02,
    y1: 110.84,
    x2: 566.9,
    y2: 110.84,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -78.94,
    y1: -545.14,
    x2: -52.78,
    y2: -545.14,
    gradientTransform: "matrix(0.97, -0.26, 0.26, 0.97, 401.14, 712.69)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f79d53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -89.37,
    y1: -529.51,
    x2: -61.78,
    y2: -569.25,
    gradientTransform: "matrix(0.97, -0.26, 0.26, 0.97, 401.14, 712.69)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#48caff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c3f3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 172.52,
    y1: 215.23,
    x2: 188.66,
    y2: 215.23,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 174.05,
    y1: 223.38,
    x2: 200.12,
    y2: 185.84,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 221.53,
    y1: 262.52,
    x2: 180.8,
    y2: 224.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#49dccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3ca3ba"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 193.1,
    y1: 191.92,
    x2: 146.81,
    y2: 237.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b514be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#651879"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 174.91,
    y1: 200.89,
    x2: 185.1,
    y2: 184.75,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 180.28,
    y1: 163.08,
    x2: 173.65,
    y2: 173.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d1b84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#190f4a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -1192.55,
    y1: 168.45,
    x2: -1184.49,
    y2: 180.63,
    gradientTransform: "translate(1371.46)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -1179.39,
    y1: 188.99,
    x2: -1186.07,
    y2: 178.34,
    gradientTransform: "translate(1371.46)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 164.46,
    y1: 224.75,
    x2: 191.67,
    y2: 185.56,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 171.32,
    y1: 206.96,
    x2: 197.47,
    y2: 206.96,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 161.31,
    y1: 222.56,
    x2: 188.52,
    y2: 183.38,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 165.14,
    y1: 223.51,
    x2: 178.9,
    y2: 199.8,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 165.35,
    y1: 223.63,
    x2: 179.11,
    y2: 199.92,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 320.2,
    y1: 418.81,
    x2: 217.85,
    y2: 400.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#821dc5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#320d7f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 317.99,
    y1: 431.33,
    x2: 215.64,
    y2: 413.25,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 311.04,
    y1: 461.68,
    x2: 144.84,
    y2: 318.96,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 308.7,
    y1: 527.69,
    x2: 232.17,
    y2: 382.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c93bde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4615a5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 249.01,
    y1: 398.09,
    x2: 304.18,
    y2: 471.56,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 200.63,
    y1: 209,
    x2: 353.21,
    y2: 446.09,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 270.93,
    y1: 454.26,
    x2: 216.47,
    y2: -21.8,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 187.55,
    y1: 92.19,
    x2: 278.3,
    y2: 350.11,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 249.41,
    y1: 172.46,
    x2: 265.18,
    y2: 652.44,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 223.58,
    y1: 130.96,
    x2: 269.13,
    y2: 352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#42b2f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a54d3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 249.8,
    y1: 285.32,
    x2: 444.17,
    y2: 516.3,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 225.07,
    y1: 269.69,
    x2: 305.05,
    y2: 512.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cd2eb9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b0d99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 200.29,
    y1: 87.08,
    x2: 275.41,
    y2: 251.87,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 387.05,
    y1: 237.3,
    x2: 518.37,
    y2: 521.9,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 371.35,
    y1: 244.55,
    x2: 502.66,
    y2: 529.15,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 336.67,
    y1: 260.55,
    x2: 467.99,
    y2: 545.15,
    gradientTransform: "translate(575.36 -144.68) rotate(60)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 393.63,
    y1: 234.26,
    x2: 524.95,
    y2: 518.87,
    gradientTransform: "translate(445.67 -219.56) rotate(60)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 413.57,
    y1: 225.06,
    x2: 544.89,
    y2: 509.67,
    gradientTransform: "translate(568.96 -230.32) rotate(60)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 414.5,
    y1: 224.64,
    x2: 545.82,
    y2: 509.24,
    gradientTransform: "translate(558.11 -232.34) rotate(60)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 415.5,
    y1: 224.17,
    x2: 546.82,
    y2: 508.78,
    gradientTransform: "translate(547.57 -234.41) rotate(60)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 416.39,
    y1: 223.76,
    x2: 547.71,
    y2: 508.37,
    gradientTransform: "translate(537.09 -236.35) rotate(60)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 417.32,
    y1: 223.33,
    x2: 548.64,
    y2: 507.94,
    gradientTransform: "translate(526.24 -238.37) rotate(60)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 418.32,
    y1: 222.87,
    x2: 549.64,
    y2: 507.48,
    gradientTransform: "translate(515.7 -240.44) rotate(60)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 419.33,
    y1: 222.41,
    x2: 550.65,
    y2: 507.01,
    gradientTransform: "translate(505.07 -242.54) rotate(60)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 420.3,
    y1: 221.96,
    x2: 551.62,
    y2: 506.56,
    gradientTransform: "translate(494.42 -244.58) rotate(60)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 421.37,
    y1: 221.46,
    x2: 552.69,
    y2: 506.07,
    gradientTransform: "translate(483.74 -246.75) rotate(60)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 422.28,
    y1: 221.05,
    x2: 553.6,
    y2: 505.65,
    gradientTransform: "translate(473.57 -248.68) rotate(60)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 423.31,
    y1: 220.57,
    x2: 554.63,
    y2: 505.17,
    gradientTransform: "translate(462.68 -250.82) rotate(60)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 424.29,
    y1: 220.12,
    x2: 555.6,
    y2: 504.72,
    gradientTransform: "translate(452.09 -252.86) rotate(60)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 425.26,
    y1: 219.67,
    x2: 556.58,
    y2: 504.27,
    gradientTransform: "translate(441.63 -254.9) rotate(60)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 412.47,
    y1: 225.57,
    x2: 543.78,
    y2: 510.18,
    gradientTransform: "translate(579.17 -228.16) rotate(60)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 450.57,
    y1: 262.26,
    x2: 400.33,
    y2: 246.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#56abff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#66b6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#9dddff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#bff6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 395.39,
    y1: 250.05,
    x2: 469.47,
    y2: 258.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#48caff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#46c0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#40a7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#377dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2d51ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: -4856.03,
    y1: -1716.31,
    x2: -4846.62,
    y2: -1716.31,
    gradientTransform: "translate(-3205.15 -3480.22) rotate(-153.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#e8874e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b10043"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 306.95,
    y1: 347.75,
    x2: 326.76,
    y2: 347.75,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: -5575.89,
    y1: 716.94,
    x2: -5409.16,
    y2: 810.93,
    gradientTransform: "matrix(-0.98, 0.22, 0.22, 0.98, -5199.18, 744.27)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#48caff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#46c1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#3985ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#305fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2d51ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: -5467.72,
    y1: 735.13,
    x2: -5586.17,
    y2: 658.78,
    gradientTransform: "matrix(-0.98, 0.22, 0.22, 0.98, -5199.18, 744.27)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: -5424.79,
    y1: 756.14,
    x2: -5495.5,
    y2: 778.51,
    gradientTransform: "matrix(-0.98, 0.22, 0.22, 0.98, -5199.18, 744.27)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#48caff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#40a5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#3678ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#2f5bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2d51ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 34.88,
    y1: 785.92,
    x2: -33.05,
    y2: 611.38,
    gradientTransform: "matrix(0.98, -0.22, 0.22, 0.98, 200.46, -444.76)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: -5532.15,
    y1: 789.24,
    x2: -5529.87,
    y2: 712.12,
    gradientTransform: "matrix(-0.98, 0.22, 0.22, 0.98, -5199.18, 744.27)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#56abff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#52b3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#4bc4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#48caff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: -5474.79,
    y1: 724.58,
    x2: -5477.51,
    y2: 726.3,
    gradientTransform: "matrix(-0.98, 0.22, 0.22, 0.98, -5199.18, 744.27)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#48caff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 249,
    y1: 1795.37,
    x2: 243.27,
    y2: 1780.65,
    gradientTransform: "matrix(0.74, -0.67, 0.25, 1.13, -311.42, -1574.96)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 253.76,
    y1: 1795.37,
    x2: 248.03,
    y2: 1780.65,
    gradientTransform: "matrix(0.74, -0.67, 0.25, 1.13, -311.42, -1574.96)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 258.51,
    y1: 1795.37,
    x2: 252.78,
    y2: 1780.65,
    gradientTransform: "matrix(0.74, -0.67, 0.25, 1.13, -311.42, -1574.96)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: -5563.18,
    y1: 712.22,
    x2: -5463.8,
    y2: 768.24,
    xlinkHref: "#linear-gradient-59"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: -5478.23,
    y1: 748.13,
    x2: -5577.74,
    y2: 683.99,
    gradientTransform: "matrix(-0.98, 0.22, 0.22, 0.98, -5199.18, 744.27)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: -5466.04,
    y1: 748.88,
    x2: -5493.01,
    y2: 757.41,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 29.14,
    y1: 729.92,
    x2: -13.23,
    y2: 705.46,
    gradientTransform: "matrix(0.98, -0.22, 0.22, 0.98, 200.46, -444.76)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 52.89,
    y1: 738.18,
    x2: -69.55,
    y2: 807.5,
    gradientTransform: "matrix(0.98, -0.22, 0.22, 0.98, 200.46, -444.76)",
    xlinkHref: "#linear-gradient-59"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: -44.8,
    y1: 777.64,
    x2: 74.57,
    y2: 706.34,
    gradientTransform: "matrix(0.98, -0.22, 0.22, 0.98, 200.46, -444.76)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: -5465.9,
    y1: 785.28,
    x2: -5493.07,
    y2: 793.88,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: -43.09,
    y1: 776.3,
    x2: 47.01,
    y2: 724.4,
    gradientTransform: "matrix(0.98, -0.22, 0.22, 0.98, 200.46, -444.76)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 52.73,
    y1: 737.9,
    x2: -69.71,
    y2: 807.22,
    gradientTransform: "matrix(0.98, -0.22, 0.22, 0.98, 200.46, -444.76)",
    xlinkHref: "#linear-gradient-59"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: -44.54,
    y1: 778.08,
    x2: 74.83,
    y2: 706.78,
    gradientTransform: "matrix(0.98, -0.22, 0.22, 0.98, 200.46, -444.76)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: -5496.96,
    y1: 767.33,
    x2: -5524.12,
    y2: 775.92,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: -43.12,
    y1: 776.25,
    x2: 46.98,
    y2: 724.35,
    gradientTransform: "matrix(0.98, -0.22, 0.22, 0.98, 200.46, -444.76)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 52.64,
    y1: 737.74,
    x2: -69.8,
    y2: 807.06,
    gradientTransform: "matrix(0.98, -0.22, 0.22, 0.98, 200.46, -444.76)",
    xlinkHref: "#linear-gradient-59"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: -44.21,
    y1: 778.64,
    x2: 75.16,
    y2: 707.34,
    gradientTransform: "matrix(0.98, -0.22, 0.22, 0.98, 200.46, -444.76)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: -5528.01,
    y1: 749.54,
    x2: -5555.18,
    y2: 758.14,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: -43.08,
    y1: 776.33,
    x2: 47.03,
    y2: 724.43,
    gradientTransform: "matrix(0.98, -0.22, 0.22, 0.98, 200.46, -444.76)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: -2534.59,
    y1: 841.75,
    x2: -2521.79,
    y2: 865.59,
    gradientTransform: "matrix(1, -0.09, 0.67, 0.94, 2268.85, -580.45)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 315.57,
    y1: 444.65,
    x2: 315.47,
    y2: 453.39,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 307.74,
    y1: 423.22,
    x2: 320.5,
    y2: 423.22,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 312.71,
    y1: 424.2,
    x2: 330.11,
    y2: 424.2,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 310.05,
    y1: 449.79,
    x2: 323.06,
    y2: 455.45,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 303.51,
    y1: 379.9,
    x2: 317.99,
    y2: 361.88,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 313.21,
    y1: 355.84,
    x2: 323.47,
    y2: 355.84,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 309.79,
    y1: 379.41,
    x2: 325.44,
    y2: 430.05,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 306.18,
    y1: 381.3,
    x2: 320.12,
    y2: 363.94,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: -315.83,
    y1: 1157.03,
    x2: -332.94,
    y2: 1175.35,
    gradientTransform: "matrix(0.84, -0.55, 0.55, 0.84, -30.9, -799.76)",
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 352.44,
    y1: 341.41,
    x2: 312.87,
    y2: 383.78,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 297.85,
    y1: 359.64,
    x2: 322.22,
    y2: 359.64,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: -4342.45,
    y1: 378.3,
    x2: -4331.59,
    y2: 378.3,
    gradientTransform: "matrix(-1, 0.05, 0.05, 1, -3929.48, 101.49)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: -4340.9,
    y1: 359.81,
    x2: -4328.64,
    y2: 359.81,
    gradientTransform: "matrix(-1, 0.05, 0.05, 1, -3929.48, 101.49)",
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: -4346.05,
    y1: 380.32,
    x2: -4336.05,
    y2: 380.32,
    gradientTransform: "matrix(-1, 0.05, 0.05, 1, -3929.48, 101.49)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: -4359.47,
    y1: 381.2,
    x2: -4333.29,
    y2: 345.07,
    gradientTransform: "matrix(-1, 0.05, 0.05, 1, -3929.48, 101.49)",
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: -3431.76,
    y1: 1086.37,
    x2: -3467.29,
    y2: 1117.42,
    gradientTransform: "matrix(-0.89, 0.45, 0.45, 0.89, -3168.61, 765.06)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: -4340.4,
    y1: 346.34,
    x2: -4335.28,
    y2: 304.09,
    gradientTransform: "matrix(-1, 0.05, 0.05, 1, -3929.48, 101.49)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#3a80f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0e1e75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: -3431.54,
    y1: 1086.63,
    x2: -3467.06,
    y2: 1117.68,
    gradientTransform: "matrix(-0.89, 0.45, 0.45, 0.89, -3168.61, 765.06)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: -4508.16,
    y1: 3.88,
    x2: -4544.96,
    y2: 36.04,
    gradientTransform: "matrix(-1, -0.06, -0.06, 1, -4113.97, -116.33)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 303.99,
    y1: 314.11,
    x2: 319.25,
    y2: 327.22,
    gradientTransform: "matrix(1, -0.05, 0.05, 1, 69.3, -109.8)",
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: -3445.21,
    y1: 1072.63,
    x2: -3455.97,
    y2: 1090.23,
    gradientTransform: "matrix(-0.89, 0.45, 0.45, 0.89, -3168.61, 765.06)",
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 1829.83,
    y1: 1086.82,
    x2: 1842.06,
    y2: 1071.1,
    gradientTransform: "translate(-1728.19 31.19) rotate(-27.01)",
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 1827.37,
    y1: 1076.39,
    x2: 1842.24,
    y2: 1076.39,
    gradientTransform: "translate(-1728.19 31.19) rotate(-27.01)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: -5807.01,
    y1: 239.57,
    x2: -5491.41,
    y2: 417.49,
    gradientTransform: "matrix(-1, 0, 0, 1, -5528.88, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: -5779.35,
    y1: 262.83,
    x2: -5607.34,
    y2: 359.8,
    gradientTransform: "matrix(-1, 0, 0, 1, -5528.88, 0)",
    xlinkHref: "#linear-gradient-59"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: -5667.76,
    y1: 281.6,
    x2: -5789.95,
    y2: 202.84,
    gradientTransform: "matrix(-1, 0, 0, 1, -5528.88, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: -5623.48,
    y1: 303.27,
    x2: -5696.41,
    y2: 326.35,
    gradientTransform: "matrix(-1, 0, 0, 1, -5528.88, 0)",
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 238.03,
    y1: 334.25,
    x2: 167.96,
    y2: 154.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: -5734.22,
    y1: 337.42,
    x2: -5731.87,
    y2: 257.86,
    gradientTransform: "matrix(-1, 0, 0, 1, -5528.88, 0)",
    xlinkHref: "#linear-gradient-63"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: -5675.05,
    y1: 270.71,
    x2: -5677.85,
    y2: 272.49,
    gradientTransform: "matrix(-1, 0, 0, 1, -5528.88, 0)",
    xlinkHref: "#linear-gradient-64"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 481.26,
    y1: 1503.43,
    x2: 475.35,
    y2: 1488.24,
    gradientTransform: "matrix(0.87, -0.5, 0, 1.15, -257.13, -1213.85)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 486.16,
    y1: 1503.43,
    x2: 480.25,
    y2: 1488.24,
    gradientTransform: "matrix(0.87, -0.5, 0, 1.15, -257.13, -1213.85)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 491.06,
    y1: 1503.43,
    x2: 485.15,
    y2: 1488.24,
    gradientTransform: "matrix(0.87, -0.5, 0, 1.15, -257.13, -1213.85)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: -5766.23,
    y1: 257.96,
    x2: -5663.72,
    y2: 315.75,
    gradientTransform: "matrix(-1, 0, 0, 1, -5528.88, 0)",
    xlinkHref: "#linear-gradient-59"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: -5678.6,
    y1: 295.01,
    x2: -5781.25,
    y2: 228.84,
    gradientTransform: "matrix(-1, 0, 0, 1, -5528.88, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: -5666.02,
    y1: 295.78,
    x2: -5693.84,
    y2: 304.58,
    gradientTransform: "matrix(-1, 0, 0, 1, -5528.88, 0)",
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: -5678.13,
    y1: 291.58,
    x2: -5762.21,
    y2: 243.04,
    gradientTransform: "matrix(-1, 0, 0, 1, -5528.88, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 256.61,
    y1: 285.01,
    x2: 130.3,
    y2: 356.52,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-59"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 155.83,
    y1: 325.72,
    x2: 278.97,
    y2: 252.17,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: -5665.88,
    y1: 333.33,
    x2: -5693.9,
    y2: 342.2,
    gradientTransform: "matrix(-1, 0, 0, 1, -5528.88, 0)",
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 157.6,
    y1: 324.34,
    x2: 250.55,
    y2: 270.8,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 256.45,
    y1: 284.72,
    x2: 130.14,
    y2: 356.23,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-59"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 156.1,
    y1: 326.17,
    x2: 279.24,
    y2: 252.62,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: -5697.92,
    y1: 314.81,
    x2: -5725.94,
    y2: 323.68,
    gradientTransform: "matrix(-1, 0, 0, 1, -5528.88, 0)",
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 157.57,
    y1: 324.29,
    x2: 250.52,
    y2: 270.75,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 256.36,
    y1: 284.56,
    x2: 130.05,
    y2: 356.07,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-59"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 156.45,
    y1: 326.75,
    x2: 279.59,
    y2: 253.21,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: -5729.95,
    y1: 296.47,
    x2: -5757.98,
    y2: 305.33,
    gradientTransform: "matrix(-1, 0, 0, 1, -5528.88, 0)",
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 157.61,
    y1: 324.37,
    x2: 250.56,
    y2: 270.83,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: -4464.52,
    y1: 163.35,
    x2: -4635.08,
    y2: 259.92,
    gradientTransform: "matrix(-1, 0, 0, 1, -4020.11, 0)",
    xlinkHref: "#linear-gradient-59"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: -4599.43,
    y1: 220.32,
    x2: -4433.16,
    y2: 121.01,
    gradientTransform: "matrix(-1, 0, 0, 1, -4020.11, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: -989.71,
    y1: 179.43,
    x2: -1027.54,
    y2: 191.4,
    gradientTransform: "translate(1508.77)",
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: -4597.86,
    y1: 217.11,
    x2: -4472.35,
    y2: 144.81,
    gradientTransform: "matrix(-1, 0, 0, 1, -4020.11, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 937.92,
    y1: 326.37,
    x2: 767.36,
    y2: 422.93,
    gradientTransform: "translate(-805.6)",
    xlinkHref: "#linear-gradient-59"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 802.42,
    y1: 382.34,
    x2: 968.69,
    y2: 283.03,
    gradientTransform: "translate(-805.6)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: -6348.76,
    y1: 367,
    x2: -6386.6,
    y2: 378.97,
    gradientTransform: "matrix(-1, 0, 0, 1, -6334.47, 0)",
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 804.39,
    y1: 379.8,
    x2: 929.91,
    y2: 307.5,
    gradientTransform: "translate(-805.6)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 1526.64,
    y1: 111.73,
    x2: 1356.08,
    y2: 208.3,
    gradientTransform: "translate(-805.6)",
    xlinkHref: "#linear-gradient-59"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 1391.14,
    y1: 167.7,
    x2: 1557.41,
    y2: 68.39,
    gradientTransform: "translate(-805.6)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: -6937.49,
    y1: 152.37,
    x2: -6975.32,
    y2: 164.34,
    gradientTransform: "matrix(-1, 0, 0, 1, -6334.47, 0)",
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 1393.12,
    y1: 165.17,
    x2: 1518.63,
    y2: 92.87,
    gradientTransform: "translate(-805.6)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 670.85,
    y1: 205.95,
    x2: 674.84,
    y2: 294.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7519ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#230378"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 645.13,
    y1: 233.28,
    x2: 700.54,
    y2: 245.49,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 688.34,
    y1: 186.09,
    x2: 600.25,
    y2: 293.73,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: 570.81,
    y1: 302.64,
    x2: 706.09,
    y2: 184.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f43bde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4615a5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: 619.58,
    y1: 204.93,
    x2: 787.27,
    y2: 321.73,
    xlinkHref: "#linear-gradient-149"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: 645.95,
    y1: 236.32,
    x2: 649.19,
    y2: 308.58,
    xlinkHref: "#linear-gradient-146"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: 639.04,
    y1: 260.95,
    x2: 694.45,
    y2: 273.16,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: 689.11,
    y1: 186.73,
    x2: 601.02,
    y2: 294.36,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: 575.98,
    y1: 308.59,
    x2: 711.26,
    y2: 190.88,
    xlinkHref: "#linear-gradient-149"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: 600.35,
    y1: 232.55,
    x2: 768.04,
    y2: 349.34,
    xlinkHref: "#linear-gradient-149"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: 621.42,
    y1: 267.23,
    x2: 623.88,
    y2: 322.14,
    xlinkHref: "#linear-gradient-146"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: 632.91,
    y1: 288.77,
    x2: 688.32,
    y2: 300.98,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: 690.4,
    y1: 187.78,
    x2: 602.31,
    y2: 295.42,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: 581.61,
    y1: 315.06,
    x2: 716.9,
    y2: 197.35,
    xlinkHref: "#linear-gradient-149"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: 581.12,
    y1: 260.16,
    x2: 748.81,
    y2: 376.95,
    xlinkHref: "#linear-gradient-149"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: 595.84,
    y1: 298.81,
    x2: 597.52,
    y2: 336.23,
    xlinkHref: "#linear-gradient-146"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: 626.6,
    y1: 317.41,
    x2: 682.01,
    y2: 329.61,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: 691.4,
    y1: 188.6,
    x2: 603.31,
    y2: 296.24,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: 587.14,
    y1: 321.41,
    x2: 722.42,
    y2: 203.7,
    xlinkHref: "#linear-gradient-149"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: 561.25,
    y1: 288.68,
    x2: 728.94,
    y2: 405.48,
    xlinkHref: "#linear-gradient-149"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    x1: 7695.26,
    y1: 187.63,
    x2: 7721.08,
    y2: 594.47,
    gradientTransform: "translate(-7175.15)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-167",
    x1: 7693.18,
    y1: 47.87,
    x2: 7705.49,
    y2: 458.55,
    gradientTransform: "translate(-7175.15)",
    xlinkHref: "#linear-gradient-146"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-168",
    x1: 7653.14,
    y1: 49.07,
    x2: 7665.45,
    y2: 459.75,
    gradientTransform: "translate(-7175.15)",
    xlinkHref: "#linear-gradient-146"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-169",
    x1: 7657.72,
    y1: 48.94,
    x2: 7670.03,
    y2: 459.62,
    gradientTransform: "translate(-7175.15)",
    xlinkHref: "#linear-gradient-146"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-170",
    x1: 7704.48,
    y1: 246.1,
    x2: 7719.98,
    y2: 712.42,
    gradientTransform: "translate(-7175.15)",
    xlinkHref: "#linear-gradient-149"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-171",
    x1: 7703.44,
    y1: 204.44,
    x2: 7721.02,
    y2: 761.42,
    gradientTransform: "translate(-7175.15)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-172",
    x1: 7704,
    y1: 240.79,
    x2: 7720.09,
    y2: 318.98,
    gradientTransform: "translate(-7175.15)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-173",
    x1: 7714.24,
    y1: 238.68,
    x2: 7730.33,
    y2: 316.88,
    gradientTransform: "translate(-7175.15)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-174",
    x1: 7662.42,
    y1: 301.87,
    x2: 7664.89,
    y2: 301.87,
    gradientTransform: "translate(-7175.15)",
    xlinkHref: "#linear-gradient-146"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-175",
    x1: 7664.13,
    y1: 275.95,
    x2: 7659.36,
    y2: 406,
    gradientTransform: "translate(-7175.15)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-176",
    x1: 7662.42,
    y1: 317.17,
    x2: 7664.89,
    y2: 317.17,
    gradientTransform: "translate(-7175.15)",
    xlinkHref: "#linear-gradient-146"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-177",
    x1: 7664.69,
    y1: 275.97,
    x2: 7659.92,
    y2: 406.02,
    gradientTransform: "translate(-7175.15)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-178",
    x1: 7662.42,
    y1: 333.68,
    x2: 7664.89,
    y2: 333.68,
    gradientTransform: "translate(-7175.15)",
    xlinkHref: "#linear-gradient-146"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-179",
    x1: 7665.29,
    y1: 275.99,
    x2: 7660.53,
    y2: 406.04,
    gradientTransform: "translate(-7175.15)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-180",
    x1: 7706.38,
    y1: 387.75,
    x2: 7724.57,
    y2: 516.43,
    gradientTransform: "translate(-7175.15)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-181",
    x1: 7704.56,
    y1: 257.21,
    x2: 7716.87,
    y2: 560.46,
    gradientTransform: "translate(-7175.15)",
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-182",
    x1: 7703.17,
    y1: 170.24,
    x2: 7710.31,
    y2: 423.68,
    gradientTransform: "translate(-7175.15)",
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-183",
    x1: -3860.74,
    y1: 362.53,
    x2: -4047.28,
    y2: 468.14,
    gradientTransform: "translate(4190.15)",
    xlinkHref: "#linear-gradient-59"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-184",
    x1: -4009.58,
    y1: 422.65,
    x2: -3827.72,
    y2: 314.03,
    gradientTransform: "translate(4190.15)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-185",
    x1: -1504.43,
    y1: 437.99,
    x2: -1545.81,
    y2: 451.08,
    gradientTransform: "matrix(-1, 0, 0, 1, -1338.73, 0)",
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-186",
    x1: -4006.97,
    y1: 420.61,
    x2: -3869.7,
    y2: 341.54,
    gradientTransform: "translate(4190.15)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-187",
    x1: -5068.91,
    y1: -1227.25,
    x2: -5054.91,
    y2: -1201.18,
    gradientTransform: "matrix(-0.87, -0.5, -1, 0.58, -5346.24, -1301.11)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-188",
    x1: -3951.91,
    y1: 516.89,
    x2: -3952.02,
    y2: 526.46,
    gradientTransform: "matrix(-1, 0, 0, 1, -3687.29, 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-189",
    x1: -3957.03,
    y1: 521.26,
    x2: -3953.05,
    y2: 521.26,
    gradientTransform: "matrix(-1, 0, 0, 1, -3687.29, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-190",
    x1: -3788.68,
    y1: 881.53,
    x2: -3788.8,
    y2: 891.09,
    gradientTransform: "matrix(-0.99, 0.12, 0.12, 0.99, -3609.7, 81.44)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-191",
    x1: -3948.62,
    y1: 524.53,
    x2: -3944.64,
    y2: 524.53,
    gradientTransform: "matrix(-1, 0, 0, 1, -3687.29, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-192",
    x1: -3973.76,
    y1: 526.66,
    x2: -3942.22,
    y2: 464.75,
    gradientTransform: "matrix(-1, 0, 0, 1, -3687.29, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#0e1e75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3ca3ba"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-193",
    x1: -3974.35,
    y1: 542,
    x2: -3941.36,
    y2: 479.14,
    xlinkHref: "#linear-gradient-192"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-194",
    x1: -3974.98,
    y1: 461.6,
    x2: -3908,
    y2: 442.93,
    gradientTransform: "matrix(-1, 0, 0, 1, -3687.29, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f518a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b514be"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-195",
    x1: -3931.89,
    y1: 443.96,
    x2: -3904.52,
    y2: 443.96,
    gradientTransform: "matrix(-1, 0, 0, 1, -3687.29, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-196",
    x1: -3976.86,
    y1: 454.84,
    x2: -3909.88,
    y2: 436.17,
    xlinkHref: "#linear-gradient-194"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-197",
    x1: -3959.8,
    y1: 448.12,
    x2: -3874.85,
    y2: 394.68,
    gradientTransform: "matrix(-1, 0, 0, 1, -3687.29, 0)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-198",
    x1: -3954.11,
    y1: 438.2,
    x2: -3932.4,
    y2: 407.62,
    gradientTransform: "matrix(-1, 0, 0, 1, -3687.29, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-199",
    x1: -3955.28,
    y1: 437.36,
    x2: -3933.58,
    y2: 406.79,
    gradientTransform: "matrix(-1, 0, 0, 1, -3687.29, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-200",
    x1: -3952.01,
    y1: 418.69,
    x2: -3935.22,
    y2: 418.69,
    gradientTransform: "matrix(-1, 0, 0, 1, -3687.29, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#860048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#370041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-201",
    x1: 402.12,
    y1: 487.75,
    x2: 446.98,
    y2: 513.03,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-59"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-202",
    x1: 458.09,
    y1: 485.88,
    x2: 408.29,
    y2: 453.78,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-203",
    x1: 525.36,
    y1: 471.06,
    x2: 418.73,
    y2: 504.79,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-204",
    x1: 459.01,
    y1: 484.63,
    x2: 417.15,
    y2: 460.46,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-205",
    x1: 395.62,
    y1: 488.01,
    x2: 459.78,
    y2: 524.18,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-59"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-206",
    x1: 463.82,
    y1: 485.68,
    x2: 403.06,
    y2: 446.52,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-207",
    x1: 545.69,
    y1: 467.7,
    x2: 415.82,
    y2: 508.79,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-208",
    x1: 412.43,
    y1: 517.53,
    x2: 413.39,
    y2: 484.88,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-63"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-209",
    x1: 484.59,
    y1: 454.55,
    x2: 433.14,
    y2: 487.16,
    gradientTransform: "translate(298.41 -161.6) rotate(30)",
    xlinkHref: "#linear-gradient-64"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-210",
    x1: 394.17,
    y1: 462.57,
    x2: 415.65,
    y2: 447.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdef67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f8ae52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f67554"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-211",
    x1: 391.25,
    y1: 451.89,
    x2: 436.84,
    y2: 451.89,
    xlinkHref: "#linear-gradient-210"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-212",
    x1: 452.11,
    y1: 444.55,
    x2: 411.33,
    y2: 429.14,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-213",
    x1: 418.51,
    y1: 411,
    x2: 434.37,
    y2: 418.86,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-214",
    x1: 422.93,
    y1: 408.03,
    x2: 430.27,
    y2: 408.03,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-215",
    x1: 391.54,
    y1: 419.35,
    x2: 422.28,
    y2: 419.35,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-216",
    x1: 396.91,
    y1: 407.01,
    x2: 401.22,
    y2: 413.81,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-217",
    x1: 454.06,
    y1: 439.37,
    x2: 413.29,
    y2: 423.96,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-218",
    x1: 419.17,
    y1: 417.5,
    x2: 428.53,
    y2: 446.95,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-219",
    x1: 414.92,
    y1: 409.48,
    x2: 428.62,
    y2: 393.51,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-220",
    x1: 412.84,
    y1: 409.19,
    x2: 443.05,
    y2: 376.87,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-200"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-221",
    x1: 416.44,
    y1: 412.55,
    x2: 446.64,
    y2: 380.23,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-200"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-222",
    x1: 416.33,
    y1: 410.49,
    x2: 429.87,
    y2: 394.72,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-223",
    x1: 394.08,
    y1: 431.54,
    x2: 419,
    y2: 417.83,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-224",
    x1: 398.42,
    y1: 439.43,
    x2: 423.34,
    y2: 425.72,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-225",
    x1: 1116.03,
    y1: -471,
    x2: 1138.3,
    y2: -453.61,
    gradientTransform: "translate(-467.82 -35.54) rotate(45.42)",
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-226",
    x1: 648.47,
    y1: 442.54,
    x2: 651.78,
    y2: 456.3,
    xlinkHref: "#linear-gradient-210"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-227",
    x1: 796.17,
    y1: 415.83,
    x2: 625.61,
    y2: 512.4,
    gradientTransform: "translate(-136.7)",
    xlinkHref: "#linear-gradient-59"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-228",
    x1: 661.26,
    y1: 472.8,
    x2: 827.53,
    y2: 373.49,
    gradientTransform: "translate(-136.7)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-229",
    x1: -6250.4,
    y1: 431.9,
    x2: -6288.24,
    y2: 443.88,
    gradientTransform: "matrix(-1, 0, 0, 1, -5665.58, 0)",
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-230",
    x1: 662.83,
    y1: 469.59,
    x2: 788.35,
    y2: 397.29,
    gradientTransform: "translate(-136.7)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-231",
    x1: -5069.25,
    y1: 540.68,
    x2: -5069.36,
    y2: 550.05,
    gradientTransform: "matrix(-1, 0, 0, 1, -4421.12, 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-232",
    x1: -5076.28,
    y1: 549.31,
    x2: -5054.57,
    y2: 521.19,
    gradientTransform: "matrix(-1, 0, 0, 1, -4421.12, 0)",
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-233",
    x1: -5090.64,
    y1: 538.22,
    x2: -5068.93,
    y2: 510.1,
    gradientTransform: "matrix(-1, 0, 0, 1, -4421.12, 0)",
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-234",
    x1: -5067.6,
    y1: 542.75,
    x2: -5035.37,
    y2: 505.27,
    gradientTransform: "matrix(-1, 0, 0, 1, -4421.12, 0)",
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-235",
    x1: -5075.17,
    y1: 546.19,
    x2: -5061.23,
    y2: 552.25,
    gradientTransform: "matrix(-1, 0, 0, 1, -4421.12, 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-236",
    x1: -5084.64,
    y1: 528.11,
    x2: -5052.41,
    y2: 490.62,
    gradientTransform: "matrix(-1, 0, 0, 1, -4421.12, 0)",
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-237",
    x1: -5085.23,
    y1: 504.46,
    x2: -5050.14,
    y2: 504.46,
    gradientTransform: "matrix(-1, 0, 0, 1, -4421.12, 0)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-238",
    x1: 621.46,
    y1: 451.65,
    x2: 665.84,
    y2: 490.49,
    xlinkHref: "#linear-gradient-210"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-239",
    x1: 642.88,
    y1: 460.41,
    x2: 647.14,
    y2: 446.97,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-240",
    x1: 635.87,
    y1: 446.63,
    x2: 649.1,
    y2: 440.01,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-241",
    x1: 6572.51,
    y1: -1164.42,
    x2: 6595.11,
    y2: -1164.42,
    gradientTransform: "matrix(-0.95, 0.32, 0.32, 0.95, 7257.74, -589.56)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-242",
    x1: 1103.96,
    y1: 1413.57,
    x2: 1126.48,
    y2: 1431.16,
    gradientTransform: "translate(-159.09 -1167.81) rotate(12.43)",
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-243",
    x1: 1111.85,
    y1: 1407.97,
    x2: 1156.23,
    y2: 1446.8,
    gradientTransform: "translate(-159.09 -1167.81) rotate(12.43)",
    xlinkHref: "#linear-gradient-210"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-244",
    x1: 637.52,
    y1: 460.29,
    x2: 642.14,
    y2: 466.77,
    xlinkHref: "#linear-gradient-210"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-245",
    x1: -4783.47,
    y1: -1241.11,
    x2: -4770.66,
    y2: -1217.27,
    gradientTransform: "matrix(0.09, -1, -0.94, -0.67, -39.63, -5207.45)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-246",
    x1: -3715.57,
    y1: 368.03,
    x2: -3715.68,
    y2: 376.78,
    gradientTransform: "matrix(-1, 0, 0, 1, -3036.48, 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-247",
    x1: -3720.25,
    y1: 372.02,
    x2: -3716.61,
    y2: 372.02,
    gradientTransform: "matrix(-1, 0, 0, 1, -3036.48, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-248",
    x1: -3723.41,
    y1: 344.22,
    x2: -3710.64,
    y2: 344.22,
    gradientTransform: "matrix(-1, 0, 0, 1, -3036.48, 0)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-249",
    x1: -3718.44,
    y1: 345.51,
    x2: -3701.04,
    y2: 345.51,
    gradientTransform: "matrix(-1, 0, 0, 1, -3036.48, 0)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-250",
    x1: -3716.48,
    y1: 371,
    x2: -3713.32,
    y2: 371,
    gradientTransform: "matrix(-1, 0, 0, 1, -3036.48, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-251",
    x1: -3721.1,
    y1: 373.18,
    x2: -3708.08,
    y2: 378.83,
    gradientTransform: "matrix(-1, 0, 0, 1, -3036.48, 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-252",
    x1: -3728.38,
    y1: 322.76,
    x2: -3687.85,
    y2: 284.12,
    gradientTransform: "matrix(-1, 0, 0, 1, -3036.48, 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-253",
    x1: -3482.62,
    y1: 709.53,
    x2: -3475.87,
    y2: 709.53,
    gradientTransform: "matrix(-0.99, 0.13, 0.13, 0.99, -2863.35, 40.8)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-254",
    x1: -3717.93,
    y1: 279.22,
    x2: -3707.68,
    y2: 279.22,
    gradientTransform: "matrix(-1, 0, 0, 1, -3036.48, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-255",
    x1: -3733.96,
    y1: 279.76,
    x2: -3709.22,
    y2: 279.76,
    gradientTransform: "matrix(-1, 0, 0, 1, -3036.48, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-256",
    x1: -3699.7,
    y1: 294.89,
    x2: -3689.35,
    y2: 294.89,
    gradientTransform: "matrix(-1, 0, 0, 1, -3036.48, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-257",
    x1: -3691.04,
    y1: 295.01,
    x2: -3708.14,
    y2: 313.33,
    gradientTransform: "matrix(-1, 0, 0, 1, -3036.48, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-258",
    x1: -3695.89,
    y1: 290.95,
    x2: -3714.04,
    y2: 310.39,
    gradientTransform: "matrix(-1, 0, 0, 1, -3036.48, 0)",
    xlinkHref: "#linear-gradient-8"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 65") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Isometric_objects",
    "data-name": "Isometric objects"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M615.88,95.62a.15.15,0,0,1-.09,0l-.83-.48a.18.18,0,0,1-.06-.24.18.18,0,0,1,.24-.07l.83.48a.19.19,0,0,1,.06.25A.18.18,0,0,1,615.88,95.62Zm-2.48-1.43a.15.15,0,0,1-.09,0l-.82-.48a.17.17,0,0,1-.07-.24.19.19,0,0,1,.25-.07l.82.48a.18.18,0,0,1,.07.25A.21.21,0,0,1,613.4,94.19Zm-2.47-1.42a.12.12,0,0,1-.09,0l-.83-.48A.17.17,0,0,1,610,92a.18.18,0,0,1,.24-.07l.82.48a.18.18,0,0,1,.07.25A.19.19,0,0,1,610.93,92.77Zm-2.48-1.43a.16.16,0,0,1-.09,0l-.83-.48a.17.17,0,0,1-.06-.24.17.17,0,0,1,.24-.06l.83.47a.18.18,0,0,1-.09.34ZM606,89.91a.16.16,0,0,1-.09,0l-.82-.48a.17.17,0,0,1-.07-.24.18.18,0,0,1,.25-.06l.82.47a.18.18,0,0,1,.07.25A.22.22,0,0,1,606,89.91Zm-2.47-1.43a.12.12,0,0,1-.09,0l-.83-.48a.17.17,0,0,1-.06-.24.17.17,0,0,1,.24-.06l.83.47a.18.18,0,0,1-.09.34ZM601,87.05l-.09,0-.83-.47a.19.19,0,0,1-.06-.25.18.18,0,0,1,.24-.06l.83.47a.18.18,0,0,1-.09.34Zm-2.48-1.43a.16.16,0,0,1-.09,0l-.82-.47a.18.18,0,0,1-.07-.25.19.19,0,0,1,.25-.06l.82.47a.18.18,0,0,1,.07.25A.22.22,0,0,1,598.54,85.62Zm-2.47-1.43a.14.14,0,0,1-.09,0l-.83-.47a.19.19,0,0,1-.06-.25.18.18,0,0,1,.24-.06l.83.47a.18.18,0,0,1-.09.34Zm-2.48-1.43a.16.16,0,0,1-.09,0l-.83-.47a.19.19,0,0,1-.06-.25.18.18,0,0,1,.24-.06l.83.47a.18.18,0,0,1-.09.34Zm-2.48-1.43a.16.16,0,0,1-.09,0l-.82-.47a.18.18,0,0,1-.07-.25.19.19,0,0,1,.25-.06l.82.47a.18.18,0,0,1,.07.25A.22.22,0,0,1,591.11,81.33Zm-2.47-1.43-.09,0-.83-.47a.19.19,0,0,1-.06-.25.18.18,0,0,1,.24-.06l.83.47a.18.18,0,0,1-.09.34Zm-2.48-1.43a.16.16,0,0,1-.09,0l-.82-.47a.18.18,0,0,1-.07-.25.18.18,0,0,1,.24-.06l.83.47a.18.18,0,0,1-.09.34ZM583.68,77a.16.16,0,0,1-.09,0l-.82-.47a.18.18,0,0,1-.07-.25.19.19,0,0,1,.25-.06l.82.47a.18.18,0,0,1,.07.25A.19.19,0,0,1,583.68,77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M538.77,160h-.72a.17.17,0,0,1-.17-.19c0-.09.1-.16.18-.17h1a.19.19,0,0,1,.18.18.18.18,0,0,1-.18.18Zm2.14-.09a.18.18,0,0,1-.18-.16.2.2,0,0,1,.17-.2l.94-.09a.17.17,0,0,1,.2.16.18.18,0,0,1-.16.19l-1,.1Zm-4.75,0h0l-1-.13a.19.19,0,0,1-.15-.2.18.18,0,0,1,.21-.15q.46.08.93.12a.18.18,0,0,1,.16.2A.17.17,0,0,1,536.16,159.83Zm7.59-.33a.18.18,0,0,1-.18-.14.18.18,0,0,1,.14-.21l.93-.18a.18.18,0,0,1,.21.13.18.18,0,0,1-.13.22l-.94.18Zm-10.41-.17h0c-.31-.07-.62-.16-.93-.25a.18.18,0,0,1-.12-.22.19.19,0,0,1,.23-.12l.91.25a.18.18,0,0,1,0,.35Zm13.19-.46a.18.18,0,0,1,0-.35l.91-.26a.17.17,0,0,1,.22.12.18.18,0,0,1-.12.22l-.92.26Zm-15.9-.42h-.07l-.88-.38a.19.19,0,0,1-.09-.24.18.18,0,0,1,.24-.09l.86.38a.17.17,0,0,1,.1.23A.17.17,0,0,1,530.63,158.45Zm18.63-.44a.18.18,0,0,1-.17-.12.19.19,0,0,1,.11-.23l.89-.33a.19.19,0,0,1,.23.11.18.18,0,0,1-.1.23l-.9.33Zm-21.2-.82a.16.16,0,0,1-.09,0q-.4-.24-.81-.51a.17.17,0,0,1,0-.24.17.17,0,0,1,.25,0c.26.17.52.34.8.49a.19.19,0,0,1,.06.25A.17.17,0,0,1,528.06,157.19Zm23.86-.23a.18.18,0,0,1-.17-.11.17.17,0,0,1,.1-.23l.86-.39a.18.18,0,0,1,.24.09.17.17,0,0,1-.09.23q-.43.21-.87.39Zm2.58-1.22a.2.2,0,0,1-.16-.1.18.18,0,0,1,.08-.24l.84-.44a.19.19,0,0,1,.25.07.19.19,0,0,1-.08.25l-.85.44Zm-28.78-.18a.15.15,0,0,1-.11,0c-.25-.2-.49-.41-.73-.62a.18.18,0,0,1,0-.25.19.19,0,0,1,.26,0c.23.21.47.42.71.61a.18.18,0,0,1,0,.25A.16.16,0,0,1,525.72,155.56ZM557,154.37a.16.16,0,0,1-.15-.09.17.17,0,0,1,.07-.24l.81-.49a.18.18,0,0,1,.25.07.18.18,0,0,1-.06.24l-.83.49Zm-33.37-.76a.16.16,0,0,1-.13-.06c-.22-.23-.43-.47-.64-.72a.18.18,0,1,1,.27-.23l.63.71a.18.18,0,0,1,0,.25A.18.18,0,0,1,523.64,153.61Zm35.81-.73a.18.18,0,0,1-.1-.33l.8-.52a.18.18,0,0,1,.25,0,.19.19,0,0,1,0,.25l-.8.53A.17.17,0,0,1,559.45,152.88Zm-37.61-1.49a.18.18,0,0,1-.15-.07c-.18-.26-.36-.53-.53-.8a.18.18,0,0,1,.05-.25.17.17,0,0,1,.24.06l.54.78a.19.19,0,0,1,0,.25A.17.17,0,0,1,521.84,151.39Zm40-.12a.19.19,0,0,1-.15-.08.18.18,0,0,1,0-.25l.77-.55a.18.18,0,1,1,.21.28l-.77.56A.14.14,0,0,1,561.82,151.27Zm2.29-1.72a.17.17,0,0,1-.11-.31l.74-.6a.19.19,0,0,1,.25,0,.18.18,0,0,1,0,.25l-.74.6ZM520.33,149a.18.18,0,0,1-.15-.1c-.16-.28-.3-.56-.45-.85a.19.19,0,0,1,.08-.24.18.18,0,0,1,.24.08c.15.29.29.57.44.84a.17.17,0,0,1-.07.24A.16.16,0,0,1,520.33,149Zm46-1.22a.16.16,0,0,1-.13-.06.18.18,0,0,1,0-.26l.72-.62a.19.19,0,0,1,.25,0,.18.18,0,0,1,0,.25l-.72.63A.28.28,0,0,1,566.32,147.75Zm-47.21-1.36a.2.2,0,0,1-.17-.11c-.12-.3-.24-.59-.35-.9a.18.18,0,0,1,.1-.23.18.18,0,0,1,.23.11c.12.3.23.59.35.88a.17.17,0,0,1-.1.23Zm49.36-.53a.16.16,0,0,1-.13-.06.18.18,0,0,1,0-.26l.69-.64a.18.18,0,0,1,.26,0,.18.18,0,0,1,0,.25l-.7.65A.21.21,0,0,1,568.47,145.86Zm2.07-2a.17.17,0,0,1-.13,0,.18.18,0,0,1,0-.25l.68-.67a.18.18,0,0,1,.25.25l-.68.67A.15.15,0,0,1,570.54,143.88Zm-52.4-.18a.18.18,0,0,1-.17-.13l-.27-.92a.18.18,0,0,1,.13-.22.19.19,0,0,1,.22.12c.08.31.17.61.26.91a.18.18,0,0,1-.12.23Zm54.4-1.86a.15.15,0,0,1-.12-.05.18.18,0,0,1,0-.25l.65-.69a.18.18,0,0,1,.26.24l-.65.7A.19.19,0,0,1,572.54,141.84Zm-55.12-.91a.18.18,0,0,1-.18-.14c-.07-.31-.13-.62-.19-.94a.18.18,0,0,1,.14-.21.18.18,0,0,1,.21.15c.06.31.12.62.19.92a.18.18,0,0,1-.14.22Zm57.05-1.2a.19.19,0,0,1-.12,0,.18.18,0,0,1,0-.25l.63-.72a.18.18,0,0,1,.27.23l-.63.72A.2.2,0,0,1,574.47,139.73Zm-57.56-1.61a.18.18,0,0,1-.18-.15c0-.32-.09-.63-.12-.95a.17.17,0,0,1,.15-.2.17.17,0,0,1,.2.15l.12.94a.18.18,0,0,1-.15.21Zm59.43-.56a.17.17,0,0,1-.14-.29l.6-.74a.19.19,0,0,1,.25,0,.18.18,0,0,1,0,.25l-.61.74A.16.16,0,0,1,576.34,137.56Zm1.79-2.23a.2.2,0,0,1-.11,0,.18.18,0,0,1,0-.25l.58-.76a.18.18,0,0,1,.28.22l-.58.76A.2.2,0,0,1,578.13,135.33Zm-61.54-.05a.17.17,0,0,1-.17-.17c0-.31,0-.63-.07-1a.18.18,0,0,1,.17-.19c.09,0,.18.07.19.17l.06.94a.18.18,0,0,1-.16.2Zm63.26-2.23a.19.19,0,0,1-.1,0,.18.18,0,0,1,0-.25l.56-.78a.19.19,0,0,1,.25,0,.18.18,0,0,1,0,.25L580,133A.18.18,0,0,1,579.85,133.05Zm-63.4-.63a.18.18,0,0,1-.18-.17c0-.32,0-.64,0-1a.18.18,0,1,1,.36,0c0,.32,0,.64,0,1a.17.17,0,0,1-.17.18Zm65.06-1.71a.19.19,0,0,1-.1,0,.17.17,0,0,1,0-.25c.18-.26.36-.52.53-.79a.18.18,0,0,1,.25,0,.17.17,0,0,1,.05.24l-.54.8A.17.17,0,0,1,581.51,130.71Zm-65-1.15h0a.17.17,0,0,1-.17-.18c0-.32,0-.64,0-1a.19.19,0,0,1,.19-.17.19.19,0,0,1,.17.19c0,.32,0,.63,0,.95A.17.17,0,0,1,516.47,129.56Zm66.63-1.23-.09,0a.19.19,0,0,1-.06-.25c.18-.26.35-.53.52-.8a.18.18,0,0,1,.24-.06.18.18,0,0,1,.06.25c-.17.27-.34.54-.52.81A.18.18,0,0,1,583.1,128.33Zm-66.47-1.62h0a.18.18,0,0,1-.16-.19c0-.32,0-.64.08-1a.18.18,0,0,1,.36,0c0,.31-.06.63-.08.94A.18.18,0,0,1,516.63,126.71Zm68-.81a.16.16,0,0,1-.09,0,.18.18,0,0,1-.06-.24c.17-.27.33-.54.49-.82a.19.19,0,0,1,.25-.06.18.18,0,0,1,.06.24c-.16.28-.33.55-.49.82A.19.19,0,0,1,584.62,125.9Zm-67.7-2h0a.18.18,0,0,1-.16-.2c0-.31.08-.63.13-1a.18.18,0,0,1,.2-.15.18.18,0,0,1,.15.2l-.12.95A.17.17,0,0,1,516.92,123.86Zm69.15-.43-.09,0a.19.19,0,0,1-.06-.25l.46-.83a.19.19,0,0,1,.25-.06.17.17,0,0,1,.06.24l-.46.83A.19.19,0,0,1,586.07,123.43ZM517.34,121h0a.17.17,0,0,1-.15-.2c.05-.32.11-.63.16-1a.19.19,0,0,1,.21-.14.17.17,0,0,1,.14.21c0,.31-.11.62-.16.93A.17.17,0,0,1,517.34,121Zm70.11-.11a.15.15,0,0,1-.09,0,.18.18,0,0,1-.07-.24l.44-.84a.18.18,0,0,1,.24-.08.19.19,0,0,1,.08.24l-.45.85A.16.16,0,0,1,587.45,120.92Zm1.3-2.54-.08,0a.17.17,0,0,1-.08-.24c.14-.28.28-.57.41-.85a.19.19,0,0,1,.24-.09.17.17,0,0,1,.08.24c-.13.29-.27.58-.41.86A.19.19,0,0,1,588.75,118.38Zm-70.88-.16h0a.17.17,0,0,1-.14-.21c.07-.31.13-.62.2-.94a.18.18,0,0,1,.35.08c-.07.31-.14.62-.2.93A.17.17,0,0,1,517.87,118.22ZM590,115.8h-.07a.19.19,0,0,1-.09-.24l.39-.87a.18.18,0,0,1,.33.15l-.39.87A.19.19,0,0,1,590,115.8Zm-71.47-.36h0a.18.18,0,0,1-.13-.22l.24-.92a.17.17,0,0,1,.21-.13.18.18,0,0,1,.13.22c-.08.31-.16.61-.23.92A.19.19,0,0,1,518.5,115.44Zm72.62-2.25h-.07a.2.2,0,0,1-.1-.24c.13-.29.25-.58.37-.87a.17.17,0,0,1,.23-.1.18.18,0,0,1,.1.23c-.12.29-.24.59-.37.88A.17.17,0,0,1,591.12,113.19Zm-71.88-.52h0a.18.18,0,0,1-.12-.22l.27-.92a.17.17,0,0,1,.22-.12.18.18,0,0,1,.12.22l-.27.91A.17.17,0,0,1,519.24,112.67Zm73-2.13h-.07a.19.19,0,0,1-.1-.23c.12-.3.23-.59.34-.89a.19.19,0,0,1,.23-.11.18.18,0,0,1,.1.23l-.33.9A.18.18,0,0,1,592.19,110.54Zm-72.11-.6H520a.18.18,0,0,1-.11-.23c.09-.3.19-.6.29-.9a.18.18,0,0,1,.23-.12.17.17,0,0,1,.11.23c-.1.3-.2.6-.29.9A.19.19,0,0,1,520.08,109.94Zm73.1-2.08h-.06a.17.17,0,0,1-.11-.23c.1-.3.2-.6.31-.9a.17.17,0,0,1,.22-.11.16.16,0,0,1,.11.22c-.1.3-.2.61-.31.91A.17.17,0,0,1,593.18,107.86ZM521,107.23h-.06a.19.19,0,0,1-.11-.23l.33-.9a.18.18,0,0,1,.23-.1.17.17,0,0,1,.1.23l-.32.89A.19.19,0,0,1,521,107.23Zm73.08-2.09H594a.18.18,0,0,1-.11-.22l.27-.91a.18.18,0,0,1,.35.1c-.1.31-.19.61-.28.92A.19.19,0,0,1,594.08,105.14ZM522,104.55h-.07a.18.18,0,0,1-.1-.23l.36-.88a.17.17,0,0,1,.23-.1.18.18,0,0,1,.1.23c-.12.29-.24.59-.35.88A.18.18,0,0,1,522,104.55Zm72.87-2.15h0a.18.18,0,0,1-.13-.22c.09-.31.17-.61.25-.92a.17.17,0,0,1,.22-.12.17.17,0,0,1,.12.21l-.24.93A.19.19,0,0,1,594.88,102.4Zm-71.78-.48-.07,0a.18.18,0,0,1-.1-.23l.39-.87a.17.17,0,1,1,.32.14l-.38.87A.17.17,0,0,1,523.1,101.92Zm72.49-2.29h0a.18.18,0,0,1-.13-.21c.07-.31.15-.62.21-.93a.18.18,0,0,1,.22-.13.17.17,0,0,1,.13.21l-.21.93A.18.18,0,0,1,595.59,99.63Zm-71.32-.31-.08,0a.17.17,0,0,1-.08-.24c.13-.29.27-.57.4-.86a.18.18,0,0,1,.33.15l-.41.86A.18.18,0,0,1,524.27,99.32Zm71.93-2.49h0a.17.17,0,0,1-.14-.21l.18-.93a.18.18,0,0,1,.2-.15.18.18,0,0,1,.15.21l-.18.94A.18.18,0,0,1,596.2,96.83Zm-70.69-.08-.08,0a.18.18,0,0,1-.08-.24l.44-.85a.17.17,0,1,1,.31.16l-.43.85A.18.18,0,0,1,525.51,96.75Zm1.32-2.54a.13.13,0,0,1-.08,0,.17.17,0,0,1-.07-.24l.45-.84a.19.19,0,0,1,.25-.07.18.18,0,0,1,.07.24c-.16.28-.31.56-.46.84A.17.17,0,0,1,526.83,94.21ZM596.7,94h0a.18.18,0,0,1-.14-.21c.05-.31.09-.63.14-.94a.17.17,0,0,1,.2-.15.17.17,0,0,1,.15.2c0,.32-.09.63-.14,1A.18.18,0,0,1,596.7,94Zm-68.47-2.3a.16.16,0,0,1-.09,0,.19.19,0,0,1-.07-.24l.49-.83a.18.18,0,1,1,.3.19l-.48.82A.19.19,0,0,1,528.23,91.72Zm68.86-.54h0a.18.18,0,0,1-.16-.2c0-.31.07-.63.1-.94a.17.17,0,0,1,.19-.16.18.18,0,0,1,.16.19c0,.32-.06.64-.1,1A.17.17,0,0,1,597.09,91.18ZM529.7,89.26a.17.17,0,0,1-.1,0,.18.18,0,0,1-.06-.24l.51-.82a.19.19,0,0,1,.25,0,.17.17,0,0,1,.05.24l-.5.81A.16.16,0,0,1,529.7,89.26Zm67.64-.92h0a.18.18,0,0,1-.17-.19l.06-.94a.19.19,0,0,1,.19-.17.18.18,0,0,1,.17.18l-.06,1A.19.19,0,0,1,597.34,88.34Zm-66.1-1.5a.17.17,0,0,1-.1,0,.16.16,0,0,1,0-.24l.52-.8a.18.18,0,0,1,.25,0,.17.17,0,0,1,0,.25l-.53.79A.17.17,0,0,1,531.24,86.84Zm66.22-1.36h0a.19.19,0,0,1-.18-.18c0-.32,0-.64,0-1a.18.18,0,1,1,.36,0c0,.31,0,.63,0,1A.18.18,0,0,1,597.46,85.48Zm-64.62-1a.19.19,0,0,1-.1,0,.18.18,0,0,1,0-.25l.55-.78a.18.18,0,0,1,.25,0,.16.16,0,0,1,0,.24l-.55.78A.18.18,0,0,1,532.84,84.47Zm64.61-1.23a.17.17,0,0,1-.17-.17c0-.32,0-.64,0-.95a.19.19,0,0,1,.17-.19h0a.18.18,0,0,1,.18.17c0,.32,0,.64,0,1a.17.17,0,0,1-.17.18Zm-62.92-1.1a.2.2,0,0,1-.11,0,.18.18,0,0,1,0-.25c.19-.26.38-.51.58-.76a.18.18,0,1,1,.28.21l-.57.76A.17.17,0,0,1,534.53,82.14Zm62.77-1.75a.17.17,0,0,1-.17-.17l-.09-.94a.18.18,0,0,1,.16-.2.17.17,0,0,1,.19.16c0,.32.07.63.09,1a.18.18,0,0,1-.16.19Zm-61-.51a.21.21,0,0,1-.11,0,.18.18,0,0,1,0-.25l.6-.75a.17.17,0,0,1,.25,0,.18.18,0,0,1,0,.25l-.6.74A.21.21,0,0,1,536.27,79.88Zm1.81-2.22a.15.15,0,0,1-.11,0,.18.18,0,0,1,0-.25l.63-.73a.17.17,0,0,1,.25,0,.18.18,0,0,1,0,.25l-.62.72A.2.2,0,0,1,538.08,77.66Zm58.9-.11a.17.17,0,0,1-.18-.15l-.15-.94a.18.18,0,0,1,.15-.21.17.17,0,0,1,.2.15c.06.31.11.63.15.94a.18.18,0,0,1-.15.21Zm-57-2a.16.16,0,0,1-.12-.05.17.17,0,0,1,0-.25l.64-.7a.18.18,0,0,1,.26,0,.18.18,0,0,1,0,.25c-.22.23-.43.47-.64.7A.2.2,0,0,1,540,75.51Zm56.5-.77a.19.19,0,0,1-.18-.14c-.07-.31-.14-.62-.22-.92a.19.19,0,0,1,.13-.22.17.17,0,0,1,.22.13c.08.31.15.62.22.93a.18.18,0,0,1-.13.21Zm-54.55-1.32a.21.21,0,0,1-.12,0,.18.18,0,0,1,0-.25l.66-.69a.19.19,0,0,1,.26,0,.18.18,0,0,1,0,.25l-.67.68A.16.16,0,0,1,541.91,73.42ZM595.72,72a.17.17,0,0,1-.17-.13c-.1-.3-.19-.6-.3-.9a.18.18,0,0,1,.11-.22.17.17,0,0,1,.23.11c.1.29.2.6.3.9a.18.18,0,0,1-.12.23Zm-51.78-.58a.16.16,0,0,1-.13-.06.18.18,0,0,1,0-.25l.69-.66a.17.17,0,0,1,.25,0,.18.18,0,0,1,0,.25l-.69.66A.21.21,0,0,1,543.94,71.4Zm2.09-2a.2.2,0,0,1-.14-.06.19.19,0,0,1,0-.26l.71-.63a.18.18,0,0,1,.26,0,.19.19,0,0,1,0,.25l-.71.63A.21.21,0,0,1,546,69.45Zm48.71-.16a.16.16,0,0,1-.16-.11c-.13-.29-.25-.58-.39-.86a.18.18,0,1,1,.33-.15l.39.88a.19.19,0,0,1-.1.23Zm-46.55-1.71a.21.21,0,0,1-.14-.07.18.18,0,0,1,0-.25l.74-.61a.18.18,0,0,1,.22.28l-.73.6A.21.21,0,0,1,548.19,67.58Zm45.31-.86a.19.19,0,0,1-.16-.09c-.15-.28-.31-.55-.47-.82a.19.19,0,0,1,.06-.25.19.19,0,0,1,.25.06c.16.28.32.55.48.84a.19.19,0,0,1-.07.24Zm-43.07-.93a.15.15,0,0,1-.14-.07.18.18,0,0,1,0-.25l.76-.57a.18.18,0,0,1,.22.29c-.26.18-.51.37-.76.57A.23.23,0,0,1,550.43,65.79ZM592,64.31a.17.17,0,0,1-.14-.08q-.29-.39-.57-.75a.19.19,0,0,1,0-.26.19.19,0,0,1,.25,0c.2.25.39.51.58.77a.18.18,0,0,1,0,.25A.21.21,0,0,1,592,64.31Zm-39.23-.2a.18.18,0,0,1-.1-.33l.78-.54a.19.19,0,0,1,.25,0,.17.17,0,0,1,0,.25l-.78.54A.19.19,0,0,1,552.74,64.11Zm2.38-1.58a.19.19,0,0,1-.15-.08.18.18,0,0,1,.06-.25l.81-.5a.18.18,0,1,1,.19.3l-.81.5A.17.17,0,0,1,555.12,62.53Zm35-.43A.16.16,0,0,1,590,62l-.66-.67a.17.17,0,1,1,.24-.25c.23.22.46.45.68.68a.18.18,0,0,1,0,.25A.18.18,0,0,1,590.16,62.1Zm-32.58-1a.19.19,0,0,1-.16-.09.19.19,0,0,1,.07-.24l.84-.46a.17.17,0,0,1,.24.07.17.17,0,0,1-.07.24l-.83.46Zm30.48-.9a.21.21,0,0,1-.11,0q-.37-.3-.75-.57a.18.18,0,0,1,0-.25.17.17,0,0,1,.24,0c.26.19.52.38.77.58a.18.18,0,0,1,0,.25A.21.21,0,0,1,588.06,60.17Zm-27.95-.43a.19.19,0,0,1-.16-.1.19.19,0,0,1,.08-.24l.87-.41a.19.19,0,0,1,.24.09.17.17,0,0,1-.09.23l-.86.41A.11.11,0,0,1,560.11,59.74Zm2.61-1.18a.18.18,0,0,1-.07-.34l.89-.36a.18.18,0,0,1,.23.11.18.18,0,0,1-.1.23l-.88.35Zm23,0-.09,0c-.27-.16-.55-.31-.83-.46a.18.18,0,0,1-.07-.24.17.17,0,0,1,.24-.07c.28.14.56.3.84.46a.17.17,0,0,1,.07.24A.19.19,0,0,1,585.7,58.56Zm-20.3-1a.16.16,0,0,1-.17-.12.19.19,0,0,1,.11-.23l.91-.29a.19.19,0,0,1,.23.12.18.18,0,0,1-.12.22l-.91.29Zm17.73-.24h-.07c-.29-.12-.58-.23-.88-.33a.18.18,0,0,1,.11-.34c.31.1.61.22.91.33a.19.19,0,0,1,.1.23A.19.19,0,0,1,583.13,57.32Zm-15-.56a.18.18,0,0,1,0-.35l.93-.22a.18.18,0,0,1,.08.35l-.93.22Zm12.27-.3h0c-.31-.08-.62-.14-.93-.2a.18.18,0,0,1,.07-.35l.94.2a.18.18,0,0,1,.13.21A.17.17,0,0,1,580.41,56.46Zm-9.47-.26a.18.18,0,0,1-.17-.16.17.17,0,0,1,.14-.2l1-.13a.17.17,0,0,1,.2.15.17.17,0,0,1-.15.2l-.94.13Zm6.65-.21h0c-.31,0-.62-.06-.94-.08a.18.18,0,1,1,0-.36l1,.08a.18.18,0,0,1,.16.2A.18.18,0,0,1,577.59,56Zm-3.81-.09a.18.18,0,0,1-.17-.17.18.18,0,0,1,.17-.19l1,0h0a.19.19,0,0,1,.18.17.19.19,0,0,1-.18.19l-1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M590.26,61.27l.34-.07-2.75-1.55c-7.32-4.14-17.43-3.48-28.58,3-22.38,12.92-40.52,44.2-40.52,69.88,0,12.85,4.55,21.85,11.89,26h0l3.13,1.76-.19-.4c7,2.55,15.93,1.34,25.68-4.29,22.37-12.92,40.51-44.21,40.51-69.88C599.78,74.3,596.2,65.93,590.26,61.27Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 561.98,
    cy: 110.62,
    rx: 57.12,
    ry: 32.98,
    transform: "translate(182.85 539.95) rotate(-59.69)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 561.98,
    cy: 110.83,
    rx: 52.77,
    ry: 30.46,
    transform: "translate(182.68 540.05) rotate(-59.69)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 561.65,
    cy: 111.05,
    rx: 41.41,
    ry: 23.31,
    transform: "translate(182.32 539.87) rotate(-59.69)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 561.96,
    cy: 110.84,
    rx: 28.93,
    ry: 16.7,
    transform: "matrix(0.5, -0.86, 0.86, 0.5, 182.66, 540.04)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 561.78,
    cy: 110.96,
    rx: 18.74,
    ry: 10.55,
    transform: "translate(182.46 539.94) rotate(-59.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M566.9,108A10.85,10.85,0,0,1,562,116.5c-2.73,1.58-4.94.32-4.94-2.81a10.85,10.85,0,0,1,4.94-8.51C564.69,103.6,566.9,104.86,566.9,108Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M562.12,157.1A.11.11,0,0,1,562,157V64a.11.11,0,0,1,.11-.12.12.12,0,0,1,.12.12V157A.12.12,0,0,1,562.12,157.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M521.59,134.51a.13.13,0,0,1-.1-.06.12.12,0,0,1,0-.17l80.8-46.65a.12.12,0,0,1,.16.05.11.11,0,0,1,0,.16l-80.8,46.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M564.09,109.61a4.7,4.7,0,0,1-2.13,3.68c-1.18.68-2.13.13-2.13-1.22a4.7,4.7,0,0,1,2.13-3.68C563.14,107.71,564.09,108.26,564.09,109.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M573.1,163.53l-.09,0-.83-.48a.18.18,0,0,1-.06-.24.17.17,0,0,1,.24-.07l.83.48a.18.18,0,0,1,.06.24A.16.16,0,0,1,573.1,163.53Zm-2.48-1.43-.09,0-.82-.48a.17.17,0,0,1-.07-.24.18.18,0,0,1,.25-.07l.82.48a.17.17,0,0,1,.07.24A.19.19,0,0,1,570.62,162.1Zm-2.47-1.43-.09,0-.83-.48a.18.18,0,0,1-.06-.24.17.17,0,0,1,.24-.07l.83.48a.18.18,0,0,1,.06.24A.16.16,0,0,1,568.15,160.67Zm-2.48-1.43-.09,0-.83-.48a.18.18,0,0,1-.06-.24.17.17,0,0,1,.24-.07l.83.48a.18.18,0,0,1,.06.24A.16.16,0,0,1,565.67,159.24Zm-2.48-1.43-.09,0-.82-.48a.17.17,0,0,1-.07-.24.18.18,0,0,1,.25-.07l.82.48a.17.17,0,0,1,.07.24A.19.19,0,0,1,563.19,157.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M582.76,123.14l-.09,0-.82-.48a.17.17,0,0,1-.07-.24.18.18,0,0,1,.25-.07l.82.48a.17.17,0,0,1,.07.24A.19.19,0,0,1,582.76,123.14Zm-2.47-1.43-.09,0-.83-.48a.18.18,0,0,1-.06-.24.17.17,0,0,1,.24-.07l.83.48a.18.18,0,0,1,.06.24A.16.16,0,0,1,580.29,121.71Zm-2.48-1.43-.09,0-.83-.48a.18.18,0,0,1-.06-.24.17.17,0,0,1,.24-.07l.83.48a.18.18,0,0,1,.06.24A.16.16,0,0,1,577.81,120.28Zm-2.48-1.43-.09,0-.82-.48a.17.17,0,0,1-.07-.24.18.18,0,0,1,.25-.07l.82.48a.17.17,0,0,1,.07.24A.19.19,0,0,1,575.33,118.85Zm-2.47-1.43a.13.13,0,0,1-.09,0l-.83-.48a.18.18,0,0,1-.06-.24.17.17,0,0,1,.24-.07l.83.48a.18.18,0,0,1,.06.24A.16.16,0,0,1,572.86,117.42ZM570.38,116a.15.15,0,0,1-.09,0l-.83-.48a.18.18,0,0,1-.06-.24.17.17,0,0,1,.24-.07l.83.48a.18.18,0,0,1,.06.24A.16.16,0,0,1,570.38,116Zm-2.48-1.43a.15.15,0,0,1-.09,0l-.82-.48a.17.17,0,0,1-.07-.24.18.18,0,0,1,.25-.07l.82.48a.17.17,0,0,1,.07.24A.19.19,0,0,1,567.9,114.56Zm-2.47-1.43a.15.15,0,0,1-.09,0l-.83-.48a.18.18,0,0,1-.06-.24.18.18,0,0,1,.24-.07l.83.48a.18.18,0,0,1,.06.24A.16.16,0,0,1,565.43,113.13ZM563,111.7a.15.15,0,0,1-.09,0l-.82-.48A.17.17,0,0,1,562,111a.18.18,0,0,1,.24-.07l.83.48a.18.18,0,0,1,.06.24A.16.16,0,0,1,563,111.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M580.19,74.6a.16.16,0,0,1-.09,0l-.83-.47a.19.19,0,0,1-.06-.25.18.18,0,0,1,.24-.06l.83.47a.18.18,0,0,1-.09.34Zm-2.48-1.43a.16.16,0,0,1-.09,0l-.82-.47a.18.18,0,0,1-.07-.25.19.19,0,0,1,.25-.06l.82.47a.18.18,0,0,1,.07.25A.22.22,0,0,1,577.71,73.17Zm-2.47-1.43a.12.12,0,0,1-.09,0l-.83-.47a.18.18,0,0,1-.06-.25.17.17,0,0,1,.24-.06l.82.47a.18.18,0,0,1,.07.25A.19.19,0,0,1,575.24,71.74Zm-2.48-1.43-.09,0-.83-.47a.19.19,0,0,1-.06-.25.18.18,0,0,1,.24-.06l.83.47a.18.18,0,0,1-.09.34Zm-2.48-1.43a.16.16,0,0,1-.09,0l-.82-.47a.18.18,0,0,1-.07-.25.19.19,0,0,1,.25-.06l.82.47a.18.18,0,0,1,.07.25A.19.19,0,0,1,570.28,68.88Zm-2.47-1.43a.14.14,0,0,1-.09,0l-.83-.47a.19.19,0,0,1-.06-.25.18.18,0,0,1,.24-.06l.83.47a.19.19,0,0,1,.06.25A.16.16,0,0,1,567.81,67.45ZM565.33,66a.16.16,0,0,1-.09,0l-.83-.47a.19.19,0,0,1-.06-.25.18.18,0,0,1,.24-.06l.83.47a.19.19,0,0,1,.06.25A.16.16,0,0,1,565.33,66Zm-2.48-1.43a.16.16,0,0,1-.09,0l-.82-.47a.18.18,0,0,1-.07-.25.19.19,0,0,1,.25-.06l.82.47a.18.18,0,0,1,.07.25A.19.19,0,0,1,562.85,64.59Zm-2.47-1.43a.14.14,0,0,1-.09,0l-.83-.47a.19.19,0,0,1-.06-.25.18.18,0,0,1,.24-.06l.83.47a.19.19,0,0,1,.06.25A.16.16,0,0,1,560.38,63.16Zm-2.48-1.43-.09,0-.82-.47a.18.18,0,0,1-.07-.25.18.18,0,0,1,.24-.06l.83.47a.19.19,0,0,1,.06.25A.16.16,0,0,1,557.9,61.73Zm-2.48-1.43-.09,0-.82-.47a.18.18,0,0,1-.07-.25.19.19,0,0,1,.25-.06l.82.47a.18.18,0,0,1,.07.25A.19.19,0,0,1,555.42,60.3ZM553,58.87a.16.16,0,0,1-.09,0l-.83-.47a.19.19,0,0,1-.06-.25.18.18,0,0,1,.24-.06l.83.47a.19.19,0,0,1,.06.25A.16.16,0,0,1,553,58.87Zm-2.48-1.43a.16.16,0,0,1-.09,0l-.82-.47a.18.18,0,0,1-.07-.25.18.18,0,0,1,.24-.06l.83.47a.18.18,0,0,1,.06.25A.16.16,0,0,1,550.47,57.44ZM548,56a.16.16,0,0,1-.09,0l-.82-.47a.18.18,0,0,1-.07-.25.19.19,0,0,1,.25-.06l.82.48a.17.17,0,0,1,.07.24A.18.18,0,0,1,548,56Zm-2.47-1.43-.09,0-.83-.47a.19.19,0,0,1-.06-.25.18.18,0,0,1,.24-.06l.83.48a.17.17,0,0,1,.06.24A.16.16,0,0,1,545.52,54.58ZM543,53.15l-.09,0-.82-.48a.18.18,0,0,1-.07-.25.18.18,0,0,1,.24-.06l.83.48a.18.18,0,0,1,.07.24A.19.19,0,0,1,543,53.15Zm-2.48-1.43-.09,0-.82-.48a.18.18,0,0,1-.07-.25.19.19,0,0,1,.25-.06l.82.48a.18.18,0,0,1-.09.33Zm-2.47-1.43-.09,0-.83-.48a.19.19,0,0,1-.06-.25.18.18,0,0,1,.24-.06l.83.48a.18.18,0,0,1,.06.24A.16.16,0,0,1,538.09,50.29Zm-2.48-1.43-.09,0-.82-.48a.18.18,0,0,1-.07-.25.19.19,0,0,1,.25-.06l.82.48a.18.18,0,0,1,.07.24A.19.19,0,0,1,535.61,48.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M541.91,146.33l-.09,0-.83-.48a.19.19,0,0,1-.06-.25.18.18,0,0,1,.24-.06l.83.48a.18.18,0,0,1,.06.24A.16.16,0,0,1,541.91,146.33Zm-2.48-1.43-.09,0-.82-.48a.18.18,0,0,1-.07-.25.19.19,0,0,1,.25-.06l.82.48a.17.17,0,0,1,.07.24A.19.19,0,0,1,539.43,144.9ZM537,143.47l-.09,0L536,143a.19.19,0,0,1-.07-.25.19.19,0,0,1,.25-.06l.82.48a.17.17,0,0,1,.07.24A.16.16,0,0,1,537,143.47ZM534.48,142l-.09,0-.83-.48a.18.18,0,0,1-.06-.24.17.17,0,0,1,.24-.07l.83.48a.18.18,0,0,1,.06.24A.16.16,0,0,1,534.48,142ZM532,140.61l-.09,0-.82-.48a.17.17,0,0,1-.07-.24.18.18,0,0,1,.25-.07l.82.48a.17.17,0,0,1,.07.24A.19.19,0,0,1,532,140.61Zm-2.47-1.43-.09,0-.83-.48a.18.18,0,0,1,.18-.31l.82.48a.17.17,0,0,1,.07.24A.16.16,0,0,1,529.53,139.18Zm-2.48-1.43-.09,0-.83-.48a.18.18,0,0,1-.06-.24.17.17,0,0,1,.24-.07l.83.48a.18.18,0,0,1,.06.24A.16.16,0,0,1,527.05,137.75Zm-2.48-1.43-.09,0-.82-.48a.17.17,0,0,1-.07-.24.18.18,0,0,1,.25-.07l.82.48a.17.17,0,0,1,.07.24A.19.19,0,0,1,524.57,136.32Zm-2.47-1.43-.09,0-.83-.48a.18.18,0,0,1-.06-.24.17.17,0,0,1,.24-.07l.83.48a.18.18,0,0,1,.06.24A.16.16,0,0,1,522.1,134.89Zm-2.48-1.43-.09,0-.83-.48a.18.18,0,0,1-.06-.24.17.17,0,0,1,.24-.07l.83.48a.18.18,0,0,1,.06.24A.16.16,0,0,1,519.62,133.46ZM517.14,132l-.09,0-.82-.48a.17.17,0,0,1-.07-.24.18.18,0,0,1,.25-.07l.82.48a.17.17,0,0,1,.07.24A.19.19,0,0,1,517.14,132Zm-2.47-1.43-.09,0-.83-.48a.18.18,0,0,1-.06-.24.17.17,0,0,1,.24-.07l.83.48a.18.18,0,0,1,.06.24A.16.16,0,0,1,514.67,130.6Zm-2.48-1.43-.09,0-.83-.48a.18.18,0,0,1-.06-.24.17.17,0,0,1,.24-.07l.83.48a.18.18,0,0,1,.06.24A.16.16,0,0,1,512.19,129.17Zm-2.48-1.43-.09,0-.82-.48a.17.17,0,0,1-.07-.24.18.18,0,0,1,.25-.07l.82.48a.17.17,0,0,1,.07.24A.17.17,0,0,1,509.71,127.74Zm-2.47-1.43-.09,0-.83-.48a.18.18,0,0,1-.06-.24.17.17,0,0,1,.24-.07l.83.48a.18.18,0,0,1,.06.24A.16.16,0,0,1,507.24,126.31Zm-2.48-1.43-.09,0-.82-.48a.18.18,0,0,1,.17-.31l.83.48a.17.17,0,0,1,.06.24A.16.16,0,0,1,504.76,124.88Zm-2.48-1.43-.09,0-.82-.48a.17.17,0,0,1-.07-.24.18.18,0,0,1,.25-.07l.82.48a.17.17,0,0,1,.07.24A.17.17,0,0,1,502.28,123.45ZM499.81,122l-.09,0-.83-.48a.18.18,0,0,1-.06-.24.17.17,0,0,1,.24-.07l.83.48a.18.18,0,0,1,.06.24A.16.16,0,0,1,499.81,122Zm-2.48-1.43-.09,0-.82-.48a.18.18,0,1,1,.17-.31l.83.48a.18.18,0,0,1,.07.24A.19.19,0,0,1,497.33,120.59Zm-2.48-1.43-.09,0-.82-.48a.17.17,0,0,1-.07-.24.18.18,0,0,1,.25-.07l.82.48a.17.17,0,0,1,.07.24A.17.17,0,0,1,494.85,119.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M547.62,164.6A21,21,0,0,1,537,161.87c-7.63-4.41-11.83-13.67-11.83-26.07,0-25.68,18.2-57.07,40.57-70,10.91-6.3,21.16-7.32,28.86-2.87S606.44,76.61,606.44,89c0,25.68-18.21,57.07-40.58,70C559.42,162.72,553.21,164.6,547.62,164.6ZM584,60.45c-5.55,0-11.72,1.87-18.12,5.57-22.31,12.88-40.45,44.18-40.45,69.78,0,12.31,4.16,21.5,11.71,25.86s17.79,3.39,28.62-2.87C588.05,145.91,606.2,114.61,606.2,89c0-12.31-4.16-21.5-11.72-25.86A20.73,20.73,0,0,0,584,60.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M205.47,197.21c-1.69,0-3.29,1.83-4.35,3.32-.78,1.1-3.86,1.66-6.38,1.65a7.88,7.88,0,0,0,0,4.7c4.47-1.11,8.78-4,9.11-4.51a3.63,3.63,0,0,1,4-1.61c2.3.35,2.86-.76,2.85-1.4S207.17,197.24,205.47,197.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M194.74,202.18a11,11,0,0,1-2.33-.23c-2.4-.57-4.1-6.07-3.55-10.4.51-4-3.93-7.34-5.94-3.65-.28.51.11,1.71.07,2.29-.18,2.63-.39,11.06,3.78,15.34,2,2.05,5,2.09,8,1.35A7.88,7.88,0,0,1,194.74,202.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "172.76 209.6 172.52 215.04 181.19 223.44 187.91 213.49 188.19 210.06 188.66 207.03 172.76 209.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M185.53,187.11l-.6.3c-1,.71-2.3,8.14-3.53,10.11-2.52,4.07-5.87,29.32-.43,27.16a9.81,9.81,0,0,0,7.2-2c3.46-2.55,4.3-7.87,4.28-13.35C192.4,192.28,185.53,187.11,185.53,187.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M172.52,215s-4.21,15.07-1.76,21.25c2,4.9,20-.6,20-.6s2.45-8,15.09-8.68c0,0-8-7.06-14.88-9.47-.91-.32-3.16-2.27-3-4.06C187.91,213.48,185.58,216.28,172.52,215Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M177.58,187.69s.33-.17,1.34-.57a13.78,13.78,0,0,1,6.33-.9s4.73,6.14,5.9,9.15c.92,2.36-1.25,15.65-1.85,19.22-.16.94-1,1.4-1.87,1.77-4.94,2-13.07,2.24-16.67,1.17C170.76,217.53,173.53,190,177.58,187.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M181.21,180.66s0,.7-.06,2.6a5,5,0,0,1-2.88,4.13s1.91,4.73,5.11,5.38,6.16-1.2,2.12-6.48a1.76,1.76,0,0,1-.81-1.28l.23-2.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M180.17,171s2.08-8.71-4.56-8.48-4,9.6,1.5,11.33S180.17,171,180.17,171Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M190.13,175.91a3.11,3.11,0,0,0,1-2.53c-.21-2.31-2.79-1.73-4.21-2.74s-4.08-3.44-6.55-1.47c-3,2.38-5.73,2-4.44,8.1,1.09,5.18,7.15,4.48,7.15,4.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M189.35,175.36s0,1.07-.08,3.13c-.15,3.44-1.47,5-2,5.44s-2.19,1-4.77-1.26a3.18,3.18,0,0,1-.8-4.47c0-.07.09-.74.21-1.57a3.25,3.25,0,0,1,3.92-2.74A9,9,0,0,1,189.35,175.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M177.58,187.69a5.78,5.78,0,0,0-2.19,1c-1,.71-2.3,8.13-3.52,10.11-2.52,4.07-5.88,29.32-.44,27.16a9.81,9.81,0,0,0,7.2-2c3.46-2.55,4.3-7.87,4.28-13.35C182.86,193.56,177.58,187.69,177.58,187.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M193,203.7c-1.63-.47-3.65.93-5,2.1-1,.86-4.16.61-6.59-.05a7.89,7.89,0,0,0-1.17,4.56c4.6.07,9.51-1.61,10-2a3.64,3.64,0,0,1,4.25-.54c2.14.93,3,0,3.11-.62S194.59,204.16,193,203.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M181.31,205.75a10.67,10.67,0,0,1-2.19-.81c-2.18-1.17-2.41-6.92-.78-11,1.53-3.78-1.57-7.36-4.46-4.31a4.07,4.07,0,0,0-.87,1.49c-.84,2.5-3.2,10.59-.27,15.8,1.4,2.49,4.33,3.31,7.4,3.35A7.89,7.89,0,0,1,181.31,205.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M179.07,210.5c-3.2-.25-5.4-1.4-6.53-3.42a12,12,0,0,1-1.39-4.89l.46,0a11.69,11.69,0,0,0,1.33,4.7c1.06,1.87,3.13,2.94,6.16,3.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M180.06,205.61a9.89,9.89,0,0,1-1.05-.46c-2.22-1.19-2.45-6.32-1.27-10.17l.44.13c-1.22,4-.71,8.68,1,9.62a7.25,7.25,0,0,0,1,.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M263.69,467c-23,0-46-5.07-63.56-15.2-17.08-9.86-26.48-23-26.48-36.91s9.26-26.77,26.09-36.49c34.73-20.05,91.43-19.95,126.38.23,17.08,9.86,26.48,23,26.48,36.91s-9.26,26.77-26.08,36.49l-.18-.32.18.32C309.22,462.05,286.48,467,263.69,467Zm-1.12-102.85c-22.66,0-45.27,5-62.47,14.89-16.58,9.57-25.72,22.31-25.72,35.85s9.28,26.55,26.12,36.27c34.75,20.07,91.12,20.17,125.65.23,16.59-9.57,25.72-22.31,25.72-35.85S342.6,389,325.76,379.31C308.31,369.23,285.41,364.19,262.57,364.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M263.83,483.19c-28.93,0-57.92-6.39-80-19.15-21.48-12.4-33.31-28.88-33.31-46.41,0-17.37,11.65-33.67,32.81-45.88,43.74-25.25,115.12-25.13,159.13.28,21.49,12.41,33.32,28.89,33.32,46.42,0,17.37-11.66,33.66-32.82,45.88l-.18-.32.18.32C321.16,476.9,292.53,483.19,263.83,483.19Zm-1.41-129.58c-28.56,0-57.06,6.25-78.74,18.77-20.93,12.08-32.45,28.15-32.45,45.25,0,17.26,11.7,33.51,33,45.78,43.8,25.29,114.86,25.42,158.4.29C363.5,451.61,375,435.54,375,418.45c0-17.26-11.71-33.52-32.95-45.78C320.09,360,291.22,353.61,262.42,353.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M264,503.7c-37,0-74.16-8.17-102.45-24.5C134.1,463.33,119,442.25,119,419.84c0-22.22,14.91-43.06,42-58.69,56-32.33,147.39-32.16,203.73.37,27.49,15.87,42.62,37,42.62,59.36,0,22.21-14.91,43.05-42,58.68C337.43,495.66,300.77,503.7,264,503.7Zm-1.81-166c-36.61,0-73.13,8-100.91,24.05-26.84,15.49-41.62,36.11-41.62,58,0,22.14,15,43,42.26,58.72C190.13,494.84,227.13,503,264,503c36.61,0,73.13-8,100.91-24.05,26.84-15.49,41.62-36.11,41.62-58.05,0-22.14-15-43-42.25-58.73C336.12,345.88,299.13,337.74,262.22,337.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M264.49,546.92c-55.57,0-111.25-12.26-153.69-36.76-41.19-23.79-63.88-55.37-63.88-88.94,0-33.28,22.35-64.5,62.93-87.93,84-48.49,221.08-48.24,305.6.55,41.19,23.79,63.88,55.37,63.88,88.94,0,33.28-22.35,64.5-62.92,87.93C374.59,534.85,319.59,546.92,264.49,546.92Zm-2.72-249.11c-55,0-109.83,12-151.56,36.12-40.34,23.29-62.55,54.29-62.55,87.29,0,33.29,22.55,64.65,63.51,88.3,84.32,48.68,221.08,48.93,304.87.55l.18.32-.18-.32c40.34-23.29,62.56-54.29,62.56-87.29,0-33.29-22.56-64.66-63.51-88.3C372.76,310,317.2,297.81,261.77,297.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M297.87,412.68a4.9,4.9,0,0,1,.45,8.71L255,446.44a12.11,12.11,0,0,1-13.81-1.18l-31.76-26.4L254,393.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "297.94 413.14 298.71 413.52 298.71 416.25 298.25 416.67 297.54 415.94 297.63 414.64 297.94 413.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M295.93,411.85a4.71,4.71,0,0,1,.43,8.38l-41.73,24.09a11.64,11.64,0,0,1-13.28-1.13l-30.56-25.4L253.71,393Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M295.93,409.31a4.71,4.71,0,0,1,.43,8.38l-41.73,24.09a11.66,11.66,0,0,1-13.28-1.13l-30.56-25.4,42.92-24.78Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "253.71 390.47 210.79 415.25 230.94 432 281.45 402.88 253.71 390.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M298.72,413.39a4.8,4.8,0,0,0-.53-1.95,5.48,5.48,0,0,1,.3,1.91,4.63,4.63,0,0,1-2.44,3.74l-41.92,24.13a15,15,0,0,1-6.43,1.66,13,13,0,0,1-5.31-1.46,11.39,11.39,0,0,0,12.08.38l41.91-24.13A4.65,4.65,0,0,0,298.72,413.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M374.44,324.3l-246.07,144c-4,2.29-8.58-2.49-8.58-7.77V264.71c0-5.28,3.42-11.44,7.82-14.06L372.82,109.07c4.27-2.48,10.38-.09,9.81,5.07l-1,196.46C381.61,315.88,378.4,322,374.44,324.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M375.8,325.91,129.26,468.25c-4,2.28-8.11-.85-8.11-6.13V266.32c0-5.27,3.42-11.43,7.82-14l245.89-142c4-2.29,8.11.85,8.11,6.13V312.21C383,317.49,379.76,323.62,375.8,325.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M375.25,110.05,129,252.27a16.88,16.88,0,0,0-7.69,13.31v172.5L382.83,287V114.46C382.83,109.54,379.53,107.58,375.25,110.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M373.61,279a2.54,2.54,0,0,1-1.26,2.2l-238,137.39a1.76,1.76,0,0,1-1.75,0,1.73,1.73,0,0,1-.87-1.51V265.4a2.52,2.52,0,0,1,1.27-2.19l238-137.4a1.74,1.74,0,0,1,2.61,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M133.5,419.16a2.09,2.09,0,0,1-1.05-.28,2.12,2.12,0,0,1-1-1.82V265.4a2.89,2.89,0,0,1,1.45-2.5l238-137.39a2.1,2.1,0,0,1,3.15,1.81V279a2.9,2.9,0,0,1-1.45,2.51l-238,137.39A2,2,0,0,1,133.5,419.16Zm239.06-293a1.41,1.41,0,0,0-1.38,0l-238,137.4a2.18,2.18,0,0,0-1.09,1.88V417.06a1.37,1.37,0,0,0,.69,1.2,1.38,1.38,0,0,0,1.39,0l238-137.39a2.19,2.19,0,0,0,1.09-1.89V127.32A1.4,1.4,0,0,0,372.56,126.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M380.64,109.43c-1.93-1.14-4.41-.18-6.15.82L129.12,251.93c-4.47,2.66-8,9-8,14.34V461.64a9.21,9.21,0,0,0,.51,3.08,5.46,5.46,0,0,1,.43-1.1,9,9,0,0,1-.22-2V266.27c0-5.15,3.35-11.18,7.62-13.72L374.85,110.88c5.53-3.18,6.93,0,7.23.07A4,4,0,0,0,380.64,109.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M257.87,383.32a3.16,3.16,0,0,1-1.61-.41,4.09,4.09,0,0,1-1.77-3.76,11.86,11.86,0,0,1,5.37-9.27,4.16,4.16,0,0,1,4.19-.36,4.08,4.08,0,0,1,1.77,3.76,11.86,11.86,0,0,1-5.37,9.27A5.32,5.32,0,0,1,257.87,383.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M249.54,189.67a4.32,4.32,0,0,1-2,3.39c-1.09.63-2,.13-2-1.12a4.34,4.34,0,0,1,2-3.39C248.66,187.92,249.54,188.42,249.54,189.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M426.74,447l2.61-1.47c.06,0,78.66-43.21,78.66-43.28S477.51,385,477.51,385l-80.9,44.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M426,445.24a.37.37,0,0,1-.37-.37V269.11a.37.37,0,0,1,.19-.32l25.79-14.89a.37.37,0,0,1,.31,0,.37.37,0,0,1,.22.22l51,148.08a.38.38,0,0,1-.23.47.37.37,0,0,1-.47-.23L451.54,254.76l-25.22,14.56V444.87A.37.37,0,0,1,426,445.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M400,430.31a.37.37,0,0,1-.37-.37V254.18a.37.37,0,0,1,.18-.32L425.62,239a.34.34,0,0,1,.31,0,.39.39,0,0,1,.22.23l51,148a.37.37,0,0,1-.23.47.36.36,0,0,1-.46-.23L425.6,239.82l-25.23,14.57V429.94A.37.37,0,0,1,400,430.31Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 412.61,
    y: 410.95,
    width: 0.73,
    height: 29.96,
    transform: "translate(-162.38 570.62) rotate(-60)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 412.61,
    y: 261.21,
    width: 0.73,
    height: 29.96,
    transform: "translate(-32.7 495.74) rotate(-60)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 483.59,
    y: 362.62,
    width: 0.73,
    height: 29.98,
    transform: "translate(-85.06 607.88) rotate(-60)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 479.91,
    y: 352.21,
    width: 0.73,
    height: 29.98,
    transform: "matrix(0.5, -0.87, 0.87, 0.5, -77.88, 599.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 476.44,
    y: 342.05,
    width: 0.73,
    height: 29.98,
    transform: "translate(-70.82 591.41) rotate(-60)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 472.88,
    y: 332,
    width: 0.73,
    height: 29.98,
    transform: "translate(-63.89 583.31) rotate(-60)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 469.21,
    y: 321.59,
    width: 0.73,
    height: 29.98,
    transform: "translate(-56.72 574.92) rotate(-60)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 465.73,
    y: 311.43,
    width: 0.73,
    height: 29.98,
    transform: "translate(-49.66 566.83) rotate(-60)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 462.23,
    y: 301.17,
    width: 0.73,
    height: 29.98,
    transform: "translate(-42.53 558.67) rotate(-60)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 458.67,
    y: 290.93,
    width: 0.73,
    height: 29.98,
    transform: "matrix(0.5, -0.87, 0.87, 0.5, -35.43, 550.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 455.21,
    y: 280.6,
    width: 0.73,
    height: 29.98,
    transform: "translate(-28.22 542.31) rotate(-60)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 451.8,
    y: 270.82,
    width: 0.73,
    height: 29.98,
    transform: "translate(-21.46 534.46) rotate(-60)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 448.21,
    y: 260.33,
    width: 0.73,
    height: 29.98,
    transform: "translate(-14.16 526.1) rotate(-60)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 444.68,
    y: 250.13,
    width: 0.73,
    height: 29.98,
    transform: "translate(-7.09 517.96) rotate(-60)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 441.21,
    y: 240.05,
    width: 0.73,
    height: 29.98,
    transform: "matrix(0.5, -0.87, 0.87, 0.5, -0.09, 509.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 486.83,
    y: 372.55,
    width: 0.73,
    height: 29.98,
    transform: "translate(-92.03 615.65) rotate(-60)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "425.96 270.16 399.59 254.88 399.59 253.72 426.51 239.28 452.88 253.41 452.88 254.57 425.96 270.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "425.96 269 399.59 253.72 426.51 238.13 452.88 253.41 425.96 269"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M395.68,206.67a23.78,23.78,0,0,1-3-3.12c-.52-.92.73-2.5,1.23-3.89s.6-8.86.9-10.7c.25-1.51.64-3.4,1.75-4.55a2.6,2.6,0,0,1,2.27.09c1.05.84,2.77,2,1.76,4.44-1.38,3.35-4.65,9.92-3.8,11s1,4.09,0,4.39S396.32,206.07,395.68,206.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M395.68,206.67a23.78,23.78,0,0,1-3-3.12c-.52-.92.73-2.5,1.23-3.89s.6-8.86.9-10.7c.25-1.51.64-3.4,1.75-4.55a2.6,2.6,0,0,1,2.27.09c1.05.84,2.77,2,1.76,4.44-1.38,3.35-4.65,9.92-3.8,11s1,4.09,0,4.39S396.32,206.07,395.68,206.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M326,331.39a4,4,0,0,0-3.6,2.19,1.33,1.33,0,0,1,.14-.53c.26-.45.69-.82.43-1.43a3.1,3.1,0,0,0-1.48,2.37c0,.22.07.79.1,1.06l-.2.41c-17.42,9.67-14.15,28.64-14.15,28.64s2.13.38,4.41-4.39c-.07-12.94,11.45-23.4,11.45-23.4a11.71,11.71,0,0,0,3.34-2.32A1.78,1.78,0,0,0,326,331.39Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-69"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "326.45 366.23 306.45 275.4 396.71 192.91 397.56 192.6 417.41 282.68 416.98 284.02 326.81 366.45 326.45 366.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "304.69 274.65 304.8 274.8 306.29 275.49 396.9 193.13 397.24 192.14 395.42 191.55 394.73 191.66 304.43 274.34 304.69 274.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "306.45 275.4 326.45 366.23 326.16 366.6 324.58 366.01 324.2 365.65 304.19 274.81 304.63 274.95 304.77 274.81 306.45 275.4"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "396.71 192.91 306.45 275.4 309.01 287.06 399.28 204.57 400.04 203.83 397.56 192.6 396.71 192.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "326.15 366.6 326.82 366.45 306.8 275.57 397.55 192.6 397.24 192.14 306.25 275.3 326.15 366.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "306.33 275.65 306.47 275.1 304.43 274.34 304.19 274.81 306.33 275.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M315.59,274.57a2.71,2.71,0,0,1-.74,2.34c-.58.53-1.19.34-1.36-.42a2.73,2.73,0,0,1,.75-2.34C314.82,273.62,315.43,273.8,315.59,274.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M319.1,271.36a2.71,2.71,0,0,1-.74,2.34c-.58.53-1.19.34-1.36-.42a2.71,2.71,0,0,1,.75-2.34C318.33,270.41,318.93,270.6,319.1,271.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M322.61,268.15a2.71,2.71,0,0,1-.74,2.34c-.58.53-1.19.34-1.36-.42a2.71,2.71,0,0,1,.75-2.34C321.84,267.2,322.44,267.39,322.61,268.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "325.09 316.7 318.66 287.47 394.46 218.2 395.15 217.8 401.53 246.78 401.34 247.26 325.44 316.62 325.09 316.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "316.77 286.64 316.71 286.86 318.52 287.54 394.62 218.38 394.36 217.41 393.1 217.03 391.97 217.29 316.72 286.2 316.77 286.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "318.66 287.47 325.09 316.7 324.71 316.78 322.96 316.24 322.6 315.94 316.16 286.71 316.47 286.67 316.69 286.88 318.66 287.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M392.66,217.73l1.13.33-75.46,68.59-.6-.28Zm-.2-.89-76.28,69.87,2.34.83,76.59-69.61a.18.18,0,0,0,.06-.17.2.2,0,0,0-.12-.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "332.98 352.4 326.49 322.96 349.34 302.22 350.03 301.82 356.46 331.01 356.26 331.5 333.32 352.32 332.98 352.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "324.6 322.13 324.53 322.35 326.36 323.04 349.5 302.4 349.23 301.43 347.97 301.04 346.82 301.31 324.54 321.68 324.6 322.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "326.49 322.96 332.98 352.4 332.6 352.49 330.82 351.94 330.46 351.64 323.98 322.19 324.29 322.15 324.51 322.36 326.49 322.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M347.52,301.75l1.14.34-22.5,20-.61-.28Zm-.2-.9L324,322.19l2.37.84L350,302a.18.18,0,0,0,.06-.17.2.2,0,0,0-.12-.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "359.44 328.18 352.96 298.75 375.8 278 376.5 277.6 382.93 306.79 382.73 307.28 359.79 328.11 359.44 328.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "351.06 297.91 351 298.13 352.82 298.82 375.96 278.19 375.7 277.21 374.44 276.83 373.29 277.09 351 297.47 351.06 297.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "352.96 298.75 359.44 328.18 359.06 328.27 357.29 327.73 356.93 327.42 350.45 297.98 350.76 297.94 350.97 298.14 352.96 298.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M374,277.54l1.13.33-22.49,20-.61-.28Zm-.2-.91L350.46,298l2.36.84,23.64-21.08a.16.16,0,0,0,.05-.17.17.17,0,0,0-.12-.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-91",
    points: "385.95 304.13 379.46 274.7 402.31 253.95 403 253.55 409.43 282.74 409.23 283.23 386.29 304.06 385.95 304.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "377.57 273.86 377.5 274.08 379.33 274.77 402.47 254.14 402.2 253.16 400.94 252.78 399.79 253.04 377.51 273.42 377.57 273.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "379.46 274.7 385.95 304.13 385.56 304.22 383.79 303.68 383.44 303.37 376.95 273.93 377.26 273.89 377.48 274.1 379.46 274.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M400.49,253.49l1.14.33-22.5,20.05-.61-.29Zm-.2-.91L377,273.93l2.37.84L403,253.69a.18.18,0,0,0-.06-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M333.84,334.36a.23.23,0,0,1-.19-.06.21.21,0,0,1,0-.29l1.44-1.31a.19.19,0,0,1,.28,0,.21.21,0,0,1,0,.29l-1.43,1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M336.12,332.28a.22.22,0,0,1-.19-.06.2.2,0,0,1,0-.29l4.12-3.76a.19.19,0,0,1,.28,0,.21.21,0,0,1,0,.29l-4.12,3.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M341.05,327.78a.24.24,0,0,1-.2-.06.21.21,0,0,1,0-.29l2.5-2.29a.21.21,0,0,1,.29,0,.19.19,0,0,1,0,.28l-2.5,2.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M334.18,335.87a.24.24,0,0,1-.2-.06.21.21,0,0,1,0-.29l3.2-2.93a.22.22,0,0,1,.29,0,.21.21,0,0,1,0,.29l-3.2,2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M338.22,332.17a.23.23,0,0,1-.19-.06.22.22,0,0,1,0-.29l3.42-3.12a.22.22,0,0,1,.29,0,.21.21,0,0,1,0,.29l-3.41,3.12A.19.19,0,0,1,338.22,332.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M342.45,328.31a.21.21,0,0,1-.2-.06.21.21,0,0,1,0-.29l1.43-1.3a.19.19,0,0,1,.28,0,.21.21,0,0,1,0,.29l-1.43,1.3A.2.2,0,0,1,342.45,328.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M333.51,332.85a.2.2,0,0,1-.19-.07.19.19,0,0,1,0-.28l1.93-1.76a.19.19,0,0,1,.28,0,.21.21,0,0,1,0,.29l-1.93,1.76A.19.19,0,0,1,333.51,332.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M339.83,327.07a.2.2,0,0,1-.2-.06.21.21,0,0,1,0-.29l1.16-1.06a.21.21,0,0,1,.28.3L339.92,327A.14.14,0,0,1,339.83,327.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M336.28,330.32a.2.2,0,0,1-.19-.07.19.19,0,0,1,0-.28l2.75-2.52a.21.21,0,0,1,.29,0,.19.19,0,0,1,0,.28l-2.75,2.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M341.8,325.27a.22.22,0,0,1-.19-.06.21.21,0,0,1,0-.29l1.41-1.29a.21.21,0,0,1,.29,0,.2.2,0,0,1,0,.28l-1.41,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M333.18,331.33a.2.2,0,0,1-.2-.06.2.2,0,0,1,0-.28l2.57-2.35a.19.19,0,0,1,.28,0,.21.21,0,0,1,0,.29l-2.57,2.35A.18.18,0,0,1,333.18,331.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M336.59,328.22a.2.2,0,0,1-.19-.07.19.19,0,0,1,0-.28l2.75-2.52a.21.21,0,0,1,.29,0,.21.21,0,0,1,0,.29l-2.76,2.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M340.15,325a.2.2,0,0,1-.19-.06.21.21,0,0,1,0-.29l2.73-2.49a.22.22,0,0,1,.29,0,.21.21,0,0,1,0,.29l-2.72,2.49A.19.19,0,0,1,340.15,325Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M335.51,341.9a.24.24,0,0,1-.2-.06.21.21,0,0,1,0-.29l1.44-1.31a.2.2,0,0,1,.28,0,.2.2,0,0,1,0,.29l-1.43,1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M337.78,339.82a.22.22,0,0,1-.19-.06.21.21,0,0,1,0-.29l4.12-3.76a.19.19,0,0,1,.28,0,.21.21,0,0,1,0,.29l-4.12,3.76A.16.16,0,0,1,337.78,339.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M342.71,335.32a.24.24,0,0,1-.2-.06.21.21,0,0,1,0-.29l2.5-2.29a.2.2,0,0,1,.27.3l-2.5,2.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M335.84,343.41a.25.25,0,0,1-.2-.06.22.22,0,0,1,0-.29l3.2-2.93a.21.21,0,0,1,.29,0,.2.2,0,0,1,0,.28l-3.21,2.93A.2.2,0,0,1,335.84,343.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M339.89,339.71a.21.21,0,0,1-.2-.06.21.21,0,0,1,0-.29l3.41-3.12a.22.22,0,0,1,.29,0,.21.21,0,0,1,0,.29L340,339.66A.2.2,0,0,1,339.89,339.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M344.11,335.85a.18.18,0,0,1-.19-.06.21.21,0,0,1,0-.29l1.43-1.3a.2.2,0,1,1,.27.3l-1.43,1.3A.2.2,0,0,1,344.11,335.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M335.17,340.39a.2.2,0,0,1-.19-.07.19.19,0,0,1,0-.28l1.93-1.76a.19.19,0,0,1,.28,0,.21.21,0,0,1,0,.29l-1.92,1.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M341.49,334.61a.18.18,0,0,1-.19-.06.19.19,0,0,1,0-.28l1.16-1.07a.21.21,0,1,1,.28.3l-1.17,1.07A.15.15,0,0,1,341.49,334.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M337.94,337.86a.22.22,0,0,1-.19-.06.2.2,0,0,1,0-.29l2.75-2.51a.2.2,0,1,1,.27.3L338,337.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M343.46,332.81a.23.23,0,0,1-.19-.06.21.21,0,0,1,0-.29l1.41-1.29a.21.21,0,0,1,.29,0,.2.2,0,0,1,0,.28l-1.41,1.29A.19.19,0,0,1,343.46,332.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M334.84,338.87a.18.18,0,0,1-.19-.06.19.19,0,0,1,0-.28l2.57-2.35a.21.21,0,0,1,.29,0,.22.22,0,0,1,0,.29l-2.57,2.35A.15.15,0,0,1,334.84,338.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M338.25,335.76a.2.2,0,0,1-.19-.07.19.19,0,0,1,0-.28l2.76-2.52a.2.2,0,0,1,.28,0,.2.2,0,0,1,0,.29l-2.75,2.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M341.81,332.5a.18.18,0,0,1-.19-.06.21.21,0,0,1,0-.29l2.73-2.49a.22.22,0,0,1,.29,0,.21.21,0,0,1,0,.29l-2.72,2.49A.19.19,0,0,1,341.81,332.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M383.25,279.86a.18.18,0,0,1-.18-.05.19.19,0,0,1,0-.26l1.31-1.2a.19.19,0,0,1,.25.28l-1.31,1.19A.12.12,0,0,1,383.25,279.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M385.32,278a.21.21,0,0,1-.18-.06.18.18,0,0,1,0-.26l3.74-3.42a.19.19,0,0,1,.27,0,.18.18,0,0,1,0,.26l-3.74,3.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M389.81,273.87a.18.18,0,0,1-.18-.06.19.19,0,0,1,0-.26l2.28-2.08a.19.19,0,0,1,.26,0,.2.2,0,0,1,0,.27l-2.28,2.08A.2.2,0,0,1,389.81,273.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M383.55,281.24a.18.18,0,0,1-.17-.06.18.18,0,0,1,0-.26l2.91-2.66a.18.18,0,1,1,.25.27l-2.91,2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M387.24,277.87a.2.2,0,0,1-.18-.05.2.2,0,0,1,0-.27l3.11-2.84a.19.19,0,0,1,.26,0,.19.19,0,0,1,0,.27l-3.11,2.84A.2.2,0,0,1,387.24,277.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M391.08,274.36a.18.18,0,0,1-.17-.06.18.18,0,0,1,0-.26l1.3-1.19a.19.19,0,0,1,.26,0,.18.18,0,0,1,0,.26l-1.3,1.19A.2.2,0,0,1,391.08,274.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M383,278.49a.2.2,0,0,1-.18-.06.19.19,0,0,1,0-.26l1.75-1.6a.18.18,0,0,1,.25.27l-1.75,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M388.7,273.23a.21.21,0,0,1-.18-.06.19.19,0,0,1,0-.26l1.06-1a.19.19,0,1,1,.25.28l-1.06,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M385.47,276.18a.17.17,0,0,1-.18-.05.19.19,0,0,1,0-.26l2.51-2.29a.18.18,0,1,1,.24.27l-2.5,2.29A.12.12,0,0,1,385.47,276.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M390.5,271.59a.2.2,0,0,1-.18-.06.19.19,0,0,1,0-.26l1.28-1.17a.18.18,0,1,1,.25.27l-1.28,1.17A.14.14,0,0,1,390.5,271.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M382.64,277.11a.18.18,0,0,1-.17-.06.18.18,0,0,1,0-.26l2.34-2.14a.19.19,0,0,1,.25.28l-2.34,2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M385.75,274.27a.21.21,0,0,1-.18-.06.18.18,0,0,1,0-.26l2.5-2.29a.19.19,0,0,1,.26,0,.18.18,0,0,1,0,.26l-2.51,2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M389,271.31a.18.18,0,0,1-.17-.06.18.18,0,0,1,0-.26l2.48-2.27a.19.19,0,0,1,.26,0,.18.18,0,0,1,0,.26l-2.48,2.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M385,287.81a.18.18,0,0,1-.18-.05.2.2,0,0,1,0-.27l1.31-1.19a.19.19,0,0,1,.26,0,.2.2,0,0,1,0,.27l-1.31,1.19A.2.2,0,0,1,385,287.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M387.07,285.92a.21.21,0,0,1-.18-.06.19.19,0,0,1,0-.26l3.75-3.43a.19.19,0,0,1,.25.28l-3.75,3.42A.2.2,0,0,1,387.07,285.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M391.56,281.82a.2.2,0,0,1-.18-.06.19.19,0,0,1,0-.26l2.28-2.08a.19.19,0,0,1,.26,0,.2.2,0,0,1,0,.27l-2.28,2.08A.2.2,0,0,1,391.56,281.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M385.3,289.19a.18.18,0,0,1-.17-.06.18.18,0,0,1,0-.26l2.92-2.67a.19.19,0,0,1,.25.28l-2.92,2.66A.2.2,0,0,1,385.3,289.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M389,285.82a.21.21,0,0,1-.18-.06.19.19,0,0,1,0-.26l3.11-2.84a.19.19,0,0,1,.26,0,.18.18,0,0,1,0,.26l-3.11,2.85A.2.2,0,0,1,389,285.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M392.83,282.31a.18.18,0,0,1-.17-.06.18.18,0,0,1,0-.26l1.3-1.19a.18.18,0,0,1,.25.27l-1.3,1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M384.7,286.44a.2.2,0,0,1-.18-.06.19.19,0,0,1,0-.26l1.75-1.6a.18.18,0,1,1,.25.27l-1.75,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M390.45,281.18a.21.21,0,0,1-.18-.06.19.19,0,0,1,0-.26l1.07-1a.18.18,0,1,1,.25.27l-1.07,1A.14.14,0,0,1,390.45,281.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M387.22,284.13a.17.17,0,0,1-.18-.05.2.2,0,0,1,0-.27l2.51-2.28a.18.18,0,0,1,.26,0,.19.19,0,0,1,0,.26l-2.51,2.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M392.25,279.54a.2.2,0,0,1-.18-.06.19.19,0,0,1,0-.26l1.29-1.17a.18.18,0,1,1,.24.27l-1.28,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M384.39,285.06a.18.18,0,0,1-.17-.06.18.18,0,0,1,0-.26l2.34-2.14a.19.19,0,0,1,.25.28L384.48,285A.2.2,0,0,1,384.39,285.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M387.5,282.22a.21.21,0,0,1-.18-.06.19.19,0,0,1,0-.26l2.5-2.29a.19.19,0,0,1,.26,0,.18.18,0,0,1,0,.26l-2.5,2.29A.2.2,0,0,1,387.5,282.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M390.74,279.25a.16.16,0,0,1-.17-.05.18.18,0,0,1,0-.26l2.48-2.27a.19.19,0,0,1,.26,0,.18.18,0,0,1,0,.26l-2.48,2.27A.15.15,0,0,1,390.74,279.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M385.93,252.94a.18.18,0,0,1-.19-.06.19.19,0,0,1,0-.27l1.39-1.27a.2.2,0,0,1,.27.29L386,252.9A.18.18,0,0,1,385.93,252.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M388.13,250.93a.2.2,0,0,1-.18-.06.19.19,0,0,1,0-.28l4-3.64a.19.19,0,0,1,.27,0,.19.19,0,0,1,0,.28l-4,3.64A.13.13,0,0,1,388.13,250.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M392.9,246.57a.16.16,0,0,1-.18-.06.19.19,0,0,1,0-.28l2.42-2.21a.19.19,0,1,1,.26.29L393,246.52A.13.13,0,0,1,392.9,246.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M386.25,254.41a.23.23,0,0,1-.19-.06.2.2,0,0,1,0-.28l3.1-2.84a.2.2,0,0,1,.28,0,.19.19,0,0,1,0,.27l-3.11,2.84A.19.19,0,0,1,386.25,254.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M390.17,250.83a.23.23,0,0,1-.19-.06.2.2,0,0,1,0-.28l3.3-3a.2.2,0,0,1,.27.29l-3.31,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M394.26,247.09a.23.23,0,0,1-.19-.06.2.2,0,0,1,0-.28l1.38-1.27a.2.2,0,0,1,.27.3L394.35,247A.16.16,0,0,1,394.26,247.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M385.61,251.48a.22.22,0,0,1-.19-.06.2.2,0,0,1,0-.28l1.87-1.7a.19.19,0,0,1,.27,0,.19.19,0,0,1,0,.28l-1.86,1.7A.2.2,0,0,1,385.61,251.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M391.73,245.89a.22.22,0,0,1-.19-.06.19.19,0,0,1,0-.28l1.13-1a.19.19,0,1,1,.26.29l-1.12,1A.2.2,0,0,1,391.73,245.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M388.29,249a.22.22,0,0,1-.19-.06.2.2,0,0,1,0-.28l2.67-2.43a.19.19,0,0,1,.27,0,.19.19,0,0,1,0,.28L388.38,249A.2.2,0,0,1,388.29,249Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M393.64,244.14a.18.18,0,0,1-.19-.06.2.2,0,0,1,0-.28l1.37-1.24a.18.18,0,0,1,.27,0,.19.19,0,0,1,0,.28l-1.36,1.24A.2.2,0,0,1,393.64,244.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M385.29,250a.22.22,0,0,1-.19-.06.19.19,0,0,1,0-.28l2.49-2.28a.2.2,0,1,1,.26.3L385.38,250Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M388.59,247a.22.22,0,0,1-.19-.06.2.2,0,0,1,0-.28l2.67-2.44a.2.2,0,0,1,.27.29L388.68,247Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M392,243.84a.18.18,0,0,1-.19-.06.19.19,0,0,1,0-.27l2.64-2.42a.2.2,0,0,1,.28,0,.18.18,0,0,1,0,.27l-2.64,2.42A.18.18,0,0,1,392,243.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M353.93,266a.19.19,0,0,1-.19-.05.2.2,0,0,1,0-.28l1.87-1.71a.19.19,0,0,1,.27,0,.18.18,0,0,1,0,.27L354,265.91A.18.18,0,0,1,353.93,266Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M360.05,260.36a.18.18,0,0,1-.19-.06.18.18,0,0,1,0-.27l1.13-1a.2.2,0,0,1,.27.3l-1.13,1A.18.18,0,0,1,360.05,260.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M356.61,263.5a.19.19,0,0,1-.19-.05.2.2,0,0,1,0-.28l2.67-2.44a.19.19,0,0,1,.27,0,.18.18,0,0,1,0,.27l-2.66,2.44A.18.18,0,0,1,356.61,263.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M362,258.62a.22.22,0,0,1-.19-.06.2.2,0,0,1,0-.28l1.37-1.25a.19.19,0,1,1,.26.29l-1.36,1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M353.61,264.49a.18.18,0,0,1-.19-.06.19.19,0,0,1,0-.28l2.49-2.27a.19.19,0,1,1,.26.29l-2.48,2.27A.2.2,0,0,1,353.61,264.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M356.91,261.47a.18.18,0,0,1-.19-.06.2.2,0,0,1,0-.28l2.66-2.43a.19.19,0,0,1,.28,0,.2.2,0,0,1,0,.28L357,261.42A.2.2,0,0,1,356.91,261.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M360.36,258.32a.22.22,0,0,1-.19-.06.19.19,0,0,1,0-.28l2.63-2.41a.2.2,0,0,1,.28,0,.19.19,0,0,1,0,.28l-2.64,2.41A.2.2,0,0,1,360.36,258.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M402.43,265.85a.28.28,0,0,0,.2-.26,6.74,6.74,0,0,0-.14-1.7c-.53-2.43-2.41-3.09-4.27-1.57a.27.27,0,0,0-.09.28l.93,4.25s0,0,.05.06a.11.11,0,0,0,.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M397.6,263a.11.11,0,0,0-.09-.09s-.08,0-.12,0a9,9,0,0,0-2.23,7.51,3,3,0,0,0,1.48,2.2.17.17,0,0,0,.14,0,.18.18,0,0,0,.09-.1l1.62-5.12a.65.65,0,0,0,0-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M399.2,267.47a.2.2,0,0,0-.14.14l-1.64,5.18a.14.14,0,0,0,0,.11.13.13,0,0,0,.1.06,3,3,0,0,0,2.51-1,9.06,9.06,0,0,0,2.56-5.5.09.09,0,0,0,0-.08.1.1,0,0,0-.09,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "333.71 325.3 331.71 327.13 331.13 324.5 333.13 322.67 333.71 325.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "337.54 321.8 335.54 323.63 334.96 321 336.96 319.17 337.54 321.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "341.37 318.3 339.37 320.13 338.79 317.5 340.79 315.67 341.37 318.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "345.2 314.8 343.2 316.63 342.62 314 344.62 312.17 345.2 314.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "349.03 311.3 347.03 313.12 346.45 310.5 348.45 308.67 349.03 311.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "348.8 310.27 331.48 326.1 331.35 325.52 348.67 309.69 348.8 310.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M342.23,318.57l-3.33,3-1-4.38,3.33-3.05Zm-3.18,2.54,2.89-2.63-.84-3.8-2.88,2.64Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "385.25 244.76 383.84 246.04 382.89 241.7 384.29 240.42 385.25 244.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "387.3 242.88 385.89 244.17 384.6 238.29 386 237.01 387.3 242.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "389.34 241.01 387.94 242.3 386.09 233.92 387.5 232.64 389.34 241.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "391.39 239.14 389.99 240.43 387.89 230.93 389.3 229.65 391.39 239.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "393.44 237.27 392.03 238.56 390.36 230.95 391.76 229.66 393.44 237.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "374 311.83 373.06 312.69 372.42 309.78 373.36 308.92 374 311.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "375.38 310.57 374.43 311.43 372.99 304.9 373.94 304.04 375.38 310.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "376.75 309.31 375.81 310.18 374.57 304.55 375.51 303.69 376.75 309.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "378.13 308.06 377.18 308.92 375.78 302.55 376.72 301.68 378.13 308.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "379.5 306.8 378.56 307.66 377.43 302.56 378.38 301.69 379.5 306.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M323.32,295a.16.16,0,0,1-.17-.05.18.18,0,0,1,0-.26l1.3-1.2a.19.19,0,0,1,.26,0,.18.18,0,0,1,0,.26l-1.3,1.19A.18.18,0,0,1,323.32,295Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M325.4,293.08a.2.2,0,0,1-.18-.06.19.19,0,0,1,0-.26l3.75-3.43a.19.19,0,0,1,.26,0,.18.18,0,0,1,0,.26L325.48,293Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M329.88,289a.18.18,0,0,1-.17-.06.18.18,0,0,1,0-.26l2.28-2.08a.18.18,0,0,1,.25.27L330,288.93A.2.2,0,0,1,329.88,289Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M323.63,296.35a.18.18,0,0,1-.18-.06.19.19,0,0,1,0-.26l2.92-2.66a.18.18,0,1,1,.25.27l-2.92,2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M327.31,293a.16.16,0,0,1-.17-.06.18.18,0,0,1,0-.26l3.11-2.84a.19.19,0,0,1,.26,0,.18.18,0,0,1,0,.26l-3.11,2.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M331.16,289.46a.18.18,0,0,1-.18,0,.19.19,0,0,1,0-.26l1.3-1.19a.18.18,0,0,1,.26,0,.19.19,0,0,1,0,.26l-1.3,1.19A.18.18,0,0,1,331.16,289.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M323,293.6a.21.21,0,0,1-.18-.06.19.19,0,0,1,0-.26l1.76-1.6a.18.18,0,0,1,.26,0,.19.19,0,0,1,0,.26l-1.76,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M328.77,288.34a.18.18,0,0,1-.17-.06.18.18,0,0,1,0-.26l1.06-1a.18.18,0,0,1,.25.27l-1.06,1A.16.16,0,0,1,328.77,288.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M325.54,291.29a.18.18,0,0,1-.18-.05.2.2,0,0,1,0-.27l2.5-2.29a.19.19,0,0,1,.26,0,.18.18,0,0,1,0,.26l-2.5,2.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M330.57,286.69a.16.16,0,0,1-.17-.05.18.18,0,0,1,0-.26l1.28-1.18a.19.19,0,0,1,.26,0,.19.19,0,0,1,0,.27l-1.28,1.17A.18.18,0,0,1,330.57,286.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M322.72,292.22a.2.2,0,0,1-.18-.06.19.19,0,0,1,0-.26l2.34-2.14a.19.19,0,0,1,.26,0,.19.19,0,0,1,0,.27l-2.34,2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M325.83,289.38a.19.19,0,0,1-.18-.06.19.19,0,0,1,0-.26l2.51-2.29a.18.18,0,0,1,.26,0,.19.19,0,0,1,0,.26l-2.51,2.29A.14.14,0,0,1,325.83,289.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M329.07,286.41a.18.18,0,0,1-.18-.05.2.2,0,0,1,0-.27l2.48-2.26a.18.18,0,0,1,.26,0,.19.19,0,0,1,0,.26l-2.48,2.27A.18.18,0,0,1,329.07,286.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M324.71,301.28a.21.21,0,0,1-.18-.06.19.19,0,0,1,0-.26l1.3-1.19a.18.18,0,1,1,.25.27l-1.3,1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M326.78,299.38a.16.16,0,0,1-.17-.05.19.19,0,0,1,0-.27l3.75-3.42a.18.18,0,0,1,.25.27l-3.75,3.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M331.27,295.28a.16.16,0,0,1-.17-.06.18.18,0,0,1,0-.26l2.27-2.08a.2.2,0,0,1,.27,0,.19.19,0,0,1,0,.26l-2.27,2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M325,302.65a.16.16,0,0,1-.17,0,.18.18,0,0,1,0-.26l2.92-2.67a.18.18,0,0,1,.26,0,.19.19,0,0,1,0,.26l-2.92,2.67A.15.15,0,0,1,325,302.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M328.7,299.28a.16.16,0,0,1-.17,0,.18.18,0,0,1,0-.26l3.11-2.85a.19.19,0,0,1,.26,0,.2.2,0,0,1,0,.27l-3.11,2.84A.18.18,0,0,1,328.7,299.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M332.55,295.77a.21.21,0,0,1-.18-.06.19.19,0,0,1,0-.26l1.31-1.19a.18.18,0,0,1,.25.27l-1.31,1.19A.14.14,0,0,1,332.55,295.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M324.41,299.9a.21.21,0,0,1-.18-.06.19.19,0,0,1,0-.26L326,298a.18.18,0,1,1,.25.27l-1.76,1.6A.14.14,0,0,1,324.41,299.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M330.16,294.64a.18.18,0,0,1-.17-.06.18.18,0,0,1,0-.26l1.06-1a.19.19,0,0,1,.26,0,.18.18,0,0,1,0,.26l-1.06,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M326.93,297.59a.18.18,0,0,1-.16-.31l2.5-2.29a.18.18,0,0,1,.25.27L327,297.55A.12.12,0,0,1,326.93,297.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M332,293a.18.18,0,0,1-.17-.06.18.18,0,0,1,0-.26l1.28-1.18a.19.19,0,0,1,.26,0,.18.18,0,0,1,0,.26L332.05,293Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M324.1,298.52a.16.16,0,0,1-.17,0,.19.19,0,0,1,0-.27l2.34-2.13a.18.18,0,0,1,.25.27l-2.34,2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M327.21,295.68a.18.18,0,0,1-.17-.06.18.18,0,0,1,0-.26l2.51-2.29a.18.18,0,1,1,.25.27l-2.51,2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M330.46,292.71a.18.18,0,0,1-.18,0,.19.19,0,0,1,0-.26l2.49-2.27a.18.18,0,0,1,.26,0,.19.19,0,0,1,0,.26l-2.49,2.27A.12.12,0,0,1,330.46,292.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M326.09,307.53a.21.21,0,0,1-.18-.06.19.19,0,0,1,0-.26l1.31-1.19a.18.18,0,0,1,.25.27l-1.31,1.19A.14.14,0,0,1,326.09,307.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M328.16,305.63a.18.18,0,0,1-.18-.05.19.19,0,0,1,0-.26l3.75-3.43a.18.18,0,1,1,.25.27l-3.75,3.43A.18.18,0,0,1,328.16,305.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M332.65,301.53a.18.18,0,0,1-.18,0,.19.19,0,0,1,0-.26l2.28-2.09a.19.19,0,0,1,.26,0,.18.18,0,0,1,0,.26l-2.28,2.08A.12.12,0,0,1,332.65,301.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M326.39,308.91a.18.18,0,0,1-.17-.06.18.18,0,0,1,0-.26l2.92-2.67a.18.18,0,0,1,.25.27l-2.92,2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M330.08,305.54a.21.21,0,0,1-.18-.06.19.19,0,0,1,0-.26l3.12-2.84a.18.18,0,0,1,.26,0,.19.19,0,0,1,0,.26l-3.12,2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M333.93,302a.2.2,0,0,1-.18-.06.19.19,0,0,1,0-.26l1.31-1.19a.19.19,0,0,1,.26,0,.19.19,0,0,1,0,.27L334,302Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M325.79,306.15a.17.17,0,0,1-.18,0,.19.19,0,0,1,0-.27l1.75-1.6a.19.19,0,1,1,.25.28l-1.75,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M331.54,300.89a.18.18,0,0,1-.18-.05.19.19,0,0,1,0-.27l1.06-1a.19.19,0,0,1,.25.28l-1.06,1A.18.18,0,0,1,331.54,300.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M328.31,303.85a.2.2,0,0,1-.18-.06.19.19,0,0,1,0-.26l2.51-2.29a.18.18,0,0,1,.25.27l-2.51,2.29A.14.14,0,0,1,328.31,303.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M333.34,299.25a.21.21,0,0,1-.18-.06.19.19,0,0,1,0-.26l1.29-1.17a.18.18,0,0,1,.26,0,.19.19,0,0,1,0,.26l-1.29,1.17A.14.14,0,0,1,333.34,299.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M325.48,304.77a.16.16,0,0,1-.17,0,.18.18,0,0,1,0-.26l2.34-2.14a.18.18,0,0,1,.26,0,.19.19,0,0,1,0,.26l-2.34,2.14A.18.18,0,0,1,325.48,304.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M328.59,301.93a.18.18,0,0,1-.18-.05.19.19,0,0,1,0-.26l2.51-2.3a.19.19,0,0,1,.26,0,.19.19,0,0,1,0,.27l-2.5,2.29A.18.18,0,0,1,328.59,301.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M331.84,299a.2.2,0,0,1-.18-.06.19.19,0,0,1,0-.26l2.49-2.27a.19.19,0,0,1,.26,0,.18.18,0,0,1,0,.26l-2.48,2.27A.14.14,0,0,1,331.84,299Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M334.54,285a.2.2,0,0,1-.18-.06.19.19,0,0,1,0-.26l1.31-1.19a.18.18,0,0,1,.26,0,.19.19,0,0,1,0,.26L334.62,285A.14.14,0,0,1,334.54,285Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M336.61,283.11a.18.18,0,0,1-.18-.05.19.19,0,0,1,0-.26l3.76-3.43a.18.18,0,0,1,.26,0,.19.19,0,0,1,0,.26l-3.76,3.43A.12.12,0,0,1,336.61,283.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M341.1,279a.17.17,0,0,1-.18-.05.2.2,0,0,1,0-.27l2.28-2.08a.19.19,0,0,1,.26,0,.2.2,0,0,1,0,.27L341.18,279A.12.12,0,0,1,341.1,279Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M334.84,286.38a.18.18,0,0,1-.18-.05.19.19,0,0,1,0-.26l2.92-2.67a.2.2,0,0,1,.27,0,.19.19,0,0,1,0,.26l-2.92,2.67A.12.12,0,0,1,334.84,286.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M338.53,283a.17.17,0,0,1-.18-.05.19.19,0,0,1,0-.26l3.11-2.85a.2.2,0,0,1,.27,0,.19.19,0,0,1,0,.26L338.61,283A.12.12,0,0,1,338.53,283Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M342.37,279.5a.18.18,0,0,1-.17-.06.18.18,0,0,1,0-.26l1.3-1.19a.19.19,0,0,1,.26,0,.18.18,0,0,1,0,.26l-1.3,1.19A.16.16,0,0,1,342.37,279.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M334.23,283.63a.18.18,0,0,1-.17-.06.18.18,0,0,1,0-.26l1.75-1.6a.19.19,0,0,1,.26,0,.18.18,0,0,1,0,.26l-1.75,1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M340,278.37a.19.19,0,0,1-.18-.06.19.19,0,0,1,0-.26l1.07-1a.19.19,0,0,1,.26,0,.2.2,0,0,1,0,.27l-1.07,1A.2.2,0,0,1,340,278.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M336.75,281.33a.18.18,0,0,1-.17-.06.18.18,0,0,1,0-.26l2.51-2.29a.19.19,0,0,1,.26,0,.18.18,0,0,1,0,.26l-2.5,2.29A.19.19,0,0,1,336.75,281.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M341.79,276.73a.2.2,0,0,1-.18-.06.19.19,0,0,1,0-.26l1.29-1.17a.18.18,0,0,1,.26,0,.19.19,0,0,1,0,.26l-1.29,1.17A.14.14,0,0,1,341.79,276.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M333.93,282.25a.18.18,0,0,1-.18-.05.19.19,0,0,1,0-.26l2.35-2.14a.18.18,0,0,1,.26,0,.19.19,0,0,1,0,.26L334,282.21A.12.12,0,0,1,333.93,282.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M337,279.41a.18.18,0,0,1-.18-.05.2.2,0,0,1,0-.27l2.51-2.29a.19.19,0,0,1,.26,0,.18.18,0,0,1,0,.26l-2.51,2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M340.28,276.45a.18.18,0,0,1-.17-.06.18.18,0,0,1,0-.26l2.48-2.27a.19.19,0,0,1,.26,0,.18.18,0,0,1,0,.26l-2.48,2.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "349.86 272.26 346.67 275.17 345.75 270.98 348.94 268.07 349.86 272.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "351.29 278.76 348.11 281.67 347.18 277.48 350.37 274.57 351.29 278.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "352.69 285.1 349.5 288.02 348.58 283.83 351.77 280.91 352.69 285.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M335.92,291.31a.18.18,0,0,1-.17-.06.18.18,0,0,1,0-.26l1.3-1.19a.2.2,0,0,1,.27,0,.19.19,0,0,1,0,.26l-1.3,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M338,289.42a.2.2,0,0,1-.18-.06.19.19,0,0,1,0-.26l3.75-3.43a.2.2,0,0,1,.27,0,.19.19,0,0,1,0,.26l-3.75,3.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M342.49,285.31a.17.17,0,0,1-.18-.05.18.18,0,0,1,0-.26l2.28-2.08a.18.18,0,0,1,.26,0,.19.19,0,0,1,0,.26l-2.28,2.08A.12.12,0,0,1,342.49,285.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M336.23,292.69a.21.21,0,0,1-.18-.06.19.19,0,0,1,0-.26L339,289.7a.19.19,0,0,1,.26,0,.19.19,0,0,1,0,.27l-2.92,2.66A.14.14,0,0,1,336.23,292.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M339.92,289.32a.2.2,0,0,1-.18-.06.19.19,0,0,1,0-.26l3.11-2.84a.18.18,0,0,1,.25.27L340,289.27A.14.14,0,0,1,339.92,289.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M343.76,285.8a.16.16,0,0,1-.17-.06.18.18,0,0,1,0-.26l1.3-1.19a.19.19,0,0,1,.26,0,.19.19,0,0,1,0,.27l-1.3,1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M335.62,289.93a.18.18,0,0,1-.18-.05.19.19,0,0,1,0-.26l1.75-1.61a.19.19,0,0,1,.26,0,.19.19,0,0,1,0,.27l-1.75,1.6A.18.18,0,0,1,335.62,289.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M341.38,284.67a.17.17,0,0,1-.18-.05.19.19,0,0,1,0-.26l1.06-1a.2.2,0,0,1,.27,0,.19.19,0,0,1,0,.26l-1.06,1A.12.12,0,0,1,341.38,284.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M338.14,287.63a.18.18,0,0,1-.17-.06.18.18,0,0,1,0-.26l2.5-2.29a.19.19,0,0,1,.26,0,.18.18,0,0,1,0,.26l-2.5,2.29A.2.2,0,0,1,338.14,287.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M343.18,283A.19.19,0,0,1,343,283a.19.19,0,0,1,0-.26l1.28-1.17a.19.19,0,0,1,.27,0,.18.18,0,0,1,0,.26L343.26,283Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M335.32,288.56a.21.21,0,0,1-.18-.06.19.19,0,0,1,0-.26l2.34-2.14a.2.2,0,0,1,.27,0,.19.19,0,0,1,0,.26l-2.34,2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M338.43,285.71a.17.17,0,0,1-.18,0,.19.19,0,0,1,0-.26l2.51-2.3a.19.19,0,0,1,.26,0,.18.18,0,0,1,0,.26l-2.51,2.29A.12.12,0,0,1,338.43,285.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M341.67,282.75a.18.18,0,0,1-.17-.06.18.18,0,0,1,0-.26l2.48-2.27a.19.19,0,0,1,.26,0,.18.18,0,0,1,0,.26l-2.48,2.27A.2.2,0,0,1,341.67,282.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M337.3,297.56a.16.16,0,0,1-.17-.05.18.18,0,0,1,0-.26l1.3-1.2a.19.19,0,0,1,.25.28l-1.3,1.19A.18.18,0,0,1,337.3,297.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M339.37,295.67a.18.18,0,0,1-.17-.06.18.18,0,0,1,0-.26l3.75-3.43a.19.19,0,0,1,.26,0,.19.19,0,0,1,0,.27l-3.75,3.42A.16.16,0,0,1,339.37,295.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M343.86,291.57a.18.18,0,0,1-.17-.06.18.18,0,0,1,0-.26l2.28-2.08a.18.18,0,1,1,.24.27L344,291.52A.2.2,0,0,1,343.86,291.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M337.61,298.94a.19.19,0,0,1-.18-.06.19.19,0,0,1,0-.26l2.92-2.67a.19.19,0,0,1,.25.28l-2.92,2.67A.2.2,0,0,1,337.61,298.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M341.29,295.57a.18.18,0,0,1-.17-.06.18.18,0,0,1,0-.26l3.11-2.84a.18.18,0,0,1,.25.27l-3.11,2.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M345.14,292.05a.18.18,0,0,1-.16-.31l1.3-1.19a.18.18,0,0,1,.26,0,.19.19,0,0,1,0,.26l-1.3,1.19A.18.18,0,0,1,345.14,292.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M337,296.19a.21.21,0,0,1-.18-.06.19.19,0,0,1,0-.26l1.76-1.6a.18.18,0,0,1,.26,0,.19.19,0,0,1,0,.26l-1.76,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M342.75,290.93a.18.18,0,0,1-.17-.06.18.18,0,0,1,0-.26l1.06-1a.18.18,0,0,1,.25.27l-1.06,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M339.52,293.88a.19.19,0,0,1-.18-.06.19.19,0,0,1,0-.26l2.5-2.29a.19.19,0,0,1,.26,0,.18.18,0,0,1,0,.26l-2.5,2.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M344.55,289.28a.16.16,0,0,1-.17,0,.19.19,0,0,1,0-.27l1.28-1.17a.19.19,0,0,1,.26,0,.18.18,0,0,1,0,.26l-1.28,1.18A.18.18,0,0,1,344.55,289.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M336.7,294.81a.19.19,0,0,1-.18-.06.19.19,0,0,1,0-.26l2.34-2.14a.19.19,0,0,1,.26,0,.19.19,0,0,1,0,.27l-2.34,2.13A.14.14,0,0,1,336.7,294.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M339.8,292a.18.18,0,0,1-.17-.06.18.18,0,0,1,0-.26l2.51-2.29a.18.18,0,0,1,.26,0,.19.19,0,0,1,0,.26l-2.51,2.29A.16.16,0,0,1,339.8,292Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M343.05,289a.2.2,0,0,1-.18-.05.19.19,0,0,1,0-.27l2.48-2.27a.19.19,0,0,1,.25.28L343.13,289A.2.2,0,0,1,343.05,289Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M356.62,279.69c.06.26,26.9-24.59,26.9-24.59s-2.92-4.66-7-.83-4,4-7.4,4.26c-3.16.26-3.51,1.86-4.82,5.06s-.72,6.68-2.17,8.48C359.56,275.29,355.64,275.21,356.62,279.69Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "357.1 281.67 356.94 281.31 384.25 256.43 384.41 256.79 357.1 281.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M369.27,295.29a.18.18,0,0,1-.17-.06.18.18,0,0,1,0-.26l1.3-1.19a.18.18,0,1,1,.25.27l-1.3,1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M371.35,293.39a.17.17,0,0,1-.18-.05.2.2,0,0,1,0-.27l3.75-3.42a.18.18,0,0,1,.26,0,.19.19,0,0,1,0,.26l-3.75,3.43A.12.12,0,0,1,371.35,293.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M369.58,296.66a.17.17,0,0,1-.18-.05.2.2,0,0,1,0-.27l2.92-2.66a.18.18,0,0,1,.26,0,.19.19,0,0,1,0,.26l-2.92,2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M373.26,293.29a.16.16,0,0,1-.17-.05.18.18,0,0,1,0-.26l3.11-2.85a.19.19,0,0,1,.25.28l-3.11,2.84A.18.18,0,0,1,373.26,293.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M370.1,299a.2.2,0,0,1-.18-.06.19.19,0,0,1,0-.26l1.3-1.19a.19.19,0,0,1,.27,0,.19.19,0,0,1,0,.26l-1.3,1.19A.14.14,0,0,1,370.1,299Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M372.17,297.12a.18.18,0,0,1-.18-.05.19.19,0,0,1,0-.26l3.75-3.43a.19.19,0,0,1,.26,0,.18.18,0,0,1,0,.26l-3.75,3.43A.12.12,0,0,1,372.17,297.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M370.4,300.39a.18.18,0,0,1-.18-.05.19.19,0,0,1,0-.26l2.92-2.67a.19.19,0,0,1,.26,0,.18.18,0,0,1,0,.26l-2.92,2.67A.12.12,0,0,1,370.4,300.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M374.08,297a.16.16,0,0,1-.17,0,.18.18,0,0,1,0-.26l3.11-2.84a.18.18,0,0,1,.26,0,.19.19,0,0,1,0,.26L374.17,297A.15.15,0,0,1,374.08,297Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M368.76,293a.16.16,0,0,1-.17-.05.18.18,0,0,1,0-.26l1.75-1.61a.19.19,0,0,1,.26,0,.18.18,0,0,1,0,.26l-1.75,1.6A.15.15,0,0,1,368.76,293Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M374.52,287.72a.2.2,0,0,1-.18-.06.19.19,0,0,1,0-.26l1.06-1a.2.2,0,0,1,.27,0,.19.19,0,0,1,0,.26l-1.06,1A.14.14,0,0,1,374.52,287.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M371.29,290.67a.19.19,0,0,1-.18-.06.19.19,0,0,1,0-.26l2.5-2.29a.2.2,0,0,1,.27,0,.19.19,0,0,1,0,.26l-2.5,2.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M368.46,291.6a.21.21,0,0,1-.18-.06.19.19,0,0,1,0-.26l2.34-2.14a.19.19,0,0,1,.26,0,.2.2,0,0,1,0,.27l-2.34,2.13A.2.2,0,0,1,368.46,291.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M371.57,288.76a.21.21,0,0,1-.18-.06.19.19,0,0,1,0-.26l2.51-2.29a.18.18,0,1,1,.25.27l-2.51,2.29A.14.14,0,0,1,371.57,288.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M364,301.93a.28.28,0,0,0,.18-.24,6.29,6.29,0,0,0-.13-1.58c-.49-2.24-2.23-2.85-3.94-1.44a.25.25,0,0,0-.09.26l.86,3.92.05,0a.06.06,0,0,0,.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M359.53,299.28a.11.11,0,0,0-.08-.08.1.1,0,0,0-.1,0,8.33,8.33,0,0,0-2.07,6.93,2.76,2.76,0,0,0,1.37,2,.19.19,0,0,0,.13,0,.24.24,0,0,0,.08-.09l1.5-4.74a.53.53,0,0,0,0-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M361,303.42a.2.2,0,0,0-.12.13l-1.52,4.78a.14.14,0,0,0,0,.11.11.11,0,0,0,.09.05,2.76,2.76,0,0,0,2.31-.88,8.29,8.29,0,0,0,2.37-5.08.11.11,0,0,0,0-.08.1.1,0,0,0-.09,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "367.33 294.65 365.39 296.43 364.83 293.87 366.77 292.1 367.33 294.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "368.2 298.61 366.26 300.39 365.7 297.83 367.64 296.06 368.2 298.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "369.06 302.48 367.12 304.26 366.55 301.7 368.5 299.93 369.06 302.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M361.45,320.94a.17.17,0,0,1-.18-.05.2.2,0,0,1,0-.27l1.31-1.19a.19.19,0,0,1,.26,0,.2.2,0,0,1,0,.27l-1.31,1.19A.2.2,0,0,1,361.45,320.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M363.52,319.05a.21.21,0,0,1-.18-.06.19.19,0,0,1,0-.26l3.76-3.43a.19.19,0,0,1,.26,0,.2.2,0,0,1,0,.27L363.6,319A.14.14,0,0,1,363.52,319.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M368,315a.2.2,0,0,1-.18-.06.19.19,0,0,1,0-.26l2.28-2.08a.18.18,0,1,1,.25.27l-2.28,2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M361.75,322.32a.21.21,0,0,1-.18-.06.18.18,0,0,1,0-.26l2.91-2.67a.2.2,0,0,1,.27,0,.19.19,0,0,1,0,.26l-2.91,2.66A.2.2,0,0,1,361.75,322.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M365.44,319a.21.21,0,0,1-.18-.06.19.19,0,0,1,0-.26l3.11-2.84a.19.19,0,0,1,.27,0,.19.19,0,0,1,0,.26l-3.11,2.84A.14.14,0,0,1,365.44,319Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M369.29,315.43a.17.17,0,0,1-.18-.05.19.19,0,0,1,0-.26l1.3-1.2a.2.2,0,0,1,.27,0,.19.19,0,0,1,0,.26l-1.3,1.19A.12.12,0,0,1,369.29,315.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M361.14,319.56a.16.16,0,0,1-.17-.05.18.18,0,0,1,0-.26l1.75-1.61a.19.19,0,0,1,.26,0,.18.18,0,0,1,0,.26l-1.75,1.6A.18.18,0,0,1,361.14,319.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M366.9,314.31a.21.21,0,0,1-.18-.06.19.19,0,0,1,0-.26l1.07-1a.18.18,0,0,1,.26,0,.19.19,0,0,1,0,.26l-1.07,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M363.67,317.26a.2.2,0,0,1-.18-.06.19.19,0,0,1,0-.26l2.51-2.29a.18.18,0,0,1,.26,0,.19.19,0,0,1,0,.26l-2.51,2.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M368.7,312.66a.2.2,0,0,1-.18-.05.2.2,0,0,1,0-.27l1.29-1.17a.18.18,0,1,1,.25.27l-1.29,1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M360.84,318.19a.21.21,0,0,1-.18-.06.18.18,0,0,1,0-.26l2.34-2.14a.18.18,0,1,1,.25.27l-2.35,2.14A.14.14,0,0,1,360.84,318.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M364,315.35a.21.21,0,0,1-.18-.06.19.19,0,0,1,0-.26l2.51-2.29a.18.18,0,1,1,.25.27L364,315.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M367.19,312.38a.16.16,0,0,1-.17-.06.18.18,0,0,1,0-.26l2.48-2.27a.19.19,0,0,1,.25.28l-2.48,2.27Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-95",
    cx: 315.49,
    cy: 454.27,
    rx: 19.91,
    ry: 7.23,
    transform: "translate(-160.77 173.07) rotate(-24.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M311.08,450.66s-.45,1.52-.59,2.08a6.72,6.72,0,0,0,.24,1.95,1.19,1.19,0,0,0,.88.91,3,3,0,0,0,2.33-.42l6.22-4.2a.78.78,0,0,0,.25-1l-.16-.32a1.22,1.22,0,0,0-1.38-.61c-1.41.35-4,.95-4.95.71C312.62,449.42,311.08,450.66,311.08,450.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M307.78,402.31l2.77,16.1a10.3,10.3,0,0,1-.48,5.42c-.8,2.09-.83,5.56-.87,10.23a85.69,85.69,0,0,0,2,17.13c.65,1.15,2.24-.16,2.7-1.44,0,0,3-32.76,6.58-38.94V401l-4.82-5.27-5.2-.92C308.89,395.5,307.48,400.61,307.78,402.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M327.26,397.93s4.27,18.07,2.35,24.83-9.81,19.49-11.23,23.76c-3.2,6.8-3.52,3.93-3.44.56,0,0,1.36-16.57,6.8-22.76a3.3,3.3,0,0,0,.83-2.68c-.4-2.75-1.46-8.23-3.7-10.83-3.06-3.56-6.27-7.12-6.16-10.6S327.26,397.93,327.26,397.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M318.43,456.3s.6,1.26-.3,1.86-2.75-.6-3.72-1.38-.57-4.21-.88-5-.84-3.79-.22-4.21a6,6,0,0,1,2.94-.48c.8.06,1.15,1.5,1.15,1.5S317.05,453.54,318.43,456.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M315.76,358.23s-2.35,5-3.62,7.08a1.27,1.27,0,0,0,.23,1.52c1.39,1.26,1.71,1.3,4.72,1.58a1.4,1.4,0,0,0,1.52-1.2c-.73-1.82.78-4.19,1.77-6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M320.94,350.2a38.66,38.66,0,0,1,2.27,5.12c.29,1.28.71,5.69-1.14,6.26s-6.38-.29-8.1-3S313,348.49,320.94,350.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M339,413.66a2.73,2.73,0,0,0-.64-3.5L334,406.61a6.48,6.48,0,0,1-2.24-3.66l-6.13-28.61s-.78-4.71-4.23-6.3l-.53-.24a8.81,8.81,0,0,0-4,8.22c.22,5.28-4.37,3-6.38,1.8a2.33,2.33,0,0,1-1.09-1.67c-.34-2.36-.85-8.08,1.66-10.81-1.6.2-3.77,1.25-3.93,5.48-.13,3.49,2.21,12.77,2,21.79-.15,5.95-2.88,12.31-2.94,14.94a4.25,4.25,0,0,1-1.15,2.83c-1.46,1.56-3.81,4.25-3.58,5.14.32,1.28,5.07,4.59,8.13,3.52s3.5,2.12,6.91,3.09,5.69-4.07,9.4-3c5.31,1.55,6.6-3.42,9.7-3.2C337.16,416.06,338.28,414.85,339,413.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M309.38,376.15a2.33,2.33,0,0,0,1.09,1.67c2,1.23,6.6,3.48,6.38-1.8a8.81,8.81,0,0,1,4-8.22,50.15,50.15,0,0,0-8.17-2.4,5.41,5.41,0,0,0-1.67-.06C308.53,368.07,309,373.79,309.38,376.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M339.46,347.44l-.79-.54a6.68,6.68,0,0,0-.86-2c-.65-1-.35-1.57-.21-2.91s1-.68.86.53,1.09.12,1.13-.28l.35-3a7.65,7.65,0,0,1,1.7,2.59c.36,1.25-.85,4.73-.85,4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M340.94,346.13s3.29,24.33-16.48,29.59c-4.91,1.71-6.68-4.41-3.06-6.4,0,0,15.61-2.08,17.27-22.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M321.41,351.13s-4,2.08-1.93,7.1-4,4.55-5.36,5.86-3.53,10.2-9.82,8.24-8-7.58-5-11.59c1.87-2.51,6.08-3.11,9-3.21a1.84,1.84,0,0,0,1.68-2.47c-.78-2.07-1.21-5,1.3-6.88C315.5,344.89,325.06,347.44,321.41,351.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M422.15,247.05s-5.43,5-5.91,6.65,4.19,1.15,7.08-.8,3.91-4.13,3.29-5.09S424.85,244.43,422.15,247.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M424.55,247.4a1.7,1.7,0,0,1-2.38-.77c-.93-1.91-2.86-5.91-3.52-7.38-1.46-3.24-4.12-8.73-5.69-11.95a14.1,14.1,0,0,1-1.41-5.43l-.3-5.59,8.51,2-1,5.59s3.41,2.35,4.8,9.83a86.34,86.34,0,0,1,1.57,12.75,1.13,1.13,0,0,1-.5,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M425.35,249.05s-2.21,3.38-3.68,5.45-.8,2.65.13,2.57,5.51-2.46,6.74-3.49,2.39-1.49,1.83-3.79C429.76,247.31,426.66,245.71,425.35,249.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M424.24,221.76c1,3.63,3.12,15.93,1.95,25.84a1.19,1.19,0,0,0,1.56,1.3,2.14,2.14,0,0,0,1-.78s8.26-14.48,2.54-25.83l-.14-4.53-7.4.82-.27,1.14C423.28,220.45,424.05,221,424.24,221.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M398.79,168.14s-4.07,10.24-3.52,14.65a7.9,7.9,0,0,0,4.64,6.11c.91.31,2.53-1.07,3-1.92a6.15,6.15,0,0,0,.95-3.29C403.66,181.63,398.79,168.14,398.79,168.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M432,195.6a151.17,151.17,0,0,1,0,25.65,1.62,1.62,0,0,1-1.29,1.46,37.45,37.45,0,0,1-6.78.82,1.55,1.55,0,0,1-1.5-1.21l-2-8.8-.34,8a1.84,1.84,0,0,1-1.75,1.75,18.63,18.63,0,0,1-6.25-.71,1.7,1.7,0,0,1-1.15-1.43,113.44,113.44,0,0,1,.35-25.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M405.87,163s6.38-1,9.45,2.24,17.28,21.22,19.51,31.06-16.53.53-19.06,1.65L411.09,200s-.39,3.06-5.17-7.81-7.87-17.56-7.69-19.57S397.13,165.44,405.87,163Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M416.19,166.34a32.46,32.46,0,0,1,3.21,17.36c-1.06,9.56-7.44,12.57-7.44,12.57a5.78,5.78,0,0,0-4.32-5.13s3.33-6,3.72-7.6-1.47-8.2-1.24-12.15S413.74,164.38,416.19,166.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M412.3,192.3a3.6,3.6,0,0,0-3.19-1.74,2,2,0,0,0-1.47.58c-1.69,1.66-6.81,6.65-7.82,7.41l-.88.7c-.29.26-1.18.13-1.81.36a6.56,6.56,0,0,0-2.2,1.4c-.14.16-.37.79.08.72s1.89-.75,2.23-.8a12.17,12.17,0,0,0-1.76,1.69c-.53.78-1.19,2.15-.14,3.21,1.24,1.25,3.75-1.46,4.69-2.66a42.13,42.13,0,0,1,3.26-4.14c.92-.93,5.33-2.7,7.84-3.65A2.19,2.19,0,0,0,412.3,192.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M402.54,158.65c0,.26,2.53,4.45,3.33,4.37s2.73-.13,2.73-.13-.27,5.26-3.72,7.42-5.81-2.78-5.81-2.78l1.28-2.12-1.54-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M392,157.49a10,10,0,0,0,1.17,4.15A18,18,0,0,0,398,167c.7.46,2-1.14,3.08-2.27a4.22,4.22,0,0,0,1.43-3.67,20.41,20.41,0,0,0-1.81-6C400,153.61,397.14,151.67,392,157.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M396,150.07c-1.59.43-2.67,2.93-4.13,3s-2-.13-2.77.55c-1.25,1.12.44,1.91,1,2s-2.64.74-2.21,2.64,2.2,2.73,5.82.45,3.43-3.87,5.13-3.77,2.74,2.41,3,3.78,1.7.68,1.71-.58S401.39,148.62,396,150.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M400.78,158s-.07-2.83.8-2.54,1,3,.19,3.9S400.78,158,400.78,158Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-69"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "142.7 364.39 142.7 268.45 251.94 205.38 252.87 205.26 252.87 300.41 252.14 301.66 143.01 364.7 142.7 364.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-121",
    points: "149.03 368.49 149.03 272.55 258.27 209.48 259.2 209.35 259.2 304.5 258.47 305.76 149.34 368.79 149.03 368.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-122",
    points: "147.43 271.4 147.5 271.57 148.85 272.6 258.41 209.74 258.98 208.82 257.27 207.82 256.55 207.77 147.23 271.03 147.43 271.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-123",
    points: "149.03 272.55 149.03 368.49 148.65 368.79 147.2 367.86 146.88 367.41 146.88 271.45 147.3 271.69 147.47 271.58 149.03 272.55"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "258.27 209.48 149.03 272.55 149.03 284.86 258.27 221.8 259.2 221.22 259.2 209.35 258.27 209.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "148.64 368.79 149.35 368.79 149.35 272.79 259.18 209.35 258.98 208.82 148.85 272.4 148.64 368.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-126",
    points: "148.86 272.77 149.12 272.24 147.23 271.03 146.88 271.45 148.86 272.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M158.43,273.73a2.82,2.82,0,0,1-1.27,2.2c-.7.4-1.27.08-1.27-.73a2.82,2.82,0,0,1,1.27-2.19C157.86,272.61,158.43,272.93,158.43,273.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M162.68,271.28a2.79,2.79,0,0,1-1.27,2.19c-.7.41-1.27.09-1.27-.72a2.79,2.79,0,0,1,1.27-2.19C162.11,270.15,162.68,270.48,162.68,271.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M166.93,268.83a2.77,2.77,0,0,1-1.28,2.19c-.7.41-1.27.08-1.27-.72a2.79,2.79,0,0,1,1.27-2.19C166.36,267.7,166.93,268,166.93,268.83Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "158.65 318.28 158.65 287.42 250.39 234.45 251.17 234.2 251.17 264.81 250.87 265.25 159.02 318.28 158.65 318.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "156.94 286.16 156.83 286.37 158.5 287.46 250.51 234.67 250.46 233.63 249.28 232.97 248.08 232.98 156.98 285.71 156.94 286.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-132",
    points: "158.65 287.42 158.65 318.28 158.25 318.28 156.6 317.35 156.31 316.97 156.31 286.1 156.63 286.12 156.8 286.38 158.65 287.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M248.68,233.58l1.06.59-91.23,52.34-.55-.42Zm0-1-92.36,53.46,2.18,1.37,92.61-53.13a.2.2,0,0,0,.09-.16.19.19,0,0,0-.09-.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-134",
    points: "158.67 356 158.67 324.91 186.29 309.08 187.07 308.83 187.07 339.67 186.77 340.11 159.04 356 158.67 356"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "156.95 323.64 156.84 323.86 158.52 324.95 186.41 309.3 186.36 308.26 185.17 307.59 183.96 307.6 156.99 323.19 156.95 323.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-136",
    points: "158.67 324.91 158.67 356 158.27 356 156.6 355.06 156.31 354.68 156.31 323.58 156.63 323.6 156.8 323.86 158.67 324.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M184.56,308.21l1.07.59L158.52,324l-.55-.42Zm0-1-28.24,16.33,2.2,1.37L187,309a.2.2,0,0,0,.09-.16.19.19,0,0,0-.09-.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-138",
    points: "190.71 337.48 190.71 306.38 218.32 290.56 219.11 290.31 219.11 321.14 218.8 321.59 191.07 337.48 190.71 337.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-139",
    points: "188.98 305.12 188.87 305.33 190.56 306.43 218.44 290.78 218.4 289.74 217.21 289.07 216 289.08 189.02 304.66 188.98 305.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-140",
    points: "190.71 306.38 190.71 337.48 190.3 337.48 188.64 336.54 188.35 336.16 188.35 305.05 188.67 305.08 188.84 305.34 190.71 306.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M216.6,289.68l1.07.59-27.11,15.2-.55-.42Zm0-.95-28.24,16.32,2.2,1.38,28.48-16a.2.2,0,0,0,.1-.16.21.21,0,0,0-.1-.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-142",
    points: "222.74 319.13 222.74 288.04 250.36 272.21 251.15 271.96 251.15 302.8 250.84 303.24 223.11 319.13 222.74 319.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-143",
    points: "221.02 286.77 220.91 286.99 222.59 288.08 250.48 272.43 250.43 271.39 249.24 270.72 248.03 270.73 221.06 286.32 221.02 286.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-144",
    points: "222.74 288.04 222.74 319.13 222.34 319.13 220.68 318.2 220.38 317.81 220.38 286.71 220.71 286.73 220.88 286.99 222.74 288.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M248.64,271.34l1.06.59-27.11,15.2-.54-.42Zm0-1L220.4,286.71l2.19,1.37,28.49-16a.19.19,0,0,0,0-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M163.55,338a.21.21,0,0,1-.18-.11.2.2,0,0,1,.07-.28l1.74-1a.2.2,0,0,1,.28.07.21.21,0,0,1-.07.29l-1.74,1A.17.17,0,0,1,163.55,338Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M166.3,336.43a.21.21,0,0,1-.18-.11.2.2,0,0,1,.08-.28l5-2.88a.21.21,0,0,1,.29.08.21.21,0,0,1-.08.28l-5,2.88A.23.23,0,0,1,166.3,336.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M172.26,333a.21.21,0,0,1-.18-.11.2.2,0,0,1,.08-.28l3-1.75a.21.21,0,0,1,.29.08.2.2,0,0,1-.08.28l-3,1.75A.2.2,0,0,1,172.26,333Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M163.55,339.61a.2.2,0,0,1-.18-.1.21.21,0,0,1,.07-.29l3.88-2.24a.22.22,0,0,1,.29.08.21.21,0,0,1-.08.29l-3.88,2.24A.16.16,0,0,1,163.55,339.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M168.45,336.79a.21.21,0,0,1-.11-.39l4.14-2.39a.21.21,0,0,1,.2.36l-4.13,2.39A.19.19,0,0,1,168.45,336.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M173.56,333.84a.22.22,0,0,1-.11-.4l1.73-1a.21.21,0,0,1,.29.07.21.21,0,0,1-.08.29l-1.73,1A.19.19,0,0,1,173.56,333.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M163.55,336.42a.22.22,0,0,1-.18-.1.21.21,0,0,1,.07-.29l2.33-1.34a.21.21,0,0,1,.29.07.21.21,0,0,1-.08.29l-2.33,1.34A.17.17,0,0,1,163.55,336.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M171.19,332a.21.21,0,0,1-.18-.11.2.2,0,0,1,.08-.28l1.41-.82a.21.21,0,0,1,.29.08.22.22,0,0,1-.08.29l-1.41.81A.2.2,0,0,1,171.19,332Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M166.9,334.49a.21.21,0,0,1-.18-.11.2.2,0,0,1,.07-.28l3.33-1.92a.21.21,0,0,1,.29.07.21.21,0,0,1-.08.29L167,334.46A.19.19,0,0,1,166.9,334.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M173.58,330.63a.21.21,0,0,1-.18-.11.2.2,0,0,1,.08-.28l1.7-1a.22.22,0,0,1,.29.08.21.21,0,0,1-.08.29l-1.7,1A.23.23,0,0,1,173.58,330.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M163.55,334.82a.2.2,0,0,1-.18-.1.21.21,0,0,1,.07-.29l3.11-1.79a.21.21,0,0,1,.29.08.2.2,0,0,1-.08.28l-3.11,1.8A.16.16,0,0,1,163.55,334.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M167.68,332.44a.22.22,0,0,1-.18-.1.21.21,0,0,1,.07-.29l3.34-1.92a.2.2,0,0,1,.28.07.21.21,0,0,1-.07.29l-3.34,1.92A.19.19,0,0,1,167.68,332.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M172,330a.22.22,0,0,1-.18-.1.21.21,0,0,1,.08-.29l3.29-1.9a.21.21,0,0,1,.29.07.21.21,0,0,1-.08.29l-3.3,1.9A.17.17,0,0,1,172,330Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M163.55,346a.2.2,0,0,1-.18-.1.21.21,0,0,1,.07-.29l1.74-1a.21.21,0,0,1,.28.08.21.21,0,0,1-.07.29l-1.74,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M166.3,344.39a.2.2,0,0,1-.18-.1.21.21,0,0,1,.08-.29l5-2.87a.21.21,0,0,1,.29.07.22.22,0,0,1-.08.29l-5,2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M172.26,341a.22.22,0,0,1-.18-.1.21.21,0,0,1,.08-.29l3-1.75a.22.22,0,0,1,.29.08.21.21,0,0,1-.08.29l-3,1.74A.2.2,0,0,1,172.26,341Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M163.55,347.58a.22.22,0,0,1-.18-.1.21.21,0,0,1,.07-.29l3.88-2.24a.21.21,0,0,1,.29.08.2.2,0,0,1-.08.28l-3.88,2.24A.17.17,0,0,1,163.55,347.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M168.45,344.75a.21.21,0,0,1-.11-.39l4.14-2.38a.2.2,0,0,1,.28.07.21.21,0,0,1-.08.29l-4.13,2.38A.19.19,0,0,1,168.45,344.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M173.56,341.8a.22.22,0,0,1-.18-.1.21.21,0,0,1,.07-.29l1.73-1a.21.21,0,0,1,.29.08.2.2,0,0,1-.08.28l-1.73,1A.19.19,0,0,1,173.56,341.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M163.55,344.39a.21.21,0,0,1-.18-.11.2.2,0,0,1,.07-.28l2.33-1.35a.21.21,0,0,1,.29.08.2.2,0,0,1-.08.28l-2.33,1.35A.17.17,0,0,1,163.55,344.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M171.19,340a.2.2,0,0,1-.18-.1.21.21,0,0,1,.08-.29l1.41-.81a.21.21,0,0,1,.29.07.22.22,0,0,1-.08.29l-1.41.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M166.9,342.45a.2.2,0,0,1-.18-.1.21.21,0,0,1,.07-.29l3.33-1.92a.21.21,0,0,1,.29.08.2.2,0,0,1-.08.28L167,342.42A.19.19,0,0,1,166.9,342.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M173.58,338.59a.2.2,0,0,1-.18-.1.21.21,0,0,1,.08-.29l1.7-1a.21.21,0,1,1,.21.36l-1.7,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M163.55,342.79a.22.22,0,0,1-.18-.1.21.21,0,0,1,.07-.29l3.11-1.8a.22.22,0,0,1,.29.08.21.21,0,0,1-.08.29l-3.11,1.79A.17.17,0,0,1,163.55,342.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M167.68,340.41a.22.22,0,0,1-.11-.4l3.34-1.92a.2.2,0,0,1,.28.08.2.2,0,0,1-.07.28l-3.34,1.93A.19.19,0,0,1,167.68,340.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M172,337.92a.21.21,0,0,1-.18-.11.19.19,0,0,1,.08-.28l3.29-1.91a.21.21,0,0,1,.29.08.2.2,0,0,1-.08.28l-3.3,1.91A.17.17,0,0,1,172,337.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M225.41,294.08a.18.18,0,0,1-.16-.09.18.18,0,0,1,.07-.26l1.57-.91a.18.18,0,0,1,.26.07.18.18,0,0,1-.07.26l-1.57.91A.18.18,0,0,1,225.41,294.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M227.92,292.64a.21.21,0,0,1-.17-.1.19.19,0,0,1,.07-.26l4.54-2.62a.19.19,0,0,1,.19.33L228,292.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M233.35,289.5a.2.2,0,0,1-.17-.09.19.19,0,0,1,.07-.26l2.76-1.59a.18.18,0,0,1,.26.07.2.2,0,0,1-.07.26l-2.76,1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M225.41,295.54a.19.19,0,0,1-.16-.1.18.18,0,0,1,.07-.26l3.53-2a.19.19,0,0,1,.19.33l-3.53,2A.19.19,0,0,1,225.41,295.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M229.87,293a.18.18,0,0,1-.16-.09.18.18,0,0,1,.07-.26l3.76-2.18a.19.19,0,0,1,.19.33L230,292.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M234.53,290.28a.21.21,0,0,1-.17-.1.19.19,0,0,1,.07-.26L236,289a.2.2,0,0,1,.26.07.19.19,0,0,1-.07.26l-1.58.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M225.41,292.63a.17.17,0,0,1-.16-.1.19.19,0,0,1,.07-.26l2.12-1.22a.19.19,0,0,1,.19.33l-2.12,1.22A.19.19,0,0,1,225.41,292.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M232.37,288.61a.18.18,0,0,1-.16-.09.21.21,0,0,1,.07-.27l1.28-.74a.19.19,0,0,1,.26.07.18.18,0,0,1-.07.26l-1.28.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M228.46,290.87a.19.19,0,0,1-.16-.1.19.19,0,0,1,.07-.26l3-1.75a.2.2,0,0,1,.26.07.19.19,0,0,1-.07.26l-3,1.75A.19.19,0,0,1,228.46,290.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M234.55,287.35a.2.2,0,0,1-.17-.09.19.19,0,0,1,.07-.26l1.56-.9a.2.2,0,0,1,.26.07.19.19,0,0,1-.07.26l-1.56.9A.15.15,0,0,1,234.55,287.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M225.41,291.18a.19.19,0,0,1-.16-.1.18.18,0,0,1,.07-.26l2.83-1.63a.18.18,0,0,1,.26.07.2.2,0,0,1-.07.26l-2.83,1.63A.19.19,0,0,1,225.41,291.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M229.17,289a.18.18,0,0,1-.16-.09.18.18,0,0,1,.07-.26l3-1.75a.18.18,0,0,1,.26.07.19.19,0,0,1-.07.26l-3,1.75A.16.16,0,0,1,229.17,289Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M233.1,286.74a.21.21,0,0,1-.17-.1.2.2,0,0,1,.07-.26l3-1.73a.2.2,0,0,1,.26.07.19.19,0,0,1-.07.26l-3,1.73A.16.16,0,0,1,233.1,286.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M225.41,302.48a.17.17,0,0,1-.16-.1.19.19,0,0,1,.07-.26l1.57-.91a.19.19,0,0,1,.26.07.18.18,0,0,1-.07.26l-1.57.91A.19.19,0,0,1,225.41,302.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M227.92,301a.2.2,0,0,1-.17-.09.19.19,0,0,1,.07-.26l4.54-2.62a.18.18,0,0,1,.26.07.2.2,0,0,1-.07.26L228,301Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M233.35,297.9a.21.21,0,0,1-.17-.1.2.2,0,0,1,.07-.26L236,296a.2.2,0,0,1,.26.07.19.19,0,0,1-.07.26l-2.76,1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M225.41,303.93a.18.18,0,0,1-.16-.09.18.18,0,0,1,.07-.26l3.53-2a.19.19,0,0,1,.19.33l-3.53,2A.18.18,0,0,1,225.41,303.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M229.87,301.36a.19.19,0,0,1-.16-.1.19.19,0,0,1,.07-.26l3.76-2.17a.19.19,0,0,1,.19.33L230,301.33A.19.19,0,0,1,229.87,301.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M234.53,298.67a.2.2,0,0,1-.17-.09.19.19,0,0,1,.07-.26l1.58-.91a.18.18,0,0,1,.26.07.2.2,0,0,1-.07.26l-1.58.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M225.41,301a.19.19,0,0,1-.16-.1.18.18,0,0,1,.07-.26l2.12-1.22a.18.18,0,0,1,.26.07.2.2,0,0,1-.07.26L225.51,301A.19.19,0,0,1,225.41,301Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M232.37,297a.19.19,0,0,1-.16-.1.19.19,0,0,1,.07-.26l1.28-.74a.19.19,0,0,1,.26.07.18.18,0,0,1-.07.26l-1.28.74A.17.17,0,0,1,232.37,297Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M228.46,299.26a.18.18,0,0,1-.16-.09.18.18,0,0,1,.07-.26l3-1.75a.2.2,0,0,1,.26.07.19.19,0,0,1-.07.26l-3,1.75A.18.18,0,0,1,228.46,299.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M234.55,295.75a.2.2,0,0,1-.17-.09.21.21,0,0,1,.07-.27l1.56-.89a.2.2,0,0,1,.26.07.19.19,0,0,1-.07.26l-1.56.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M225.41,299.57a.18.18,0,0,1-.16-.09.18.18,0,0,1,.07-.26l2.83-1.64a.19.19,0,0,1,.19.33l-2.83,1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M229.17,297.4a.18.18,0,0,1-.16-.09.2.2,0,0,1,.07-.27l3-1.75a.19.19,0,0,1,.26.07.18.18,0,0,1-.07.26l-3,1.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M233.1,295.13a.2.2,0,0,1-.17-.09.19.19,0,0,1,.07-.26l3-1.74a.2.2,0,0,1,.26.07.19.19,0,0,1-.07.26l-3,1.74A.15.15,0,0,1,233.1,295.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M234.09,267.56a.22.22,0,0,1-.18-.1.21.21,0,0,1,.08-.28l1.67-1a.21.21,0,0,1,.28.08.2.2,0,0,1-.07.27l-1.68,1A.19.19,0,0,1,234.09,267.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M236.75,266a.21.21,0,0,1-.17-.1.2.2,0,0,1,.07-.28l4.83-2.78a.19.19,0,0,1,.27.07.2.2,0,0,1-.07.28L236.85,266A.17.17,0,0,1,236.75,266Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M242.53,262.69a.22.22,0,0,1-.18-.1.21.21,0,0,1,.07-.28l2.93-1.69a.2.2,0,0,1,.28.07.21.21,0,0,1-.07.28l-2.93,1.69A.19.19,0,0,1,242.53,262.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M234.09,269.11a.21.21,0,0,1-.18-.11.2.2,0,0,1,.08-.27l3.75-2.17a.2.2,0,1,1,.2.35l-3.75,2.17A.19.19,0,0,1,234.09,269.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M238.83,266.37a.22.22,0,0,1-.18-.1.21.21,0,0,1,.08-.28l4-2.31a.21.21,0,0,1,.28.07.21.21,0,0,1-.08.28l-4,2.31A.17.17,0,0,1,238.83,266.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M243.78,263.51a.22.22,0,0,1-.18-.1.21.21,0,0,1,.08-.28l1.67-1a.21.21,0,0,1,.21.36l-1.68,1A.19.19,0,0,1,243.78,263.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M234.09,266a.2.2,0,0,1-.1-.37l2.25-1.31a.21.21,0,0,1,.28.08.2.2,0,0,1-.08.27L234.19,266A.18.18,0,0,1,234.09,266Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M241.49,261.74a.22.22,0,0,1-.18-.1.21.21,0,0,1,.08-.28l1.37-.79a.2.2,0,0,1,.27.08.19.19,0,0,1-.07.27l-1.37.79A.19.19,0,0,1,241.49,261.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M237.33,264.14a.19.19,0,0,1-.17-.1.2.2,0,0,1,.07-.28l3.22-1.86a.21.21,0,0,1,.28.08.19.19,0,0,1-.08.27l-3.22,1.86A.17.17,0,0,1,237.33,264.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M243.8,260.4a.19.19,0,0,1-.17-.1.2.2,0,0,1,.07-.27l1.65-1a.21.21,0,0,1,.28.08.2.2,0,0,1-.07.27l-1.65,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M234.09,264.47a.22.22,0,0,1-.18-.1.21.21,0,0,1,.08-.28l3-1.74a.2.2,0,0,1,.27.08.19.19,0,0,1-.07.27l-3,1.74A.19.19,0,0,1,234.09,264.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M238.09,262.16a.22.22,0,0,1-.18-.1.21.21,0,0,1,.07-.28l3.23-1.86a.2.2,0,0,1,.28.07.21.21,0,0,1-.07.28l-3.23,1.86A.19.19,0,0,1,238.09,262.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M242.26,259.75a.19.19,0,0,1-.17-.1.2.2,0,0,1,.07-.28l3.19-1.84a.2.2,0,0,1,.28.07.21.21,0,0,1-.07.28l-3.2,1.84A.17.17,0,0,1,242.26,259.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M199,273.57a.21.21,0,0,1-.18-.11.2.2,0,0,1,.08-.27l2.25-1.3a.2.2,0,0,1,.28.07.21.21,0,0,1-.07.28l-2.26,1.3A.17.17,0,0,1,199,273.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M206.36,269.29a.19.19,0,0,1-.17-.1.21.21,0,0,1,.07-.28l1.37-.79a.21.21,0,1,1,.2.36l-1.36.78A.23.23,0,0,1,206.36,269.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M202.21,271.69a.19.19,0,0,1-.18-.1.21.21,0,0,1,.07-.28l3.23-1.86a.21.21,0,0,1,.2.36l-3.22,1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M208.68,268a.21.21,0,0,1-.18-.11.2.2,0,0,1,.08-.27l1.65-1a.21.21,0,0,1,.28.08.21.21,0,0,1-.08.28l-1.65.95A.19.19,0,0,1,208.68,268Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M199,272a.22.22,0,0,1-.18-.1.21.21,0,0,1,.08-.28l3-1.74a.21.21,0,0,1,.28.08.2.2,0,0,1-.08.27l-3,1.74A.17.17,0,0,1,199,272Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M203,269.71a.22.22,0,0,1-.18-.1.21.21,0,0,1,.08-.28l3.23-1.86a.2.2,0,0,1,.27.07.2.2,0,0,1-.07.28l-3.23,1.86A.19.19,0,0,1,203,269.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M207.14,267.3a.2.2,0,0,1-.11-.38l3.2-1.84a.2.2,0,0,1,.28.07.21.21,0,0,1-.08.28l-3.19,1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M247.85,284.23a.29.29,0,0,0,.25-.22,6.7,6.7,0,0,0,.24-1.75c0-2.56-1.75-3.65-4-2.52a.29.29,0,0,0-.16.26v4.48a.08.08,0,0,0,0,.07.11.11,0,0,0,.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M243.61,280.27a.11.11,0,0,0-.06-.11.15.15,0,0,0-.13,0,9.32,9.32,0,0,0-3.92,7.07,3.07,3.07,0,0,0,1,2.55.16.16,0,0,0,.13,0,.15.15,0,0,0,.11-.08l2.78-4.8a.68.68,0,0,0,.08-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M244.23,285.14a.21.21,0,0,0-.16.11l-2.81,4.85a.17.17,0,0,0,0,.12.11.11,0,0,0,.08.08,3.12,3.12,0,0,0,2.74-.41,9.32,9.32,0,0,0,3.8-5,.12.12,0,0,0,0-.1.09.09,0,0,0-.09,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "165.42 328.86 163 330.26 163 327.48 165.42 326.09 165.42 328.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "170.06 326.19 167.64 327.58 167.64 324.81 170.06 323.41 170.06 326.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "174.69 323.51 172.27 324.91 172.27 322.13 174.69 320.73 174.69 323.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "179.33 320.83 176.91 322.23 176.91 319.45 179.33 318.06 179.33 320.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "183.96 318.16 181.54 319.55 181.54 316.78 183.96 315.38 183.96 318.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "183.96 317.08 163 329.18 163 328.56 183.96 316.46 183.96 317.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M175.5,324l-4,2.33v-4.63l4-2.33Zm-3.77,1.86,3.5-2v-4l-3.5,2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "235.22 259.16 233.52 260.14 233.52 255.56 235.22 254.58 235.22 259.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "237.69 257.73 236 258.71 236 252.51 237.69 251.53 237.69 257.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "240.17 256.3 238.47 257.28 238.47 248.43 240.17 247.45 240.17 256.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "242.65 254.87 240.95 255.85 240.95 245.82 242.65 244.84 242.65 254.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "245.13 253.44 243.43 254.42 243.43 246.38 245.13 245.4 245.13 253.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "209 324.23 207.86 324.89 207.86 321.82 209 321.16 209 324.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "210.67 323.27 209.53 323.93 209.53 317.03 210.67 316.37 210.67 323.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "212.33 322.31 211.19 322.97 211.19 317.03 212.33 316.37 212.33 322.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "213.99 321.35 212.85 322.01 212.85 315.28 213.99 314.62 213.99 321.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "215.66 320.39 214.52 321.05 214.52 315.65 215.66 315 215.66 320.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M161.69,296a.21.21,0,0,1-.17-.1.19.19,0,0,1,.07-.26l1.58-.91a.19.19,0,0,1,.26.07.18.18,0,0,1-.07.26l-1.58.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M164.2,294.56a.19.19,0,0,1-.17-.1.2.2,0,0,1,.07-.26l4.54-2.62a.19.19,0,0,1,.26.07.18.18,0,0,1-.07.26l-4.54,2.62A.16.16,0,0,1,164.2,294.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M169.63,291.42a.2.2,0,0,1-.17-.09.19.19,0,0,1,.07-.26l2.76-1.59a.18.18,0,0,1,.26.07.2.2,0,0,1-.07.26l-2.76,1.59A.15.15,0,0,1,169.63,291.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M161.69,297.46a.2.2,0,0,1-.17-.09.19.19,0,0,1,.07-.26l3.54-2a.2.2,0,0,1,.26.07.19.19,0,0,1-.07.26l-3.54,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M166.15,294.89a.19.19,0,0,1-.16-.1.18.18,0,0,1,.07-.26l3.76-2.17a.18.18,0,0,1,.26.07.19.19,0,0,1-.07.26l-3.76,2.17A.19.19,0,0,1,166.15,294.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M170.81,292.2a.21.21,0,0,1-.17-.1.19.19,0,0,1,.07-.26l1.58-.91a.19.19,0,1,1,.19.33l-1.58.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M161.69,294.55a.2.2,0,0,1-.17-.09.19.19,0,0,1,.07-.26l2.13-1.23a.2.2,0,0,1,.26.07.19.19,0,0,1-.07.26l-2.13,1.23A.15.15,0,0,1,161.69,294.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M168.65,290.53a.18.18,0,0,1-.16-.09.19.19,0,0,1,.07-.26l1.28-.75a.21.21,0,0,1,.27.07.19.19,0,0,1-.07.26l-1.29.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M164.74,292.79a.18.18,0,0,1-.16-.09.18.18,0,0,1,.07-.26l3-1.76a.19.19,0,0,1,.26.07.21.21,0,0,1-.07.27l-3,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M170.83,289.28a.19.19,0,0,1-.16-.1.18.18,0,0,1,.07-.26l1.55-.9a.19.19,0,1,1,.19.33l-1.55.9A.19.19,0,0,1,170.83,289.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M161.69,293.1a.21.21,0,0,1-.17-.1.2.2,0,0,1,.07-.26l2.84-1.63a.2.2,0,0,1,.26.07.19.19,0,0,1-.07.26l-2.84,1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M165.45,290.93a.19.19,0,0,1-.16-.1.18.18,0,0,1,.07-.26l3-1.75a.19.19,0,0,1,.26.07.18.18,0,0,1-.07.26l-3,1.75A.19.19,0,0,1,165.45,290.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M169.38,288.66a.21.21,0,0,1-.17-.1.2.2,0,0,1,.07-.26l3-1.73a.19.19,0,1,1,.19.33l-3,1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M161.69,302.67a.21.21,0,0,1-.17-.1.19.19,0,0,1,.07-.26l1.58-.91a.19.19,0,0,1,.26.07.18.18,0,0,1-.07.26l-1.58.91A.16.16,0,0,1,161.69,302.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M164.2,301.22a.21.21,0,0,1-.17-.1.19.19,0,0,1,.07-.26l4.54-2.62a.19.19,0,0,1,.26.07.18.18,0,0,1-.07.26l-4.54,2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M169.63,298.08a.2.2,0,0,1-.17-.09.19.19,0,0,1,.07-.26l2.76-1.6a.19.19,0,1,1,.19.33l-2.76,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M161.69,304.12a.19.19,0,0,1-.17-.1.2.2,0,0,1,.07-.26l3.54-2a.2.2,0,0,1,.26.07.19.19,0,0,1-.07.26l-3.54,2A.16.16,0,0,1,161.69,304.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M166.15,301.54a.18.18,0,0,1-.16-.09.18.18,0,0,1,.07-.26l3.76-2.18a.19.19,0,0,1,.26.07.18.18,0,0,1-.07.26l-3.76,2.18A.18.18,0,0,1,166.15,301.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M170.81,298.86a.21.21,0,0,1-.17-.1.19.19,0,0,1,.07-.26l1.58-.91a.19.19,0,0,1,.19.33l-1.58.91A.16.16,0,0,1,170.81,298.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M161.69,301.21a.2.2,0,0,1-.17-.09.21.21,0,0,1,.07-.27l2.13-1.22a.2.2,0,0,1,.26.07.19.19,0,0,1-.07.26l-2.13,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M168.65,297.19a.17.17,0,0,1-.16-.1.2.2,0,0,1,.07-.26l1.28-.74a.21.21,0,0,1,.27.07.19.19,0,0,1-.07.26l-1.29.74A.17.17,0,0,1,168.65,297.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M164.74,299.45a.19.19,0,0,1-.16-.1.18.18,0,0,1,.07-.26l3-1.75a.19.19,0,1,1,.19.33l-3,1.75A.19.19,0,0,1,164.74,299.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M170.83,295.93a.18.18,0,0,1-.16-.09.18.18,0,0,1,.07-.26l1.55-.9a.19.19,0,1,1,.19.33l-1.55.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M161.69,299.76a.21.21,0,0,1-.17-.1.19.19,0,0,1,.07-.26l2.84-1.64a.2.2,0,0,1,.26.07.19.19,0,0,1-.07.26l-2.84,1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M165.45,297.58a.18.18,0,0,1-.16-.09.18.18,0,0,1,.07-.26l3-1.76a.19.19,0,0,1,.26.07.2.2,0,0,1-.07.27l-3,1.75A.18.18,0,0,1,165.45,297.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M169.38,295.32a.21.21,0,0,1-.17-.1.19.19,0,0,1,.07-.26l3-1.74a.19.19,0,0,1,.26.07.21.21,0,0,1-.07.27l-3,1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M161.69,309.27a.19.19,0,0,1-.17-.1.2.2,0,0,1,.07-.26l1.58-.91a.19.19,0,0,1,.26.07.18.18,0,0,1-.07.26l-1.58.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M164.2,307.82a.2.2,0,0,1-.17-.09.19.19,0,0,1,.07-.26l4.54-2.63a.19.19,0,0,1,.26.07.2.2,0,0,1-.07.27l-4.54,2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M169.63,304.69a.21.21,0,0,1-.17-.1.19.19,0,0,1,.07-.26l2.76-1.59a.19.19,0,0,1,.19.33l-2.76,1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M161.69,310.72a.2.2,0,0,1-.17-.09.19.19,0,0,1,.07-.26l3.54-2a.2.2,0,0,1,.26.07.19.19,0,0,1-.07.26l-3.54,2A.15.15,0,0,1,161.69,310.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M166.15,308.15a.19.19,0,0,1-.16-.1.18.18,0,0,1,.07-.26l3.76-2.17a.19.19,0,0,1,.26.07.18.18,0,0,1-.07.26l-3.76,2.17A.19.19,0,0,1,166.15,308.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M170.81,305.46a.19.19,0,0,1-.17-.1.2.2,0,0,1,.07-.26l1.58-.91a.19.19,0,0,1,.19.33l-1.58.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M161.69,307.82a.21.21,0,0,1-.17-.1.19.19,0,0,1,.07-.26l2.13-1.23a.2.2,0,0,1,.26.07.19.19,0,0,1-.07.26l-2.13,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M168.65,303.79a.18.18,0,0,1-.16-.09.19.19,0,0,1,.07-.26l1.28-.74a.19.19,0,0,1,.27.07.2.2,0,0,1-.07.26l-1.29.74A.16.16,0,0,1,168.65,303.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M164.74,306.05a.18.18,0,0,1-.16-.09.18.18,0,0,1,.07-.26l3-1.75a.18.18,0,0,1,.26.07.2.2,0,0,1-.07.26l-3,1.75A.18.18,0,0,1,164.74,306.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M170.83,302.54a.19.19,0,0,1-.16-.1.18.18,0,0,1,.07-.26l1.55-.9a.19.19,0,0,1,.26.07.19.19,0,0,1-.07.26l-1.55.9A.19.19,0,0,1,170.83,302.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M161.69,306.36a.2.2,0,0,1-.17-.09.21.21,0,0,1,.07-.27l2.84-1.63a.2.2,0,0,1,.26.07.19.19,0,0,1-.07.26l-2.84,1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M165.45,304.19a.19.19,0,0,1-.16-.1.18.18,0,0,1,.07-.26l3-1.75a.19.19,0,0,1,.26.07.18.18,0,0,1-.07.26l-3,1.75A.19.19,0,0,1,165.45,304.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M169.38,301.92a.2.2,0,0,1-.17-.09.21.21,0,0,1,.07-.27l3-1.73a.19.19,0,1,1,.19.33l-3,1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M175.2,288.46a.21.21,0,0,1-.17-.1.19.19,0,0,1,.07-.26l1.58-.91a.19.19,0,1,1,.19.33l-1.58.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M177.71,287a.21.21,0,0,1-.17-.1.19.19,0,0,1,.07-.26l4.54-2.62a.19.19,0,1,1,.19.33L177.8,287Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M183.14,283.87a.2.2,0,0,1-.17-.09.19.19,0,0,1,.07-.26l2.76-1.59a.18.18,0,0,1,.26.06.21.21,0,0,1-.07.27l-2.76,1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M175.2,289.91a.2.2,0,0,1-.17-.09.19.19,0,0,1,.07-.26l3.53-2a.19.19,0,0,1,.27.07.2.2,0,0,1-.07.26l-3.54,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M179.66,287.33a.2.2,0,0,1-.17-.09.19.19,0,0,1,.07-.26l3.77-2.18a.19.19,0,0,1,.26.07.21.21,0,0,1-.07.27l-3.76,2.17A.18.18,0,0,1,179.66,287.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M184.32,284.65a.21.21,0,0,1-.17-.1.19.19,0,0,1,.07-.26l1.58-.91a.19.19,0,1,1,.19.33l-1.58.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M175.2,287a.2.2,0,0,1-.17-.09.19.19,0,0,1,.07-.26l2.12-1.23a.19.19,0,0,1,.26.07.18.18,0,0,1-.07.26L175.29,287Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M182.16,283a.18.18,0,0,1-.16-.09.2.2,0,0,1,.07-.27l1.28-.74a.19.19,0,0,1,.26.07.18.18,0,0,1-.07.26l-1.28.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M178.25,285.24a.19.19,0,0,1-.17-.1.2.2,0,0,1,.07-.26l3-1.75a.2.2,0,0,1,.26.07.19.19,0,0,1-.07.26l-3,1.75A.16.16,0,0,1,178.25,285.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M184.34,281.72a.2.2,0,0,1-.17-.09.19.19,0,0,1,.07-.26l1.56-.9a.19.19,0,1,1,.19.33l-1.56.9A.15.15,0,0,1,184.34,281.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M175.2,285.55a.21.21,0,0,1-.17-.1.19.19,0,0,1,.07-.26l2.83-1.63a.19.19,0,0,1,.27.07.2.2,0,0,1-.07.26l-2.84,1.63A.16.16,0,0,1,175.2,285.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M179,283.37a.2.2,0,0,1-.17-.09.19.19,0,0,1,.07-.26l3-1.75a.18.18,0,0,1,.26.07.2.2,0,0,1-.07.26l-3,1.75A.18.18,0,0,1,179,283.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M182.89,281.11a.21.21,0,0,1-.17-.1.19.19,0,0,1,.07-.26l3-1.73a.18.18,0,0,1,.26.07.2.2,0,0,1-.07.26l-3,1.73A.16.16,0,0,1,182.89,281.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "193.46 279.01 189.61 281.24 189.61 276.81 193.46 274.59 193.46 279.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "193.46 285.88 189.61 288.11 189.61 283.68 193.46 281.45 193.46 285.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "193.46 292.58 189.61 294.81 189.61 290.38 193.46 288.16 193.46 292.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M175.2,295.11A.2.2,0,0,1,175,295a.19.19,0,0,1,.07-.26l1.58-.91a.18.18,0,0,1,.26.07.2.2,0,0,1-.07.26l-1.58.91A.15.15,0,0,1,175.2,295.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M177.71,293.67a.21.21,0,0,1-.17-.1.19.19,0,0,1,.07-.26l4.54-2.62a.19.19,0,1,1,.19.33l-4.54,2.62A.16.16,0,0,1,177.71,293.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M183.14,290.53a.19.19,0,0,1-.17-.1.2.2,0,0,1,.07-.26l2.76-1.59a.19.19,0,1,1,.19.33l-2.76,1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M175.2,296.57a.21.21,0,0,1-.17-.1.19.19,0,0,1,.07-.26l3.53-2a.21.21,0,0,1,.27.07.19.19,0,0,1-.07.26l-3.54,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M179.66,294a.2.2,0,0,1-.17-.09.19.19,0,0,1,.07-.26l3.77-2.18a.19.19,0,1,1,.19.33L179.76,294Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M184.32,291.3a.2.2,0,0,1-.17-.09.19.19,0,0,1,.07-.26l1.58-.91a.18.18,0,0,1,.26.07.2.2,0,0,1-.07.26l-1.58.91A.15.15,0,0,1,184.32,291.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M175.2,293.66a.21.21,0,0,1-.17-.1.2.2,0,0,1,.07-.26l2.12-1.22a.19.19,0,0,1,.26.07.18.18,0,0,1-.07.26l-2.12,1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M182.16,289.64a.19.19,0,0,1-.16-.1.18.18,0,0,1,.07-.26l1.28-.74a.19.19,0,0,1,.26.07.18.18,0,0,1-.07.26l-1.28.74A.19.19,0,0,1,182.16,289.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M178.25,291.9a.21.21,0,0,1-.17-.1.19.19,0,0,1,.07-.26l3-1.75a.2.2,0,0,1,.26.07.19.19,0,0,1-.07.26l-3,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M184.34,288.38a.2.2,0,0,1-.17-.09.21.21,0,0,1,.07-.27l1.56-.89a.19.19,0,1,1,.19.33l-1.56.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M175.2,292.2a.2.2,0,0,1-.17-.09.19.19,0,0,1,.07-.26l2.83-1.64a.21.21,0,0,1,.27.07.19.19,0,0,1-.07.26l-2.84,1.64A.15.15,0,0,1,175.2,292.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M179,290a.2.2,0,0,1-.17-.09.19.19,0,0,1,.07-.26l3-1.76a.19.19,0,1,1,.19.33l-3,1.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M182.89,287.76a.2.2,0,0,1-.17-.09.19.19,0,0,1,.07-.26l3-1.74a.19.19,0,1,1,.19.33l-3,1.74A.15.15,0,0,1,182.89,287.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M175.2,301.72a.21.21,0,0,1-.17-.1.2.2,0,0,1,.07-.26l1.58-.91a.19.19,0,1,1,.19.33l-1.58.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M177.71,300.27a.19.19,0,0,1-.17-.1.2.2,0,0,1,.07-.26l4.54-2.62a.19.19,0,1,1,.19.33l-4.54,2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M183.14,297.13A.2.2,0,0,1,183,297a.19.19,0,0,1,.07-.26l2.76-1.59a.18.18,0,0,1,.26.07.2.2,0,0,1-.07.26l-2.76,1.59A.15.15,0,0,1,183.14,297.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M175.2,303.17a.2.2,0,0,1-.17-.09.19.19,0,0,1,.07-.26l3.53-2a.21.21,0,0,1,.27.07.19.19,0,0,1-.07.26l-3.54,2A.15.15,0,0,1,175.2,303.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M179.66,300.6a.21.21,0,0,1-.17-.1.19.19,0,0,1,.07-.26l3.77-2.17a.18.18,0,0,1,.26.07.2.2,0,0,1-.07.26l-3.76,2.17A.19.19,0,0,1,179.66,300.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M184.32,297.91a.21.21,0,0,1-.17-.1.19.19,0,0,1,.07-.26l1.58-.91a.19.19,0,1,1,.19.33l-1.58.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M175.2,300.26a.2.2,0,0,1-.17-.09.19.19,0,0,1,.07-.26l2.12-1.23a.19.19,0,0,1,.26.07.18.18,0,0,1-.07.26l-2.12,1.23A.15.15,0,0,1,175.2,300.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M182.16,296.24a.18.18,0,0,1-.16-.09.18.18,0,0,1,.07-.26l1.28-.75a.19.19,0,0,1,.26.07.18.18,0,0,1-.07.26l-1.28.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M178.25,298.5a.2.2,0,0,1-.17-.09.19.19,0,0,1,.07-.26l3-1.75a.18.18,0,0,1,.26.07.2.2,0,0,1-.07.26l-3,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M184.34,295a.21.21,0,0,1-.17-.1.19.19,0,0,1,.07-.26l1.56-.9a.19.19,0,1,1,.19.33l-1.56.9A.16.16,0,0,1,184.34,295Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M175.2,298.81a.19.19,0,0,1-.17-.1.2.2,0,0,1,.07-.26l2.83-1.63a.21.21,0,0,1,.27.07.19.19,0,0,1-.07.26l-2.84,1.63A.16.16,0,0,1,175.2,298.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M179,296.64a.21.21,0,0,1-.17-.1.19.19,0,0,1,.07-.26l3-1.75a.19.19,0,1,1,.19.33l-3,1.75A.19.19,0,0,1,179,296.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M182.89,294.37a.19.19,0,0,1-.17-.1.2.2,0,0,1,.07-.26l3-1.73a.19.19,0,1,1,.19.33l-3,1.73A.16.16,0,0,1,182.89,294.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M198.63,288c0,.27,32.55-18.8,32.55-18.8s-1.91-5.35-6.85-2.39-4.89,3.13-8.4,2.66c-3.23-.45-3.94,1.08-6,4s-2.22,6.57-4.07,8.06C202.57,284.23,198.63,283.27,198.63,288Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "198.67 290.1 198.59 289.7 231.62 270.69 231.71 271.09 198.67 290.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M207.91,306.52a.17.17,0,0,1-.16-.1.18.18,0,0,1,.07-.26l1.57-.91a.19.19,0,0,1,.26.07.18.18,0,0,1-.07.26l-1.57.91A.19.19,0,0,1,207.91,306.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M210.42,305.07a.2.2,0,0,1-.17-.09.19.19,0,0,1,.07-.26l4.54-2.62a.18.18,0,0,1,.26.07.2.2,0,0,1-.07.26l-4.54,2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M207.91,308a.18.18,0,0,1-.16-.09.18.18,0,0,1,.07-.26l3.53-2a.2.2,0,0,1,.26.07.19.19,0,0,1-.07.26L208,308Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M212.37,305.4a.19.19,0,0,1-.16-.1.18.18,0,0,1,.07-.26l3.76-2.17a.19.19,0,0,1,.19.33l-3.76,2.17A.19.19,0,0,1,212.37,305.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M207.91,310.46a.18.18,0,0,1-.16-.09.19.19,0,0,1,.07-.27l1.57-.91a.19.19,0,0,1,.26.07.18.18,0,0,1-.07.26l-1.57.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M210.42,309a.2.2,0,0,1-.17-.09.19.19,0,0,1,.07-.26l4.54-2.62a.19.19,0,0,1,.19.33L210.51,309Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M207.91,311.91a.18.18,0,0,1-.16-.09.18.18,0,0,1,.07-.26l3.53-2a.2.2,0,0,1,.26.07.19.19,0,0,1-.07.26l-3.53,2A.18.18,0,0,1,207.91,311.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M212.37,309.34a.17.17,0,0,1-.16-.1.18.18,0,0,1,.07-.26l3.76-2.17a.19.19,0,0,1,.19.33l-3.76,2.17A.19.19,0,0,1,212.37,309.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M207.91,304.08a.19.19,0,0,1-.16-.1.18.18,0,0,1,.07-.26l2.12-1.22a.19.19,0,0,1,.26.07.2.2,0,0,1-.07.26L208,304.05A.19.19,0,0,1,207.91,304.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M214.87,300.06a.19.19,0,0,1-.16-.1.18.18,0,0,1,.07-.26l1.28-.74a.19.19,0,0,1,.26.07.18.18,0,0,1-.07.26L215,300A.19.19,0,0,1,214.87,300.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M211,302.32a.19.19,0,0,1-.16-.1.18.18,0,0,1,.07-.26l3-1.75a.2.2,0,0,1,.26.07.19.19,0,0,1-.07.26l-3,1.75A.19.19,0,0,1,211,302.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M207.91,302.62a.18.18,0,0,1-.16-.09.18.18,0,0,1,.07-.26l2.83-1.64a.2.2,0,0,1,.26.07.19.19,0,0,1-.07.26L208,302.6A.18.18,0,0,1,207.91,302.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M211.67,300.45a.18.18,0,0,1-.16-.09.18.18,0,0,1,.07-.26l3-1.76a.19.19,0,0,1,.26.07.19.19,0,0,1-.07.26l-3,1.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M201.12,312a.28.28,0,0,0,.24-.2,6.56,6.56,0,0,0,.22-1.61c0-2.38-1.63-3.38-3.67-2.33a.24.24,0,0,0-.13.21v4.16a.08.08,0,0,0,0,.07.11.11,0,0,0,.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M197.21,308.38a.11.11,0,0,0-.06-.1.11.11,0,0,0-.12,0,8.61,8.61,0,0,0-3.62,6.52,2.82,2.82,0,0,0,.94,2.36.13.13,0,0,0,.12,0,.16.16,0,0,0,.1-.08l2.57-4.43a.58.58,0,0,0,.07-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M197.78,312.89a.19.19,0,0,0-.15.09L195,317.47a.12.12,0,0,0,0,.1.11.11,0,0,0,.07.08,2.88,2.88,0,0,0,2.53-.38,8.58,8.58,0,0,0,3.51-4.59.1.1,0,0,0,0-.09.09.09,0,0,0-.09,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "206.1 305.45 203.75 306.81 203.75 304.11 206.1 302.75 206.1 305.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "206.1 309.63 203.75 310.99 203.75 308.29 206.1 306.94 206.1 309.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "206.1 313.72 203.75 315.08 203.75 312.38 206.1 311.02 206.1 313.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M194.33,330.63a.19.19,0,0,1-.16-.1.19.19,0,0,1,.07-.26l1.58-.91a.2.2,0,0,1,.26.07.19.19,0,0,1-.07.26l-1.58.91A.17.17,0,0,1,194.33,330.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M196.84,329.18a.18.18,0,0,1-.16-.09.19.19,0,0,1,.07-.27l4.54-2.62a.2.2,0,0,1,.26.07.19.19,0,0,1-.07.26l-4.54,2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M202.27,326.05a.19.19,0,0,1-.16-.1.18.18,0,0,1,.07-.26l2.75-1.59a.18.18,0,0,1,.26.07.18.18,0,0,1-.07.26L202.37,326A.19.19,0,0,1,202.27,326.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M194.33,332.08a.18.18,0,0,1-.16-.09.18.18,0,0,1,.07-.26l3.53-2a.19.19,0,0,1,.19.33l-3.53,2A.16.16,0,0,1,194.33,332.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M198.8,329.51a.21.21,0,0,1-.17-.1.19.19,0,0,1,.07-.26l3.77-2.17a.2.2,0,0,1,.26.07.19.19,0,0,1-.07.26l-3.77,2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M203.45,326.82a.19.19,0,0,1-.16-.1.18.18,0,0,1,.07-.26l1.57-.91a.19.19,0,0,1,.26.07.18.18,0,0,1-.07.26l-1.57.91A.19.19,0,0,1,203.45,326.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M194.33,329.17a.18.18,0,0,1-.16-.09.18.18,0,0,1,.07-.26l2.12-1.23a.19.19,0,1,1,.19.33l-2.12,1.23A.16.16,0,0,1,194.33,329.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M201.3,325.15a.2.2,0,0,1-.17-.09.19.19,0,0,1,.07-.26l1.29-.75a.19.19,0,0,1,.26.07.21.21,0,0,1-.07.27l-1.29.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M197.39,327.41a.19.19,0,0,1-.17-.09.19.19,0,0,1,.07-.26l3-1.75a.18.18,0,0,1,.26.07.2.2,0,0,1-.07.26l-3,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M203.47,323.9a.19.19,0,0,1-.16-.1.19.19,0,0,1,.07-.26l1.55-.9a.19.19,0,0,1,.26.07.18.18,0,0,1-.07.26l-1.55.9A.17.17,0,0,1,203.47,323.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M194.33,327.72a.17.17,0,0,1-.16-.1.19.19,0,0,1,.07-.26l2.83-1.63a.19.19,0,0,1,.19.33l-2.83,1.63A.17.17,0,0,1,194.33,327.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M198.1,325.55a.21.21,0,0,1-.17-.1.19.19,0,0,1,.07-.26l3-1.75a.2.2,0,0,1,.26.07.19.19,0,0,1-.07.26l-3,1.75A.16.16,0,0,1,198.1,325.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M202,323.28a.17.17,0,0,1-.16-.1.19.19,0,0,1,.07-.26l3-1.73a.19.19,0,0,1,.26.07.18.18,0,0,1-.07.26l-3,1.73A.17.17,0,0,1,202,323.28Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-146",
    points: "489.81 210.04 489.81 168.05 452.51 146.68 451.45 146.34 451.45 187.97 451.87 188.58 489.31 210.04 489.81 210.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-147",
    points: "492.13 166.34 492.29 166.63 490.01 168.1 452.35 146.97 452.42 145.56 454.02 144.67 455.66 144.68 492.08 165.72 492.13 166.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-148",
    points: "489.81 168.05 489.81 210.04 490.35 210.04 492.6 208.77 492.99 208.25 492.99 166.25 492.56 166.28 492.33 166.63 489.81 168.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M454.84,145.5l35.91,20.75-.74.57L453.4,146.29Zm0-1.29-3.3,1.87a.22.22,0,0,0-.12.21.24.24,0,0,0,.12.22L490,168.1l3-1.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M454.84,269.47l-3.3,1.87a.24.24,0,0,0-.12.22.22.22,0,0,0,.12.21L490,293.37l3-1.86Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "479.43 193.42 482.86 195.4 482.86 186.14 479.43 184.16 479.43 193.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "474.42 190.52 477.85 192.51 477.85 171.72 474.42 169.74 474.42 190.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "469.4 187.63 472.84 189.62 472.84 171.73 469.4 169.74 469.4 187.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "464.39 184.74 467.83 186.72 467.83 166.44 464.39 164.46 464.39 184.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "459.38 181.85 462.82 183.83 462.82 167.58 459.38 165.6 459.38 181.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M192.55,246.5a.28.28,0,0,1-.27-.28V207.27a.28.28,0,0,1,.55,0v38.95A.28.28,0,0,1,192.55,246.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M207.65,237.63a.28.28,0,0,1-.28-.27v-36.6a.29.29,0,0,1,.28-.28.28.28,0,0,1,.27.28v36.6A.27.27,0,0,1,207.65,237.63Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-151",
    points: "43.55 397.61 43.55 355.62 80.84 334.25 81.9 333.91 81.9 375.55 81.48 376.16 44.04 397.61 43.55 397.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-152",
    points: "41.22 353.92 41.07 354.2 43.34 355.68 81 334.55 80.94 333.14 79.33 332.24 77.69 332.25 41.27 353.3 41.22 353.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-153",
    points: "43.55 355.62 43.55 397.61 43 397.61 40.76 396.35 40.36 395.83 40.36 353.83 40.8 353.86 41.03 354.21 43.55 355.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M78.51,333.07l1.44.8-36.6,20.52-.75-.56Zm0-1.29L40.38,353.83l3,1.85,38.47-21.59a.25.25,0,0,0,0-.44Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-155",
    points: "78.7 340.75 47.98 358.49 47.98 380.29 78.7 362.55 78.7 340.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "65.64 358.42 60.26 357.96 60.26 365.08 65.64 358.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M63.6,376.86a.26.26,0,0,1,.24.13.28.28,0,0,1-.1.38l-2.26,1.3a.27.27,0,0,1-.38-.1.28.28,0,0,1,.1-.37l2.27-1.31A.31.31,0,0,1,63.6,376.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M60,378.93a.27.27,0,0,1,.24.14.28.28,0,0,1-.1.38l-6.52,3.76a.28.28,0,0,1-.27-.48L59.87,379A.33.33,0,0,1,60,378.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M52.21,383.43a.29.29,0,0,1,.24.14.29.29,0,0,1-.1.38l-4,2.28a.28.28,0,0,1-.38-.1.27.27,0,0,1,.11-.37l4-2.29A.33.33,0,0,1,52.21,383.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M63.6,374.77a.28.28,0,0,1,.24.13.28.28,0,0,1-.1.38l-5.07,2.93a.27.27,0,0,1-.37-.1.28.28,0,0,1,.1-.38l5.07-2.93A.31.31,0,0,1,63.6,374.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M57.2,378.47a.27.27,0,0,1,.24.13.29.29,0,0,1-.1.38l-5.41,3.12a.27.27,0,0,1-.37-.1.28.28,0,0,1,.1-.38l5.4-3.12A.32.32,0,0,1,57.2,378.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M50.52,382.32a.27.27,0,0,1,.23.14.28.28,0,0,1-.1.38l-2.26,1.3A.28.28,0,0,1,48,384a.27.27,0,0,1,.11-.37l2.26-1.31A.33.33,0,0,1,50.52,382.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M63.6,378.94a.27.27,0,0,1,.24.14.27.27,0,0,1-.1.37l-3,1.76a.28.28,0,0,1-.38-.1.27.27,0,0,1,.1-.37l3-1.76A.33.33,0,0,1,63.6,378.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M53.61,384.72a.26.26,0,0,1,.23.13.27.27,0,0,1-.1.38l-1.84,1.06a.28.28,0,0,1-.38-.1.27.27,0,0,1,.1-.37l1.85-1.07A.32.32,0,0,1,53.61,384.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M59.22,381.47a.27.27,0,0,1,.24.14.27.27,0,0,1-.1.37L55,384.5a.29.29,0,0,1-.38-.1.28.28,0,0,1,.11-.38l4.35-2.51A.22.22,0,0,1,59.22,381.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M50.48,386.52a.27.27,0,0,1,.14.51l-2.23,1.29a.29.29,0,0,1-.38-.1.28.28,0,0,1,.11-.38l2.23-1.28A.22.22,0,0,1,50.48,386.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M63.6,381a.27.27,0,0,1,.24.14.27.27,0,0,1-.1.37l-4.06,2.35a.29.29,0,0,1-.38-.1.27.27,0,0,1,.1-.37l4.07-2.35A.22.22,0,0,1,63.6,381Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M58.2,384.15a.27.27,0,0,1,.24.14.27.27,0,0,1-.1.37L54,387.18a.27.27,0,0,1-.37-.1.28.28,0,0,1,.1-.38l4.36-2.51A.22.22,0,0,1,58.2,384.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M52.57,387.4a.27.27,0,0,1,.23.14.28.28,0,0,1-.1.38l-4.31,2.49a.29.29,0,0,1-.38-.1.28.28,0,0,1,.11-.38l4.31-2.49A.33.33,0,0,1,52.57,387.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-156",
    points: "632.27 182.98 632.27 140.99 669.56 119.61 670.62 119.28 670.62 160.91 670.21 161.52 632.76 182.98 632.27 182.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-157",
    points: "629.94 139.28 629.79 139.56 632.06 141.04 669.72 119.91 669.66 118.5 668.05 117.61 666.42 117.62 629.99 138.66 629.94 139.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-158",
    points: "632.27 140.99 632.27 182.98 631.72 182.98 629.48 181.71 629.08 181.19 629.08 139.19 629.52 139.22 629.75 139.57 632.27 140.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M667.23,118.43l1.44.8-36.6,20.53-.75-.57Zm0-1.28-38.13,22,3,1.85,38.47-21.59a.25.25,0,0,0,0-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M652.14,160.77a.27.27,0,0,1,.23.14.26.26,0,0,1-.1.37L650,162.59a.29.29,0,0,1-.38-.1.28.28,0,0,1,.11-.38L652,160.8A.32.32,0,0,1,652.14,160.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M648.54,162.85a.28.28,0,0,1,.23.13.27.27,0,0,1-.1.38l-6.51,3.76a.28.28,0,0,1-.38-.1.27.27,0,0,1,.1-.37l6.52-3.77A.32.32,0,0,1,648.54,162.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M640.74,167.35a.28.28,0,0,1,.24.13.29.29,0,0,1-.1.38l-4,2.28a.27.27,0,1,1-.27-.47l4-2.29A.35.35,0,0,1,640.74,167.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M652.14,158.68a.27.27,0,0,1,.23.14.26.26,0,0,1-.1.37l-5.07,2.93a.28.28,0,0,1-.27-.48l5.07-2.92A.23.23,0,0,1,652.14,158.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M645.73,162.38a.27.27,0,0,1,.14.51L640.46,166a.28.28,0,0,1-.37-.1.27.27,0,0,1,.1-.37l5.41-3.12A.22.22,0,0,1,645.73,162.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M639.05,166.24a.29.29,0,0,1,.24.13.29.29,0,0,1-.1.38l-2.27,1.31a.28.28,0,0,1-.27-.48l2.26-1.31A.35.35,0,0,1,639.05,166.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M652.14,162.86a.28.28,0,0,1,.23.13.27.27,0,0,1-.1.38l-3,1.76a.28.28,0,1,1-.28-.48l3-1.76A.32.32,0,0,1,652.14,162.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M642.14,168.63a.28.28,0,0,1,.24.14.28.28,0,0,1-.1.37l-1.85,1.06a.26.26,0,0,1-.37-.1.27.27,0,0,1,.1-.37l1.84-1.07A.35.35,0,0,1,642.14,168.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M647.76,165.39a.26.26,0,0,1,.23.13.28.28,0,0,1-.1.38l-4.35,2.51a.27.27,0,0,1-.37-.1.28.28,0,0,1,.1-.38l4.35-2.51A.32.32,0,0,1,647.76,165.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M639,170.43a.27.27,0,0,1,.13.51l-2.23,1.29a.27.27,0,1,1-.27-.47l2.23-1.29A.23.23,0,0,1,639,170.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M652.14,164.94a.27.27,0,0,1,.23.14.27.27,0,0,1-.1.38l-4.06,2.34a.28.28,0,0,1-.38-.1.27.27,0,0,1,.1-.37L652,165A.33.33,0,0,1,652.14,164.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M646.74,168.06a.27.27,0,0,1,.13.51l-4.35,2.52a.28.28,0,1,1-.28-.48l4.36-2.51A.23.23,0,0,1,646.74,168.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M641.1,171.32a.29.29,0,0,1,.24.13.29.29,0,0,1-.1.38l-4.32,2.49a.27.27,0,0,1-.37-.1.28.28,0,0,1,.1-.38l4.31-2.49A.35.35,0,0,1,641.1,171.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M644.38,157.2l-7.75-.6a.14.14,0,0,1-.13-.15.14.14,0,0,1,.15-.12l7.64.59,7.91-6.66,6.93.32,7.4-4.64a.14.14,0,0,1,.19.05.14.14,0,0,1-.05.19l-7.46,4.68h-.05l-6.86-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M636.61,154.36a.13.13,0,0,1-.13-.1.14.14,0,0,1,.1-.17l7.58-1.79,8-5.66,7,.26,7.22-2.93a.14.14,0,0,1,.18.08.15.15,0,0,1-.08.18l-7.27,3-7-.27-8,5.65-7.61,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M637.08,156.16c0-.33-.23-.47-.52-.3a1.15,1.15,0,0,0-.52.9c0,.32.23.46.52.29A1.13,1.13,0,0,0,637.08,156.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M637.08,154c0-.33-.23-.47-.52-.3a1.15,1.15,0,0,0-.52.89c0,.33.23.47.52.3A1.13,1.13,0,0,0,637.08,154Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M644.72,156.75c0-.33-.23-.46-.52-.3a1.18,1.18,0,0,0-.52.9.32.32,0,0,0,.52.29A1.12,1.12,0,0,0,644.72,156.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M644.72,152.12c0-.33-.23-.46-.52-.3a1.18,1.18,0,0,0-.52.9c0,.33.24.46.52.29A1.12,1.12,0,0,0,644.72,152.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M652.77,150.1c0-.33-.23-.46-.52-.3a1.15,1.15,0,0,0-.52.9c0,.33.23.46.52.29A1.12,1.12,0,0,0,652.77,150.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M652.77,146.36c0-.33-.23-.47-.52-.3a1.15,1.15,0,0,0-.52.89c0,.33.23.47.52.3A1.15,1.15,0,0,0,652.77,146.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M659.69,150.26c0-.33-.24-.46-.52-.29a1.12,1.12,0,0,0-.52.89c0,.33.23.46.52.3A1.18,1.18,0,0,0,659.69,150.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M659.69,146.65c0-.33-.24-.46-.52-.3a1.15,1.15,0,0,0-.52.9c0,.33.23.46.52.3A1.18,1.18,0,0,0,659.69,146.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M667.07,145.82c0-.33-.24-.46-.52-.29a1.12,1.12,0,0,0-.52.89c0,.33.23.46.52.3A1.18,1.18,0,0,0,667.07,145.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M667.07,143.66c0-.33-.24-.47-.52-.3a1.15,1.15,0,0,0-.52.89c0,.33.23.47.52.3A1.18,1.18,0,0,0,667.07,143.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M647,138.63a.27.27,0,0,1,.13.51l-1.84,1.07a.28.28,0,1,1-.28-.48l1.85-1.06A.23.23,0,0,1,647,138.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M650.21,136.77a.28.28,0,0,1,.24.14.27.27,0,0,1-.1.37l-2,1.13a.28.28,0,0,1-.38-.1.27.27,0,0,1,.1-.37l2-1.13A.23.23,0,0,1,650.21,136.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M643.85,140.43a.27.27,0,0,1,.24.14.29.29,0,0,1-.1.38l-2.23,1.28a.28.28,0,0,1-.38-.1.27.27,0,0,1,.1-.37l2.23-1.29A.37.37,0,0,1,643.85,140.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M649.19,139.45a.29.29,0,0,1,.24.13.29.29,0,0,1-.1.38l-2,1.13a.27.27,0,1,1-.27-.47l2-1.14A.35.35,0,0,1,649.19,139.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M645.93,141.32a.27.27,0,0,1,.24.14.27.27,0,0,1-.1.37l-4.31,2.49a.28.28,0,0,1-.38-.1.27.27,0,0,1,.1-.37l4.32-2.49A.22.22,0,0,1,645.93,141.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "636.06 144.39 639.23 142.55 639.23 146.2 636.06 148.03 636.06 144.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M663.68,129.65a.27.27,0,0,1,.23.14.28.28,0,0,1-.1.38L662,131.23a.28.28,0,0,1-.38-.1.27.27,0,0,1,.1-.37l1.85-1.07A.33.33,0,0,1,663.68,129.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M666.91,127.79a.28.28,0,0,1,.24.14.27.27,0,0,1-.1.37l-2,1.14a.28.28,0,0,1-.38-.11.28.28,0,0,1,.1-.37l2-1.13A.25.25,0,0,1,666.91,127.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M660.55,131.46a.27.27,0,0,1,.24.14.28.28,0,0,1-.1.37l-2.23,1.29a.28.28,0,1,1-.28-.48l2.23-1.29A.35.35,0,0,1,660.55,131.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M665.89,130.47a.28.28,0,0,1,.24.14.27.27,0,0,1-.1.37l-2,1.14a.27.27,0,0,1-.37-.1.28.28,0,0,1,.1-.38l2-1.13A.25.25,0,0,1,665.89,130.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M662.63,132.34a.27.27,0,0,1,.24.14.27.27,0,0,1-.1.37l-4.31,2.49a.27.27,0,0,1-.38-.1.28.28,0,0,1,.1-.37l4.32-2.49A.22.22,0,0,1,662.63,132.34Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "652.76 135.41 655.93 133.58 655.93 137.22 652.76 139.05 652.76 135.41"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-160"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-161"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-162",
    points: "612.18 309.85 630.45 299.31 664.66 319.19 646.4 329.73 612.18 309.85"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-161"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-162",
    points: "586.43 325.05 604.69 314.51 633.82 331.45 615.56 341.99 586.43 325.05"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-161"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-162",
    points: "662.21 280.63 680.47 270.09 728.98 298.19 710.72 308.74 662.21 280.63"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-161"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-162",
    points: "636.94 295.51 655.2 284.97 695.1 308.06 676.84 318.6 636.94 295.51"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-163",
    points: "680.55 290.19 664.46 280.9 664.56 195.58 680.55 204.81 680.55 290.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-164",
    points: "696.64 280.9 680.55 290.19 680.55 204.81 696.64 195.52 696.64 280.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-165",
    points: "664.56 195.58 680.65 186.29 696.64 195.52 680.55 204.81 664.56 195.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "680.5 204.65 696.49 195.43 696.64 195.52 696.64 195.7 680.77 205.15 680.5 204.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M680.78,290.06l-.23.13-.24-.13.16-85-15.91-9.25v-.27l.24-.14,16,9.32a.23.23,0,0,1,.11.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "655.34 304.71 639.25 295.42 639.35 227.96 655.34 237.19 655.34 304.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-169",
    points: "671.42 295.42 655.34 304.71 655.34 237.2 671.42 227.91 671.42 295.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "639.35 227.96 655.44 218.68 671.42 227.91 655.34 237.19 639.35 227.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "655.29 237.04 671.27 227.82 671.42 227.91 671.42 228.09 655.55 237.54 655.29 237.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M655.57,304.57l-.23.14-.24-.14.16-67.09-15.91-9.24V228l.23-.13,16,9.31a.26.26,0,0,1,.12.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-173",
    points: "630.49 319.11 614.4 309.82 614.5 260.96 630.49 270.19 630.49 319.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-174",
    points: "646.58 309.82 630.49 319.11 630.49 270.2 646.58 260.91 646.58 309.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-175",
    points: "614.5 260.96 630.59 251.67 646.58 260.9 630.49 270.19 614.5 260.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "630.44 270.04 646.42 260.82 646.58 260.9 646.58 261.09 630.7 270.54 630.44 270.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M630.72,319l-.23.14-.24-.14.16-48.49-15.91-9.24V261l.23-.13,16,9.31a.24.24,0,0,1,.12.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-178",
    points: "604.58 334.06 588.49 324.77 588.59 294.65 604.58 303.88 604.58 334.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-179",
    points: "620.67 324.77 604.58 334.06 604.58 303.88 620.67 294.6 620.67 324.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-180",
    points: "588.59 294.65 604.68 285.36 620.67 294.59 604.58 303.88 588.59 294.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-181",
    points: "604.54 303.73 620.52 294.51 620.67 294.59 620.67 294.77 604.8 304.23 604.54 303.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M604.82,333.92l-.24.14-.23-.14.16-29.75-15.91-9.25v-.27l.24-.13,16,9.31a.24.24,0,0,1,.12.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M572.4,413.92l-90,52,7,4.38,90.78-51a.6.6,0,0,0,.3-.52.57.57,0,0,0-.3-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M574.07,228.82c0-10.08-10.13-14.34-17.83-9.88l-59.49,34.31c-7.23,4.16-11.31,13.13-11.31,21.55V450.5c0,9.86,8.91,15.61,17.45,10.67l59.85-34.59c8-4.64,11.33-10.23,11.33-21.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M567.81,218.32a11.86,11.86,0,0,0-5.11-1.14,12.91,12.91,0,0,0-6.46,1.76l-59.49,34.31c-7.23,4.16-11.31,13.13-11.31,21.55V450.5c0,7.24,4.81,12.26,10.74,12.46,0,0-10-.66-10-12.46V274.8c0-8.75,4.4-17.16,11-20.93l59.49-34.31a14.18,14.18,0,0,1,6.15-1.95A14.57,14.57,0,0,1,567.81,218.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M493.72,438.63c-2.35,1.28-8.28-1.24-8.28-3.05v-3.26c0,1.81,5.94,4.8,8.28,3.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M493.72,285.87c-2.35,1.28-8.28-1.24-8.28-3.05v-3.27c0,1.81,5.94,4.8,8.28,3.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M573.22,410.92l0-.22a31.62,31.62,0,0,0,.32-4.52V229.26h0v-.11c0-4.63-1.56-6.55-3.07-7.44-2.15-1.26-5.06-1-8.2.74l-61.23,35.34c-5.28,3.05-9.58,10.47-9.58,16.53V455.54c0,3,1.11,5.17,3,6.28a5.16,5.16,0,0,0,2.69.61,8.67,8.67,0,0,0,4.28-1.31l62.7-36.2a17.54,17.54,0,0,0,4.49-3.68,19.6,19.6,0,0,0,4.5-10.15Zm-3.44-188c1.7,1,2.6,3.19,2.6,6.33V406.18c0,10.46-4.77,15.4-8.77,17.71l-62.7,36.2c-2.19,1.27-4.22,1.49-5.71.63s-2.28-2.69-2.28-5.18V274.31c0-5.61,4-12.47,8.86-15.29L563,223.68C565.68,222.2,568.08,221.93,569.78,222.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M562.65,223.06,501.43,258.4c-5.08,2.93-9.23,10.09-9.23,15.91V455.54c0,5.72,4.08,8,9.07,5.17l62.7-36.2c5-2.9,9.12-8.57,9.12-18.33V229.26C573.09,222,568.41,219.87,562.65,223.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M535.37,247.18l-9.61,5.55c-.34.2-.62,0-.62-.47a1.48,1.48,0,0,1,.62-1.18l9.61-5.55c.34-.2.62,0,.62.47A1.48,1.48,0,0,1,535.37,247.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M541.45,242.85a3,3,0,0,1-1.34,2.31c-.74.42-1.34.08-1.34-.77a3,3,0,0,1,1.34-2.31C540.85,241.66,541.45,242,541.45,242.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M489.74,300.22a2.27,2.27,0,0,0-.86-1.77c-.52-.34-.76-.24-.94-.14l-.67.43.33,5.68,1.2,1.1s.42-.31.59-.42.35-.66.35-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M488.17,305.5l-.3-.17a2.26,2.26,0,0,1-.93-1.78V299.5c0-.68.42-1,.93-.7l.3.16a2.26,2.26,0,0,1,.93,1.78v4.05C489.1,305.47,488.68,305.79,488.17,305.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M489.74,312.66a2.27,2.27,0,0,0-.86-1.77c-.52-.34-.76-.24-.93-.15l-.68.44.33,11.46,1.1,1.05s.52-.26.69-.37.35-.66.35-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M488.1,323.61l-.16-.09a2.4,2.4,0,0,1-1-1.91V312c0-.73.45-1.07,1-.75l.16.09a2.41,2.41,0,0,1,1,1.91v9.64C489.1,323.59,488.65,323.93,488.1,323.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M489.74,329.22a2.29,2.29,0,0,0-.86-1.78c-.52-.33-.76-.24-.93-.14l-.68.44.33,11.46,1.09.95a4.36,4.36,0,0,0,.7-.27c.29-.18.35-.66.35-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M488.1,340.07l-.16-.09a2.41,2.41,0,0,1-1-1.91v-9.54c0-.73.45-1.07,1-.75l.16.09a2.38,2.38,0,0,1,1,1.9v9.54C489.1,340.05,488.65,340.39,488.1,340.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M548.75,428.39l-22,12.67c-.28.17-.52,0-.52-.39a1.29,1.29,0,0,1,.52-1l22-12.67c.29-.17.53,0,.53.39A1.27,1.27,0,0,1,548.75,428.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M570.57,408.65,495.32,452.1a.56.56,0,0,1-.84-.49V277.75a1.38,1.38,0,0,1,.7-1.21l75.25-43.45a.56.56,0,0,1,.84.49V407.43A1.4,1.4,0,0,1,570.57,408.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M495,452.31a.73.73,0,0,1-.35-.09.71.71,0,0,1-.35-.61V277.75a1.52,1.52,0,0,1,.77-1.33L570.36,233a.68.68,0,0,1,.7,0,.69.69,0,0,1,.35.61V407.43a1.55,1.55,0,0,1-.77,1.34l-75.25,43.45A.73.73,0,0,1,495,452.31Zm75.67-219.15a.41.41,0,0,0-.21.05l-75.25,43.45a1.26,1.26,0,0,0-.63,1.09V451.61a.41.41,0,0,0,.21.36.4.4,0,0,0,.42,0l75.25-43.45a1.25,1.25,0,0,0,.63-1.09V233.58a.42.42,0,0,0-.21-.37A.38.38,0,0,0,570.71,233.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-155",
    points: "564.87 308.9 503.2 344.51 503.2 388.29 564.87 352.68 564.87 308.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "502.95 407.74 515.97 400.02 515.86 390.72 502.85 398.44 502.95 407.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "503.1 420.55 516.11 412.83 516.01 403.54 502.99 411.25 503.1 420.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "503.25 433.36 516.26 425.65 516.15 416.35 503.14 424.06 503.25 433.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M525.6,394.54a.51.51,0,0,1-.44-.24.51.51,0,0,1,.18-.69l4.09-2.42a.49.49,0,0,1,.68.17.5.5,0,0,1-.17.68l-4.1,2.43A.42.42,0,0,1,525.6,394.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M532.1,390.68a.47.47,0,0,1-.43-.24.49.49,0,0,1,.17-.68l16.69-9.89a.5.5,0,0,1,.68.17.51.51,0,0,1-.17.69l-16.69,9.88A.45.45,0,0,1,532.1,390.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M551.1,379.43a.52.52,0,0,1-.44-.25.5.5,0,0,1,.18-.68l7.15-4.24a.5.5,0,0,1,.68.18.5.5,0,0,1-.17.68l-7.15,4.24A.59.59,0,0,1,551.1,379.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M525.55,390.74a.5.5,0,0,1-.26-.92l5.5-3.27a.51.51,0,0,1,.69.18.49.49,0,0,1-.18.68l-5.5,3.26A.45.45,0,0,1,525.55,390.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M548.53,377.13a.52.52,0,0,1-.44-.25.5.5,0,0,1,.18-.68l3.33-2a.51.51,0,0,1,.69.18.5.5,0,0,1-.18.68l-3.33,2A.59.59,0,0,1,548.53,377.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M533.47,386.05a.5.5,0,0,1-.26-.93L546,377.55a.51.51,0,0,1,.69.18.49.49,0,0,1-.18.68L533.71,386A.42.42,0,0,1,533.47,386.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M554.17,373.78a.49.49,0,0,1-.43-.24.51.51,0,0,1,.17-.69l4-2.39a.51.51,0,0,1,.69.18.49.49,0,0,1-.18.68l-4,2.39A.45.45,0,0,1,554.17,373.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M525.51,387a.52.52,0,0,1-.44-.25.49.49,0,0,1,.18-.68l7.34-4.36a.51.51,0,0,1,.69.18.49.49,0,0,1-.18.68l-7.34,4.36A.78.78,0,0,1,525.51,387Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M535.27,381.16a.49.49,0,0,1-.44-.24.51.51,0,0,1,.18-.69l12.78-7.57a.5.5,0,1,1,.51.86l-12.79,7.57A.42.42,0,0,1,535.27,381.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M550.37,372.21a.48.48,0,0,1-.44-.24.49.49,0,0,1,.18-.68l7.79-4.62a.5.5,0,0,1,.68.17.5.5,0,0,1-.17.69l-7.8,4.62A.5.5,0,0,1,550.37,372.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M525.74,407.42a.5.5,0,0,1-.26-.93l4.1-2.43a.5.5,0,0,1,.5.86L526,407.35A.72.72,0,0,1,525.74,407.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M532.25,403.56a.54.54,0,0,1-.44-.24.51.51,0,0,1,.18-.69l16.69-9.89a.5.5,0,0,1,.68.18.49.49,0,0,1-.18.68l-16.68,9.89A.47.47,0,0,1,532.25,403.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M551.25,392.3a.51.51,0,0,1-.44-.24.51.51,0,0,1,.18-.69l7.15-4.23a.49.49,0,1,1,.5.85l-7.14,4.24A.47.47,0,0,1,551.25,392.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M525.7,403.62a.52.52,0,0,1-.44-.25.5.5,0,0,1,.18-.68l5.5-3.26a.51.51,0,0,1,.69.17.51.51,0,0,1-.18.69l-5.5,3.26A.59.59,0,0,1,525.7,403.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M548.68,390a.5.5,0,0,1-.26-.93l3.33-2a.5.5,0,0,1,.51.86l-3.34,2A.42.42,0,0,1,548.68,390Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M533.61,398.93a.5.5,0,0,1-.43-.25.5.5,0,0,1,.17-.68l12.78-7.57a.5.5,0,0,1,.51.86l-12.78,7.57A.55.55,0,0,1,533.61,398.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M554.32,386.66a.5.5,0,0,1-.26-.93l4-2.39a.5.5,0,0,1,.51.86l-4,2.39A.72.72,0,0,1,554.32,386.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M525.66,399.82a.5.5,0,0,1-.26-.93l7.34-4.35a.5.5,0,0,1,.51.86l-7.35,4.35A.42.42,0,0,1,525.66,399.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M535.41,394a.5.5,0,0,1-.43-.25.5.5,0,0,1,.17-.68l12.79-7.58a.51.51,0,0,1,.69.18.5.5,0,0,1-.18.68L535.66,394A.55.55,0,0,1,535.41,394Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M550.51,385.09a.5.5,0,0,1-.26-.93l7.8-4.62a.5.5,0,0,1,.68.18.5.5,0,0,1-.17.68l-7.8,4.62A.45.45,0,0,1,550.51,385.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M525.89,420.29a.49.49,0,0,1-.43-.24.5.5,0,0,1,.17-.69l4.09-2.42a.5.5,0,1,1,.51.86l-4.09,2.42A.45.45,0,0,1,525.89,420.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M532.4,416.44a.51.51,0,0,1-.44-.25.49.49,0,0,1,.18-.68l16.68-9.89a.51.51,0,0,1,.69.17.51.51,0,0,1-.18.69l-16.69,9.89A.67.67,0,0,1,532.4,416.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M551.4,405.18a.5.5,0,0,1-.26-.93l7.14-4.24a.51.51,0,0,1,.69.18.5.5,0,0,1-.18.68l-7.15,4.24A.51.51,0,0,1,551.4,405.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M525.85,416.49a.49.49,0,0,1-.26-.92l5.5-3.27a.5.5,0,0,1,.51.86l-5.5,3.26A.47.47,0,0,1,525.85,416.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M548.82,402.88a.5.5,0,0,1-.43-.25.5.5,0,0,1,.17-.68l3.34-2a.5.5,0,0,1,.68.18.5.5,0,0,1-.17.68l-3.34,2A.55.55,0,0,1,548.82,402.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M533.76,411.8a.49.49,0,0,1-.43-.24.5.5,0,0,1,.17-.69l12.78-7.57a.5.5,0,0,1,.51.86L534,411.73A.45.45,0,0,1,533.76,411.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M554.47,399.53a.51.51,0,0,1-.44-.24.51.51,0,0,1,.18-.69l4-2.38a.49.49,0,0,1,.68.17.5.5,0,0,1-.17.68l-4,2.39A.47.47,0,0,1,554.47,399.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M525.8,412.7a.5.5,0,0,1-.43-.25.5.5,0,0,1,.17-.68l7.35-4.35a.49.49,0,0,1,.68.17.5.5,0,0,1-.17.68l-7.35,4.36A.55.55,0,0,1,525.8,412.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M535.56,406.91a.5.5,0,0,1-.26-.92l12.79-7.58a.5.5,0,0,1,.51.86l-12.79,7.57A.45.45,0,0,1,535.56,406.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M550.66,398a.5.5,0,0,1-.26-.93l7.8-4.62a.5.5,0,1,1,.5.86l-7.79,4.62A.72.72,0,0,1,550.66,398Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "538.65 344.37 527.86 343.45 527.86 357.75 538.65 344.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-200",
    points: "184.76 467.37 184.76 421.45 225.55 398.07 226.71 397.7 226.71 443.24 226.25 443.9 185.3 467.37 184.76 467.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-201",
    points: "182.21 419.58 182.05 419.89 184.54 421.51 225.72 398.4 225.65 396.86 223.9 395.88 222.11 395.89 182.27 418.91 182.21 419.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-202",
    points: "184.76 421.45 184.76 467.37 184.16 467.37 181.71 465.99 181.27 465.42 181.27 419.48 181.75 419.52 182 419.9 184.76 421.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M223,396.78l1.58.87-40,22.45-.81-.62Zm0-1.41-41.71,24.11,3.25,2,42.07-23.62a.29.29,0,0,0,.14-.23.27.27,0,0,0-.14-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M223,484.57l-41.71,24.11,3.25,2,42.07-23.62a.29.29,0,0,0,.14-.24.27.27,0,0,0-.14-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M193.44,431.74a.28.28,0,0,1-.14-.52l2.33-1.35a.29.29,0,0,1,.39.11.28.28,0,0,1-.1.38l-2.34,1.35A.32.32,0,0,1,193.44,431.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M197.15,429.61a.29.29,0,0,1-.25-.15.28.28,0,0,1,.11-.38l6.7-3.87a.29.29,0,0,1,.39.1.28.28,0,0,1-.11.39l-6.7,3.87A.33.33,0,0,1,197.15,429.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M205.17,425a.28.28,0,0,1-.24-.15.27.27,0,0,1,.1-.38l4.07-2.35a.28.28,0,1,1,.28.49l-4.07,2.35A.33.33,0,0,1,205.17,425Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M193.44,433.89a.28.28,0,0,1-.14-.52l5.22-3a.29.29,0,0,1,.39.11.28.28,0,0,1-.11.38l-5.22,3A.32.32,0,0,1,193.44,433.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M200,430.09a.29.29,0,0,1-.25-.14.29.29,0,0,1,.1-.39l5.57-3.21a.28.28,0,0,1,.38.1.29.29,0,0,1-.1.39l-5.56,3.21A.27.27,0,0,1,200,430.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M206.91,426.12a.27.27,0,0,1-.24-.14.29.29,0,0,1,.1-.39l2.33-1.34a.29.29,0,0,1,.39.1.29.29,0,0,1-.11.39l-2.33,1.34A.23.23,0,0,1,206.91,426.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M193.44,429.6a.28.28,0,0,1-.24-.14.29.29,0,0,1,.1-.39l3.14-1.81a.28.28,0,0,1,.38.1.29.29,0,0,1-.1.39l-3.14,1.81A.33.33,0,0,1,193.44,429.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M203.73,423.66a.27.27,0,0,1-.24-.14.28.28,0,0,1,.1-.39l1.9-1.09a.28.28,0,0,1,.28.48l-1.9,1.1A.23.23,0,0,1,203.73,423.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M198,427a.27.27,0,0,1-.24-.14.28.28,0,0,1,.1-.38l4.48-2.59a.28.28,0,0,1,.28.49L198.09,427A.32.32,0,0,1,198,427Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M207,421.8a.29.29,0,0,1-.25-.14.28.28,0,0,1,.1-.38l2.3-1.33a.28.28,0,1,1,.28.49l-2.29,1.32A.27.27,0,0,1,207,421.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M193.44,427.45a.28.28,0,0,1-.24-.14.29.29,0,0,1,.1-.39l4.19-2.41a.27.27,0,0,1,.38.1.28.28,0,0,1-.1.38l-4.19,2.42A.23.23,0,0,1,193.44,427.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M199,424.24a.27.27,0,0,1-.24-.14.29.29,0,0,1,.1-.39l4.48-2.59a.29.29,0,0,1,.39.11.28.28,0,0,1-.1.38l-4.49,2.59A.23.23,0,0,1,199,424.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M204.8,420.89a.27.27,0,0,1-.24-.14.29.29,0,0,1,.1-.39l4.44-2.56a.28.28,0,1,1,.28.49l-4.44,2.56A.23.23,0,0,1,204.8,420.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "220.42 417.8 214.73 421.09 214.73 414.55 220.42 411.26 220.42 417.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "220.42 427.94 214.73 431.23 214.73 424.69 220.42 421.4 220.42 427.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "220.42 437.84 214.73 441.13 214.73 434.59 220.42 431.3 220.42 437.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M193.44,441.58a.28.28,0,0,1-.24-.14.29.29,0,0,1,.1-.39l2.33-1.35a.29.29,0,0,1,.39.11.28.28,0,0,1-.1.38l-2.34,1.35A.33.33,0,0,1,193.44,441.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M197.15,439.44a.3.3,0,0,1-.25-.14.29.29,0,0,1,.11-.39l6.7-3.87a.29.29,0,0,1,.39.1.28.28,0,0,1-.11.39l-6.7,3.87A.23.23,0,0,1,197.15,439.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M205.17,434.81a.27.27,0,0,1-.24-.14.28.28,0,0,1,.1-.39l4.07-2.35a.28.28,0,1,1,.28.49l-4.07,2.35A.33.33,0,0,1,205.17,434.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M193.44,443.73a.29.29,0,0,1-.24-.15.28.28,0,0,1,.1-.38l5.22-3a.29.29,0,0,1,.39.1.29.29,0,0,1-.11.39l-5.22,3A.33.33,0,0,1,193.44,443.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M200,439.92a.29.29,0,0,1-.25-.14.29.29,0,0,1,.1-.39l5.57-3.21a.28.28,0,0,1,.38.11.28.28,0,0,1-.1.38l-5.56,3.21A.27.27,0,0,1,200,439.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M206.91,436a.27.27,0,0,1-.24-.14.29.29,0,0,1,.1-.39l2.33-1.34a.28.28,0,1,1,.28.49l-2.33,1.34A.23.23,0,0,1,206.91,436Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M193.44,439.43a.28.28,0,0,1-.24-.14.29.29,0,0,1,.1-.39l3.14-1.81a.28.28,0,0,1,.38.11.28.28,0,0,1-.1.38l-3.14,1.81A.23.23,0,0,1,193.44,439.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M203.73,433.49a.27.27,0,0,1-.24-.14.28.28,0,0,1,.1-.39l1.9-1.09a.27.27,0,0,1,.38.1.28.28,0,0,1-.1.39l-1.9,1.09A.23.23,0,0,1,203.73,433.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M198,436.83a.26.26,0,0,1-.24-.15.28.28,0,0,1,.1-.38l4.48-2.59a.28.28,0,0,1,.38.11.28.28,0,0,1-.1.38l-4.48,2.59A.33.33,0,0,1,198,436.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M207,431.63a.29.29,0,0,1-.25-.14.28.28,0,0,1,.1-.38l2.3-1.33a.29.29,0,0,1,.39.11.28.28,0,0,1-.11.38l-2.29,1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M193.44,437.28a.28.28,0,0,1-.24-.14.29.29,0,0,1,.1-.39l4.19-2.41a.28.28,0,0,1,.38.1.29.29,0,0,1-.1.39l-4.19,2.41A.23.23,0,0,1,193.44,437.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M199,434.07a.27.27,0,0,1-.24-.14.28.28,0,0,1,.1-.38l4.48-2.59a.28.28,0,0,1,.39.1.28.28,0,0,1-.1.38L199.14,434A.23.23,0,0,1,199,434.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M204.8,430.72a.27.27,0,0,1-.24-.14.28.28,0,0,1,.1-.38l4.44-2.57a.29.29,0,0,1,.39.11.28.28,0,0,1-.11.38l-4.44,2.56A.23.23,0,0,1,204.8,430.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M193.44,451.33a.28.28,0,0,1-.24-.14.28.28,0,0,1,.1-.38l2.33-1.35a.28.28,0,1,1,.29.49l-2.34,1.34A.23.23,0,0,1,193.44,451.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M197.15,449.19a.3.3,0,0,1-.25-.14.28.28,0,0,1,.11-.38l6.7-3.87a.28.28,0,0,1,.39.1.27.27,0,0,1-.11.38l-6.7,3.87A.23.23,0,0,1,197.15,449.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M205.17,444.56A.28.28,0,0,1,205,444l4.07-2.36a.29.29,0,0,1,.39.11.28.28,0,0,1-.11.38l-4.07,2.35A.23.23,0,0,1,205.17,444.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M193.44,453.48a.28.28,0,0,1-.24-.14.29.29,0,0,1,.1-.39l5.22-3a.29.29,0,0,1,.39.1.29.29,0,0,1-.11.39l-5.22,3A.23.23,0,0,1,193.44,453.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M200,449.67a.29.29,0,0,1-.25-.14.28.28,0,0,1,.1-.38l5.57-3.21a.28.28,0,0,1,.38.1.29.29,0,0,1-.1.39l-5.56,3.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M206.91,445.7a.27.27,0,0,1-.24-.14.28.28,0,0,1,.1-.38l2.33-1.35a.29.29,0,0,1,.39.11.28.28,0,0,1-.11.38l-2.33,1.35A.32.32,0,0,1,206.91,445.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M193.44,449.18a.28.28,0,0,1-.24-.14.28.28,0,0,1,.1-.38l3.14-1.81a.28.28,0,0,1,.38.1.29.29,0,0,1-.1.39l-3.14,1.81A.32.32,0,0,1,193.44,449.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M203.73,443.24a.28.28,0,0,1-.14-.52l1.9-1.1a.28.28,0,0,1,.38.1.28.28,0,0,1-.1.39l-1.9,1.1A.32.32,0,0,1,203.73,443.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M198,446.58a.27.27,0,0,1-.24-.14.29.29,0,0,1,.1-.39l4.48-2.58a.28.28,0,0,1,.38.1.29.29,0,0,1-.1.39l-4.48,2.58A.23.23,0,0,1,198,446.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M207,441.39a.29.29,0,0,1-.25-.14.29.29,0,0,1,.1-.39l2.3-1.32a.28.28,0,1,1,.28.48l-2.29,1.33A.27.27,0,0,1,207,441.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M193.44,447a.28.28,0,0,1-.14-.52l4.19-2.42a.28.28,0,0,1,.38.11.28.28,0,0,1-.1.38L193.58,447A.32.32,0,0,1,193.44,447Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M199,443.83a.27.27,0,0,1-.24-.14.29.29,0,0,1,.1-.39l4.48-2.59a.28.28,0,0,1,.29.49l-4.49,2.59A.33.33,0,0,1,199,443.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M204.8,440.48a.27.27,0,0,1-.24-.14.29.29,0,0,1,.1-.39l4.44-2.56a.28.28,0,1,1,.28.49l-4.44,2.56A.23.23,0,0,1,204.8,440.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M241.69,516.38c-4.49,2.6.08,9.44,10.21,15.29s22,8.49,26.48,5.9-.08-9.44-10.22-15.29S246.18,513.79,241.69,516.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M269.52,523.47s.5,1.66.65,2.28a7.37,7.37,0,0,1-.26,2.13,1.28,1.28,0,0,1-1,1,3.18,3.18,0,0,1-2.54-.46l-6.81-4.59a.85.85,0,0,1-.27-1.11l.18-.34a1.33,1.33,0,0,1,1.51-.67c1.54.39,4.4,1,5.41.78C267.84,522.11,269.52,523.47,269.52,523.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M269.73,518.54s0,4.87-.2,5.56-2.4.65-3-.81a29.43,29.43,0,0,1-.78-5.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M260.88,526.2s.69,1.59.9,2.18a7,7,0,0,1,0,2.15,1.28,1.28,0,0,1-.84,1.1,3.18,3.18,0,0,1-2.58-.17l-7.29-3.78a.86.86,0,0,1-.41-1.06l.15-.37a1.32,1.32,0,0,1,1.42-.83c1.57.21,4.49.52,5.47.15C259.05,525,260.88,526.2,260.88,526.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M261.33,521.81s0,4.87-.2,5.55-2.4.66-3-.81a29.43,29.43,0,0,1-.78-5.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M272.19,469.82s-2.32,19.11-1.52,24.15c1.52,9.57-.35,24.57-.35,24.57a4.18,4.18,0,0,1-4.92,0s-2.21-31.89-6.18-38.66V469.15l5.28-5.77,5.69-1C271.92,463.14,272.51,468,272.19,469.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M249.55,467.6s.91,13,2.8,26.14c1.78,12.33,4.54,24.66,4.94,28.29a1.82,1.82,0,0,0,.8,1.32,3.73,3.73,0,0,0,2.92.51,1.18,1.18,0,0,0,.93-1.06c.41-4,.63-22.36.62-25.68,0-3.74,3.19-25.79,3.19-25.79l-1-8.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M269.23,430.63a8.14,8.14,0,0,0-7.68-1.31l-9.9,3.39S248.4,445,247.84,449c-3.19,22.71.93,27.09.93,27.09.78,4.57,21.91,1.61,23.5-1.89.88-1.92,4.17-5.75,1-36A10.92,10.92,0,0,0,269.23,430.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M244.6,443.89s-4.85,3.76-14.65-3.71c0,0-5.37-4-7.24-4.2s-5-.39-5-.39-1.33,1.09.31,1.32c.88.13,2.11.39,3,.61A1.18,1.18,0,0,1,222,439a2.94,2.94,0,0,0,.52,2.59c1.4,1.87,4.91.93,4.91.93s8.24,8.87,11.89,9.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M255.23,436.68s-1.55-5-3.58-4-3.42,3.73-5.91,6.92-2.57,4.18-4.82,5.21c0,0,.07,5.24-1.64,7.49a8.81,8.81,0,0,0,5.32,1.31C247.3,453.25,256.48,446.56,255.23,436.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M244.2,441.72c.41-.57.89-1.25,1.54-2.09.48-.62.92-1.21,1.33-1.78,8,6.26,21,.83,25.75-1.75a12,12,0,0,1,.4,2.07c.14,1.31.26,2.56.38,3.77C268.66,445.08,254.23,452.68,244.2,441.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M256.32,425.1l.62,6a1.07,1.07,0,0,0,.88.93,6.34,6.34,0,0,0,4.71-1.05,1.9,1.9,0,0,0,.74-2l-1.12-4.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M250.45,418.18s1.38,7.58,2.76,9.24,6.2,1,7.17,0,3-6.07,2.62-7.86S252.93,413.63,250.45,418.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "M259.64,412.11c1.07.39,2.12,2.3,4.05,2.57,1.36.2,1.1,2.3.73,6s-2.29,4.51-3.58,5-3.22-2.57-4.51-4a4.84,4.84,0,0,0-4.78-2c-2.3.27-4.69-1.48-3.13-3s2.67-1,4-1.84S255.54,410.6,259.64,412.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-218",
    points: "431.88 522.44 431.88 486.89 401.04 469.09 400.78 469 400.78 504.38 400.99 504.74 431.65 522.44 431.88 522.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-219",
    points: "462.76 468.96 462.8 469.03 431.93 486.9 401 469.16 401.02 468.81 431.72 451.09 432.13 451.09 462.75 468.81 462.76 468.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-220",
    points: "431.88 486.89 431.88 522.44 432.1 522.44 462.77 504.74 462.97 504.38 462.97 468.94 462.86 468.95 462.81 469.03 431.88 486.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "M431.93,451.29l30.49,17.65-30.49,17.65L401.26,469Zm0-.32-31.13,18a.05.05,0,0,0,0,.05.06.06,0,0,0,0,.06l31.13,17.86,31-18Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-69"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "469.52 522.4 469.56 522.49 431.9 544.29 394.17 522.65 394.19 522.22 431.65 500.59 432.15 500.59 469.5 522.21 469.52 522.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-223",
    points: "431.84 530.29 431.84 486.92 394.22 465.2 393.9 465.34 393.9 508.26 394.15 508.69 431.57 530.29 431.84 530.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-224",
    points: "469.52 465.04 469.56 465.13 431.9 486.94 394.17 465.29 394.19 464.86 431.65 443.24 432.15 443.24 469.5 464.86 469.52 465.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-225",
    points: "431.84 486.92 431.84 530.29 432.11 530.29 469.53 508.69 469.78 508.26 469.78 465.33 469.63 465.17 469.58 465.13 431.84 486.92"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-226",
    points: "432.12 530.29 431.56 530.29 431.56 487.08 393.91 465.34 394.19 464.86 432.12 486.76 432.12 530.29"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-227",
    x: 428.92,
    y: 475.73,
    width: 43.65,
    height: 0.55,
    transform: "translate(-177.62 289.16) rotate(-30)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M409.28,455.34c-1.41-3.12,19,.31,19,.31l0-16.88s-24.87-.68-28.29,3.28c-2.73,3.17-1.24,8.94,3.26,17.62,2-1.17,4.7-1.86,6.54-3.22A4.43,4.43,0,0,0,409.28,455.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-229",
    d: "M435.27,439.44l-18.69,7.49s-20.61-1.88-23.82,1.84c-3.07,3.55-1,9,2.22,15.57a38.52,38.52,0,0,0,6.81-3.86c-1-3-.8-2.63-.84-3.27-.11-1.77,1.47-1.82,4.22-1.24,2.07.43,15.54,4.55,21,3.44s10.45-7.41,10.66-10.31S435.27,439.44,435.27,439.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-230",
    d: "M414.13,445a5,5,0,0,1,3.48,4.05c.45,3.29.68,9.88,4.64,10.76s14.27-3.14,15.18-7.4.79-7.89.68-15.36,2.94-23.45-5.1-26.28l-11.78,3.06s-2.72,2.6-3.74,11.78S414.13,445,414.13,445Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M423.5,412.12a8,8,0,0,0-2.27,1.7c-.66.89,3.4.11,4.31,2.26s2.13,9.29,7.59,9.06,4.63-5.13,5-6.95-1.24-6.75-5.09-7.43S425.76,410.42,423.5,412.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M422.93,408l.79,4.07a1.13,1.13,0,0,0,1.1.91,21,21,0,0,0,4.76-.51c.71-.18,1.13-.93,0-3.92L428,403.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M407.93,430.48l-16-13.05a.94.94,0,0,1,.12-1.54l13.38-7.76a.94.94,0,0,1,1.05.08l15.47,12.1a.94.94,0,0,1-.05,1.52l-12.81,8.7A1,1,0,0,1,407.93,430.48Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "394.33 416.25 405.94 409.17 421.16 420.84 409.28 429.11 394.33 416.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M396.5,413.69l1.25.85a.48.48,0,0,0,.54,0l5.36-3.38a.49.49,0,0,0,0-.83l-1.09-.71a.49.49,0,0,0-.52,0l-5.52,3.25A.49.49,0,0,0,396.5,413.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "M421.16,415.59s-1.59-.41-3.19,3.76a58.13,58.13,0,0,0-2.49,10.44l1.71,7.36a8.39,8.39,0,0,0,5.09-4C424.06,429.94,426.91,414.75,421.16,415.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "M420.22,436l-.4-.54A7.77,7.77,0,0,0,422,433c1.13-2,2.8-9.31,2.1-13.83l.67-.1c.72,4.65-1,12.13-2.18,14.26A8.41,8.41,0,0,1,420.22,436Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-237",
    d: "M415.06,398.61s1.27,7.88,2.66,9.62,6.4,1.13,7.42.15,3.27-6.22,2.88-8.08S417.72,394,415.06,398.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M424.7,392.52c1.1.43,2.14,2.42,4.14,2.75,1.4.23,1.09,2.4.63,6.2s-2.47,4.61-3.81,5.06-3.28-2.73-4.58-4.28-2.52-2.43-4.91-2.19-4.82-1.62-3.17-3.21,2.78-1,4.13-1.82S420.49,390.87,424.7,392.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M422.93,403s.43,3.8-6,3.63c0,0,.44,2.9,1.35,3.85s7.7.27,8.45-4.86S422.93,403,422.93,403Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-240",
    d: "M421.56,404.06s.71-4.38,2.52-3.33c1.25.73.12,2.53-.7,3.59a1,1,0,0,1-1.43.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "M399.91,424s2.16,2.14,2.92,1.2.64-1.89,1.05-2.25.38,1.12.8,2.25,1.54,3.22.86,4.3-2.77.45-3.79-.34S397.89,426.22,399.91,424Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-242",
    d: "M404.9,428c.39-.07,4.16,2.33,6.76,2.67a4.57,4.57,0,0,0,3.82-.9,8.22,8.22,0,0,1,2.47,6.06c-.29,3.51-10.59-.62-14.53-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-243",
    d: "M654,450.1s3-4.31,1.68-14.47c0,0-.78-5.49-1.73-6.74-.39-.5-.8-1-1.15-1.33a1.56,1.56,0,0,0-2-.22c-1,.66-2.38,1.66-2.48,2.27-.28,1.92,4.46,5.87,4.46,5.87s-1.7,10-3.31,13.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-244",
    d: "M645.44,452.6s3.5-4,4.84-4.35a17.84,17.84,0,0,1,4.51.21.84.84,0,0,1,.61.4.83.83,0,0,1,.06.72l-3.91,10.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-245",
    points: "614.07 462.51 614.07 420.52 651.37 399.15 652.43 398.82 652.43 440.45 652.01 441.06 614.57 462.51 614.07 462.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-246",
    points: "611.75 418.82 611.6 419.1 613.87 420.58 651.53 399.45 651.46 398.04 649.86 397.14 648.22 397.16 611.8 418.2 611.75 418.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-247",
    points: "614.07 420.52 614.07 462.51 613.53 462.51 611.28 461.25 610.89 460.73 610.89 418.73 611.33 418.76 611.55 419.11 614.07 420.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-248",
    d: "M649,398l1.44.8L613.87,419.3l-.74-.57Zm0-1.28-38.14,22,3,1.85L652.34,399a.26.26,0,0,0,0-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M649,511.87l-38.14,22,3,1.85,38.47-21.59a.26.26,0,0,0,0-.44Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "638.31 444.09 636.77 444.98 636.77 440.83 638.31 439.94 638.31 444.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "640.55 442.79 639.01 443.68 639.01 434.36 640.55 433.47 640.55 442.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "642.8 441.49 641.26 442.38 641.26 434.36 642.8 433.47 642.8 441.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "645.05 440.2 643.51 441.09 643.51 432 645.05 431.11 645.05 440.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "647.29 438.9 645.75 439.79 645.75 432.51 647.29 431.62 647.29 438.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M636.83,420.17a.26.26,0,0,1-.13-.48l2.13-1.23a.27.27,0,0,1,.36.09.25.25,0,0,1-.1.35L637,420.13A.2.2,0,0,1,636.83,420.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M640.22,418.21a.24.24,0,0,1-.22-.12.26.26,0,0,1,.09-.36l6.13-3.53a.26.26,0,0,1,.35.09.25.25,0,0,1-.1.35l-6.12,3.54A.31.31,0,0,1,640.22,418.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M636.83,422.13a.24.24,0,0,1-.22-.13.26.26,0,0,1,.09-.35l4.77-2.75a.26.26,0,0,1,.35.09.27.27,0,0,1-.09.36L637,422.1A.28.28,0,0,1,636.83,422.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M642.86,418.66a.28.28,0,0,1-.23-.13.26.26,0,0,1,.1-.36l5.08-2.93a.25.25,0,0,1,.35.1.26.26,0,0,1-.09.35L643,418.62A.28.28,0,0,1,642.86,418.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M636.83,425.49a.24.24,0,0,1-.22-.13.26.26,0,0,1,.09-.35l2.13-1.23a.26.26,0,0,1,.36.1.25.25,0,0,1-.1.35L637,425.46A.28.28,0,0,1,636.83,425.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M640.22,423.54a.26.26,0,0,1-.13-.48l6.13-3.54a.26.26,0,0,1,.35.09.26.26,0,0,1-.1.36l-6.12,3.53A.22.22,0,0,1,640.22,423.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M636.83,427.46a.26.26,0,0,1-.22-.13.27.27,0,0,1,.09-.36l4.77-2.75a.25.25,0,0,1,.35.1.26.26,0,0,1-.09.35L637,427.42A.28.28,0,0,1,636.83,427.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M642.86,424a.28.28,0,0,1-.23-.13.25.25,0,0,1,.1-.35l5.08-2.94a.25.25,0,0,1,.35.1.26.26,0,0,1-.09.35L643,423.94A.19.19,0,0,1,642.86,424Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M636.83,416.87a.24.24,0,0,1-.22-.13.26.26,0,0,1,.09-.35l2.87-1.65a.26.26,0,0,1,.26.44L637,416.84A.28.28,0,0,1,636.83,416.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M646.23,411.44a.25.25,0,0,1-.22-.12.27.27,0,0,1,.09-.36l1.74-1a.25.25,0,0,1,.35.1.26.26,0,0,1-.09.35l-1.74,1A.28.28,0,0,1,646.23,411.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M641,414.49a.24.24,0,0,1-.22-.13.26.26,0,0,1,.09-.35l4.09-2.36a.27.27,0,0,1,.36.09.26.26,0,0,1-.1.36l-4.09,2.36A.28.28,0,0,1,641,414.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M636.83,414.91a.26.26,0,0,1-.13-.48l3.83-2.21a.26.26,0,0,1,.35.09.26.26,0,0,1-.1.36l-3.82,2.2A.2.2,0,0,1,636.83,414.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M641.91,412a.26.26,0,0,1-.22-.13.26.26,0,0,1,.09-.35l4.1-2.37a.26.26,0,0,1,.35.09.27.27,0,0,1-.09.36l-4.1,2.36A.22.22,0,0,1,641.91,412Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M627.66,427.63a.37.37,0,0,0,.32-.28,8.35,8.35,0,0,0,.3-2.18c0-3.19-2.18-4.55-4.92-3.15a.36.36,0,0,0-.2.33v5.59a.1.1,0,0,0,0,.09.11.11,0,0,0,.09,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M622.38,422.69a.16.16,0,0,0-.08-.14.14.14,0,0,0-.15,0,11.61,11.61,0,0,0-4.89,8.81,3.85,3.85,0,0,0,1.25,3.18.21.21,0,0,0,.17,0,.21.21,0,0,0,.14-.1l3.46-6a.75.75,0,0,0,.1-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M623.15,428.77a.23.23,0,0,0-.2.13l-3.5,6.05a.2.2,0,0,0,0,.15.18.18,0,0,0,.09.1,3.88,3.88,0,0,0,3.42-.52,11.56,11.56,0,0,0,4.74-6.19.11.11,0,0,0,0-.12.16.16,0,0,0-.11-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "634.38 418.72 631.21 420.56 631.21 416.91 634.38 415.08 634.38 418.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "634.38 424.38 631.21 426.21 631.21 422.56 634.38 420.73 634.38 424.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "634.38 429.89 631.21 431.73 631.21 428.08 634.38 426.25 634.38 429.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M618.5,452.73a.28.28,0,0,1-.23-.13.27.27,0,0,1,.1-.36L620.5,451a.25.25,0,0,1,.35.1.26.26,0,0,1-.09.35l-2.13,1.23A.33.33,0,0,1,618.5,452.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M621.88,450.77a.27.27,0,0,1-.22-.13.25.25,0,0,1,.1-.35l6.13-3.54a.26.26,0,0,1,.35.09.26.26,0,0,1-.1.36L622,450.74A.28.28,0,0,1,621.88,450.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M629.22,446.54a.25.25,0,0,1-.22-.13.26.26,0,0,1,.09-.36l3.72-2.14a.26.26,0,1,1,.26.44l-3.72,2.15A.33.33,0,0,1,629.22,446.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M618.5,454.69a.28.28,0,0,1-.23-.13.26.26,0,0,1,.1-.35l4.77-2.76a.26.26,0,0,1,.35.1.26.26,0,0,1-.09.35l-4.77,2.76A.31.31,0,0,1,618.5,454.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M624.52,451.21a.26.26,0,0,1-.13-.48l5.09-2.94a.26.26,0,0,1,.35.1.26.26,0,0,1-.09.35l-5.09,2.94A.28.28,0,0,1,624.52,451.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M630.81,447.58a.26.26,0,0,1-.13-.48l2.13-1.23a.26.26,0,0,1,.35.09.27.27,0,0,1-.09.36l-2.13,1.23A.28.28,0,0,1,630.81,447.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M618.5,450.76a.26.26,0,0,1-.23-.13.26.26,0,0,1,.1-.35l2.86-1.65a.27.27,0,0,1,.36.09.26.26,0,0,1-.1.35l-2.86,1.66A.31.31,0,0,1,618.5,450.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M627.9,445.33a.26.26,0,0,1-.13-.48l1.74-1a.26.26,0,1,1,.26.44l-1.74,1A.28.28,0,0,1,627.9,445.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M622.62,448.38a.23.23,0,0,1-.22-.13.25.25,0,0,1,.09-.35l4.09-2.36a.27.27,0,0,1,.36.09.26.26,0,0,1-.1.35l-4.09,2.37A.31.31,0,0,1,622.62,448.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M630.84,443.63a.25.25,0,0,1-.22-.12.27.27,0,0,1,.09-.36l2.1-1.21a.25.25,0,0,1,.35.1.26.26,0,0,1-.09.35L631,443.6A.28.28,0,0,1,630.84,443.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M618.5,448.8a.28.28,0,0,1-.23-.13.26.26,0,0,1,.1-.35l3.82-2.21a.27.27,0,0,1,.36.09.26.26,0,0,1-.1.35l-3.82,2.21A.22.22,0,0,1,618.5,448.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M623.58,445.86a.26.26,0,0,1-.23-.13.26.26,0,0,1,.1-.35l4.1-2.36a.25.25,0,0,1,.35.09.26.26,0,0,1-.09.35l-4.1,2.37A.31.31,0,0,1,623.58,445.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M628.88,442.8a.24.24,0,0,1-.22-.13.26.26,0,0,1,.09-.35l4.06-2.34a.26.26,0,1,1,.26.44L629,442.77A.28.28,0,0,1,628.88,442.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-249",
    d: "M652.94,547.12s.48,1.63.63,2.23a7.41,7.41,0,0,1-.25,2.09,1.29,1.29,0,0,1-1,1,3.17,3.17,0,0,1-2.49-.45l-6.67-4.5a.85.85,0,0,1-.27-1.09l.18-.33a1.3,1.3,0,0,1,1.48-.66c1.51.38,4.31,1,5.3.76C651.29,545.79,652.94,547.12,652.94,547.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-250",
    d: "M653.14,542.29s0,4.77-.2,5.44-2.35.64-2.93-.79a28.09,28.09,0,0,1-.77-5.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M656.06,491.84l-2.55,20.73a11,11,0,0,0,.51,5.81c.86,2.24.89,6,.94,11a55.44,55.44,0,0,1-1.84,14.94c-1.68,1-2.29.14-3.67-.9,0,0-2.72-32.32-6.61-38.95V493.91l5.18-5.64,5.57-1C655.28,488,655.39,488.59,656.06,491.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-252",
    d: "M645.71,543l.75,3.28,2.64-1.44-.65-3.32S646.14,541,645.71,543Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-253",
    d: "M645.06,553.16s-.64,1.35.33,2,3-.64,4-1.48.62-4.51.94-5.4.9-4,.24-4.5a6.44,6.44,0,0,0-3.15-.52c-.86.07-1.23,1.6-1.23,1.6S646.54,550.2,645.06,553.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-254",
    d: "M635.07,493.08l3.29-10.29,16-.92,1.7,10s-4.88.85-4.87,1.24c.12,3.73-3.32,7.54-6.59,11.35-2.4,2.79-3.54,8.66-4,11.6a3.55,3.55,0,0,0,.89,2.87c5.83,6.63,6.93,22.61,6.93,22.61a2,2,0,0,1-2.74,1.48c-1.52-4.57-10.56-18.52-12.62-25.76S635.07,493.08,635.07,493.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M638.36,482.89s-7.84,20.51-9.22,34.18,8.5,9.79,15.14,8.36c4.78-1,7.69,2.91,13.11.85,4.08-1.55,8.88-1.1,5.68-12.57s-8.71-31.84-8.71-31.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-256",
    d: "M657.18,495.43c-.22-2.13-3.1-37.88-3.54-40.46a5.89,5.89,0,0,0-2.15-3.73c-6.82-1.15-10.32,2.78-10.32,2.78h0a7.35,7.35,0,0,0-2.21,4.45l-3,26.3a1.92,1.92,0,0,0,1.91,2.15s.44.1,1.19.22a1.62,1.62,0,0,1,1.34,1.82s-2.1,5.55,4.62,9.78S657.39,497.56,657.18,495.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-257",
    d: "M646.44,444.71s2.16,4.53,3.31,6.47a1.15,1.15,0,0,1-.21,1.39c-1.27,1.15-1.56,1.18-4.3,1.44a1.27,1.27,0,0,1-1.39-1.1l-.86-6.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-258",
    d: "M640.1,438.64a35.93,35.93,0,0,0-.46,5.1c.14,1.19,1.07,5.12,2.84,5.07s5.43-2.14,6.11-5S646.47,434.81,640.1,438.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M653.65,437.63a1.52,1.52,0,0,1-1.85-1.33c-.15-1.77-1.65-2.85-4.52-3.35-4.93-.86-7.8,1.91-8.34,3.64a3,3,0,0,0,1,3s5.2-.2,5.44,4c.2,3.48,1.26,7.6,5.46,4.68,3.69-2.56,5-1.62,7.19-.23s7.65-2.21,5.7-7.31c-1.2-3.13-3.9-2-5.79-.71a1.47,1.47,0,0,1-2.26-.79C655.43,438.27,654.86,437.41,653.65,437.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-260",
    d: "M632.92,462.31s-5.07,2.39-12.35-6.2c0,0-4-4.6-5.63-5.18a19.09,19.09,0,0,0-1.86-.54,1.72,1.72,0,0,0-2,1c-.53,1.21-1.21,3-.93,3.57.89,1.95,7.63,2.75,7.63,2.75s5.61,9.54,8.68,11.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M643.84,458s-.41-4.75-2.42-4.25-3.79,2.66-6.64,5-3.12,3.23-5.33,3.69c0,0-1,4.7-2.94,6.37A8.1,8.1,0,0,0,631,471C633.49,471.19,643,467,643.84,458Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-262",
    d: "M638.09,468.36a.36.36,0,0,1-.25-.11.32.32,0,0,1,0-.45,20,20,0,0,0,5.17-6.44.33.33,0,0,1,.43-.16.32.32,0,0,1,.15.43,20.41,20.41,0,0,1-5.34,6.65A.32.32,0,0,1,638.09,468.36Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-263",
    cx: 678.41,
    cy: 376.06,
    rx: 7.23,
    ry: 19.91,
    transform: "translate(53.58 835.69) rotate(-65.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M683.57,374s.46,1.52.6,2.08a6.72,6.72,0,0,1-.24,1.95,1.2,1.2,0,0,1-.89.91,2.93,2.93,0,0,1-2.32-.42l-6.22-4.2a.79.79,0,0,1-.26-1l.17-.32a1.22,1.22,0,0,1,1.38-.61c1.41.36,4,.95,5,.71C682,372.8,683.57,374,683.57,374Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M683.77,369.54s0,4.45-.19,5.07-2.2.6-2.74-.74a26.47,26.47,0,0,1-.71-4.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M686.88,325.69l-2.77,16.1a10.2,10.2,0,0,0,.48,5.42c.8,2.09.83,5.56.87,10.24.07,8-1.16,12.09-1.16,12.09a3.84,3.84,0,0,1-4.49,0s-2-29.17-5.66-35.35v-9.82L679,319.1l5.2-.92C685.77,318.88,687.18,324,686.88,325.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-267",
    d: "M667.4,321.31s-4.27,18.07-2.35,24.83,9.81,19.49,11.23,23.76c0,0,3.35.13,3.85-2,0,0-1.77-14-7.21-20.2a3.26,3.26,0,0,1-.83-2.68c.4-2.74,1.46-8.23,3.7-10.83,3.06-3.56,6.27-7.12,6.16-10.6S667.4,321.31,667.4,321.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-268",
    d: "M676.83,370.19l.7,3.06L680,371.9l-.61-3.1S677.23,368.35,676.83,370.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-269",
    d: "M676.23,379.68s-.61,1.26.3,1.86,2.75-.6,3.72-1.38.57-4.21.88-5,.83-3.79.22-4.21a6,6,0,0,0-2.94-.48c-.8.06-1.15,1.5-1.15,1.5S677.61,376.92,676.23,379.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M682.52,288.69s-9.23,1.37-11.33,4.38c-1.75,2.5-2.06,6.92-2.2,8.48s-3.64,15.49-4.44,19.56c-1.07,5.46,9.83,10.23,17.4,8.1s5.07-6.88,5-12.38-.37-18.08.47-21.6C688.41,291,684.76,288,682.52,288.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-271",
    d: "M678.89,281.61s2.36,5,3.63,7.08a1.26,1.26,0,0,1-.24,1.52c-1.39,1.26-1.7,1.3-4.71,1.59a1.41,1.41,0,0,1-1.52-1.21l-.94-7.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M673.72,273.58a38.66,38.66,0,0,0-2.27,5.12c-.29,1.28-.71,5.69,1.13,6.26s6.39-.29,8.11-3S681.69,271.87,673.72,273.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-273",
    d: "M688.12,277.34a1.67,1.67,0,0,1-1.45-2c.48-1.88-.69-3.53-3.49-5.07-4.8-2.64-8.76-.79-9.93.81a3.29,3.29,0,0,0,0,3.47s5.46,1.63,4.2,6.11c-1,3.67-1.38,8.32,4,6.79,4.73-1.35,5.79.09,7.53,2.3s8.7.43,8.49-5.55c-.13-3.67-3.31-3.48-5.74-2.79a1.61,1.61,0,0,1-2.06-1.61C689.74,278.64,689.45,277.54,688.12,277.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M663,296.31l-5.48-6.07a.54.54,0,0,0-.62-.12l-4,1.86v.74l5.69,6.81a.54.54,0,0,0,.66.13l4-2.13v-.63A.89.89,0,0,0,663,296.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-275",
    d: "M658.59,300.3l.35-.89a6.68,6.68,0,0,1-.39-2.17c0-1.17-.57-1.5-1.42-2.55s-1.21,0-.43.92-.84.69-1.1.39l-1.91-2.29a7.76,7.76,0,0,0,0,3.1c.38,1.25,3.3,3.49,3.3,3.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-276",
    d: "M673,292.63a2.62,2.62,0,0,0-2.35,2.75c.09,2.61,0,7.51-2.12,9-2.88,2-9.59-4.94-9.59-4.94l-2,.89s5.46,12.48,12.29,9.81c5.28-2.06,6.6-9.29,6.93-12.47a5.42,5.42,0,0,0-.53-3.07C675,293.24,674.09,292.58,673,292.63Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDevelop);
export default __webpack_public_path__ + "static/media/web-develop.7173a2fd79b85acb7e777f04197e6f97.svg";
export { ForwardRef as ReactComponent };